import jaLocale from 'element-ui/lib/locale/lang/ja'

export default {
  LanguageLib: {
    _THE_SYSTEM_WILL_AUTOMATICALLY_COMPRESS_THE_PICTURE_INTO_2000_STAR_2000_AND_UPLOAD: '画像が自動的に2000*2000に圧縮してからアップロードします',
    ABOUT_PAGE_MAP: 'ウェブページ写真',
    ACCEPT_PICTURE_CONFIGURATION: '写真を承認',
    ACCEPTANCE_REPORT: '検査報告書',
    ACCEPTANCE_SCORE_IS_REQUIRED: 'スコアを確認',
    ACCESSORIES_NAME: 'アクセサリー名',
    ACCESSORY_NAME: '添付ファイル名',
    ACCOUNT: 'アカウント名',
    ExcelTemplate_common_000009: 'アカウント名',
    ACCOUNT_NUMBER: 'アカウント番号',
    ACTIVATION: '活動',
    ACTUAL_SCORE: '実際の得点',
    ADD_A_STORE_CAMERA: '店舗カメラを追加',
    ADD_ASSET_TYPE: '資産タイプを追加',
    ADD_ASSET_TYPE_FAILED: '資産タイプを追加できませんでした',
    ADD_BRAND: '新しいブランドの追加',
    ADD_BRAND_TYPE: 'ブランドタイプを追加',
    ADD_CAMERA_INFORMATION: 'カメラ情報の追加',
    ADD_CATEGORY: '分類を追加する',
    ADD_CATEGORY_NAME_CANNOT_BE_KEYWORDS_FOR_SHOP_PROVINCE_CITY_COUNTRY_ETC: '名称を追加する際、店舗名、省（都道府県）、市、国等のキーワードを使ってはならない',
    ADD_CONTACT: '連絡先を追加',
    ADD_COURSE: 'コースの追加',
    ADD_COURSEWARE: 'レッスンを追加する',
    ADD_DATA_ON_THE_REPORT_SHEET: 'レポートの日付を追加',
    ADD_DATE: '日付の追加',
    ADD_DEALER: 'エージェンシの追加',
    ADD_DEALER_TYPE: 'エージェンシ分類を追加する',
    ADD_DEFECTIVE_PARTS: '不良品を追加',
    ADD_DEFECTIVE_PRODUCT_CLASSIFICATION: '不良品分類を追加',
    ADD_DISTRIBUTOR_CORPORATE: 'ディーラー/法人を追加',
    ADD_EMPLOYEE: '社員の追加',
    ADD_FAILED: '追加できませんでした',
    ADD_FAILED_BUSINESS_START_TIME_CANNOT_BE_LESS_THAN_END_TIME: '追加できませんでした。開始時刻を確認してください',
    ADD_FAILED_DO_NOT_ADD_EXISTING_NONCUSTOM_ORGANIZATION: '追加できませんでした。既に登録のある組織は追加できません',
    ADD_FAILED_NO_CORRECT_ANSWER_EXISTS_IN_OPTIONS: '追加できませんでした。オプション内に正しい解答がありません',
    ADD_FAILED_START_TIME_CANNOT_BE_GREATER_THAN_END_TIME: '追加できませんでした。開始時刻を確認してください',
    ADD_FAILED_START_TIME_CANNOT_BE_LESS_THAN_TODAY: '追加できませんでした。開始時刻を本日以降に設定してください',
    ADD_FAILED_THE_ACCOUNT_IS_NOT_A_SUPPLIER_USER: '追加できませんでした。使用しているアカウントはベンダーアカウントではありません',
    ADD_FAILED_THE_BRAND_ALREADY_EXISTS: '追加できませんでした。ブランドは既に登録があります',
    ADD_FAILED_THE_PHONE_NUMBER_USER_ALREADY_EXISTS: '追加できませんでした。電話番号は既に登録があります',
    ADD_FAILED_THE_SAME_ORGANIZATION_OR_STORE_NAME_ALREADY_EXISTS: '追加できませんでした。組織または店舗は既に登録があります',
    ADD_FAILED_THE_TEMPLATE_NAME_ALREADY_EXISTS: '追加できませんでした。テンプレート名は既に登録があります',
    ADD_FAILED_WITH_AT_LEAST_TWO_OPTIONS_FOR_A_TOPIC: '追加できませんでした。少なくとも2つのオプションを選択してください',
    ADD_FAILED1: '追加できませんでした',
    ADD_FAILED2: '追加できませんでした',
    ADD_FAILED3: '追加できませんでした：',
    ADD_FILE_TYPE: 'ファイルタイプの追加',
    ADD_FOLDER: 'フォルダーの追加',
    ADD_GENERAL_DATA: '通用データの追加',
    ADD_GREETING_RETURN_VISIT_TYPE: '挨拶追跡タイプを追加する',
    ADD_HISTORICAL_EXCHANGE_RATES: '為替レートの履歴追加',
    ADD_ITEM_CATEGORY_SUCCESSFULLY: '道具類別の追加ができました',
    ADD_JOB: '役職の追加',
    ADD_MAINTENANCE_PROBLEM_CLASSIFICATION: 'メンテナンス問題分類を追加する',
    ADD_MAINTENANCE_QUESTION: 'メンテナンス問題を追加する',
    ADD_NEW_LABEL: '新規タグの追加',
    ADD_ORGANIZATION: '組織の追加',
    ADD_ORGANIZATION_NODE_SUCCESSFULLY: '組織節点の追加ができました',
    ADD_ORGANIZATION_TYPE: '組織タイプの追加',
    ADD_PASSENGER_FLOW: '顧客トラフィックの追加',
    ADD_PASSENGER_FLOW_ADJUSTMENTS: 'トラフィック調整の追加',
    ADD_PEOPLE: '職員の追加',
    ADD_PERSON_FAILED: '職員の追加ができませんでした',
    ADD_PERSONNEL_ASSESSMENT_TEMPLATE_QUESTIONS: '社員評価フォーム問題を追加する',
    ADD_PURCHASE_RECORD: '購入記録の追加',
    ADD_PURCHASE_RECORD_FAILED: '購入記録の追加ができませんでした',
    ADD_QUESTION: '問題を追加',
    ADD_QUESTION_BANK_QUESTIONS: 'データベースに試験問題を追加する',
    ADD_REGION: '地域を追加する',
    ADD_RELATIONSHIP: '関係の追加',
    ADD_RETAIL_TOUR_TEMPLATE: '小売店舗チェックフォーム問題分類を追加する',
    ADD_ROLE: '職務の追加',
    ADD_SALES: '売り上げの追加',
    ADD_SALES_DATA: '販売データの追加',
    ADD_SHOP: '店舗の追加',
    ADD_SHOP_EQUIPMENT: '店舗設備の追加',
    ADD_SHOP_TYPE: '店舗タイプを追加',
    ADD_SUPPLIER: '仕入先の追加',
    ADD_TAG: 'タグの追加',
    ADD_TASK_TYPE: 'タスクタイプの追加',
    ADD_TEMPLATE: 'テンプレートの追加',
    ADD_TEST_PAPER: '答案用紙の追加',
    ADD_TEST_QUESTIONS: '試験問題を追加する',
    ADD_TIME: '追加時間',
    ADD_TO: '追加',
    ADD_TO_TEST_PAPER: 'テストの追加',
    ADD_TRANSFER_LABEL: '交替リストのタグを追加する',
    ADD_USER_REFERENCE: 'ユーザー参照を追加する',
    ADD_VENDOR_TYPE: 'ベンダータイプを追加する',
    ADDED_SUCCESSFULLY: '追加できました',
    ADDED_SUCCESSFULLY1: '追加完了',
    ADDING_A_STORE_CAMERA_FAILED: '店舗カメラを追加に失敗しました',
    ADDING_A_STORE_FAILED: '店舗の追加ができませんでした',
    ADDING_ASSETS: '資産の追加',
    ADDING_COMPETITION_CATEGORY_SUCCESSFUL: '競合他社カテゴリの追加',
    ADDING_COMPETITOR_CATEGORY_FAILED: '競合他社カテゴリの追加に失敗しました',
    ADDING_CUSTOM_FIELDS: 'カスタマー文字列を追加する',
    ADDING_CUSTOM_FIELDS_FAILED: 'カスタマー文字列の追加ができませんでした',
    ADDING_DEFECTIVE_PARTS_FAILED: '不良品追加に失敗しました',
    ADDING_DEFECTIVE_PRODUCT_CLASSIFICATION_FAILED: '不良品分類の追加に失敗しました',
    ADDING_FAILED_THE_NUMBER_OF_ORGANIZATIONS_IN_THE_ORGANIZATION_HAS_REACHED_THE_UPPER_LIMIT: '追加できませんでした。組織の登録最大数に達しています',
    ADDING_GENERIC_DATA_FAILED: '通用データの追加ができませんでした',
    ADDING_MAINTENANCE_ISSUES_FAILED: 'メンテナンス問題の追加ができませんでした',
    ADDING_ORGANIZATION_NODE_FAILED: '組織節点の追加ができませんでした',
    ADDING_PASSENGER_FLOW_FAILED: '追加できませんでした',
    ADDING_RETAIL_TOUR_TEMPLATES: '小売店舗チェックフォーム問題を追加する',
    ADDING_STORE_EQUIPMENT_FAILED: '店舗設備の追加ができませんでした',
    ADDING_USER_REFERENCE_FAILED: 'ユーザー参照の追加ができませんでした',
    ADJUSTMENT_COEFFICIENT: '調整係数',
    ADJUSTMENT_INFORMATION: '情報調整',
    ADMINISTRATOR: '管理者',
    AFFILIATES: '会社名',
    AFTER_DELETING_THE_COURSE_ALL_THE_COURSEWARE_IN_THE_COURSE_WILL_BE_DELETED_TOGETHER_PLEASE_CONFIRM_WHETHER_TO_DELETE: 'コースを削除すると、全部レッスン内容が削除されるので、削除しますか？',
    AFTER_THE_PHONE_NUMBER: '電話番号の後に',
    AGE: '年齢',
    AGREEMENT_CONTENT_CANNOT_BE_EMPTY: '契約内容を入力してください',
    AGREEMENT_DOWNLOAD: 'ダウンロード契約',
    AGREEMENT_MUST_BE_SIGNED_AT_LOGIN: 'ログイン中に契約書にサインしてください',
    ALL: '全て',
    ALL_TAGS: '全タグ',
    ALL_UNSAVED_CHANGES_HAVE_BEEN_UNDONE: '保存していない訂正がすでにキャンセルされました。',
    ALLOW_EXPORT_OF_CONTACTS: '連絡先のエクスポート許可',
    ALLOW_MULTIPLE_PEOPLE: '一人以上の人がこの職務に就けます。',
    ALLOWS_MODIFICATION_OF_SCORES_WHEN_ENTRIES_ARE_NOT_UP_TO_STANDARD: '条件を満たしていない場合、点数の修正変更が可能です',
    ALREADY_COPIED_TO_THE_CLIPBOARD: '既にコピーされています',
    ALREADY_HAVE_THE_SAME_AREA_CODE: '同じエリアコードが既に登録されています',
    ALREADY_HAVE_THE_SAME_ORGANIZATION_OR_SHOP_NAME: '同じ組織または店舗が既に登録されています',
    worker_common_000009: '同じ組織または店舗は存在します',
    ALREADY_HAVE_THIS_OPTION: 'この選択肢はすでに存在しています',
    AN_AREA_WITH_THE_SAME_NAME_ALREADY_EXISTS: '同じエリア名が既に登録されています',
    AN_ERROR_OCCURRED: 'エラー発生：',
    AN_ORGANIZATION_WITH_THE_SAME_NAME_ALREADY_EXISTS: '同じ組織が既に登録されています',
    AN_UNKNOWN_ERROR_OCCURRED: '未知エラー発生',
    ANNEX: '添付ファイル',
    ANNIVERSARY: '記念日',
    ANNOUNCER: '発表者',
    ANSWER: '答え',
    ANSWER_CASE: '回答',
    ANSWER_NUMBER: 'ダイヤルイン番号',
    APPLY_FOR_REPAIRS_AND_PROPS: 'メンテナンスと備品の申請提出時の写真設定',
    ARE_YOU_SATISFIED: 'あなたは満足していますか？',
    ARE_YOU_SURE_TO_DISABLE: '無効にしますか？',
    ARE_YOU_SURE_TO_DOWNLOAD_THE_REPAIR_CODE: 'メンテナンスコードをダウンロードしますか？',
    ARE_YOU_SURE_TO_FREEZE: '凍結しますか？',
    ARE_YOU_SURE_TO_GENERATE_A_REPAIR_CODE: 'メンテナンスコードを作成しますか？',
    ARE_YOU_SURE_TO_UNFREEZE: '凍結解除を行ってもいいですか',
    ARE_YOU_SURE_YOU_WANT_TO_ADD_FROM_THE_QUESTION_BANK: '質問を追加しますか？',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT: '本当に削除しますか？',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1: '本当に削除しますか？',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_COURSEWARE: '選択した件名を削除しますか？',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_EXAM: '選択した試験問題を削除しますか',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SELECTED_TEST_PAPER: '選択した試験紙を削除しますか',
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_QUESTION: '質問を削除しますか？',
    ARE_YOU_SURE_YOU_WANT_TO_ENABLE_IT: '有効にしますか？',
    ARE_YOU_SURE_YOU_WANT_TO_RESET_THE_USER_PASSWORD: 'パスワードをリセットしますか',
    ARE_YOU_SURE_YOU_WANT_TO_RESET_THE_USER_PASSWORD1: 'パスワードをリセットしますか？',
    ARE_YOU_SURE_YOU_WANT_TO_SEND_THE_MESSAGE: 'メッセージを送信しますか',
    AREA: '所在地',
    AREA_CODE: '地域番号',
    AREA_INFORMATION: '地域情報',
    AREA_INFORMATION_ADDED: '地域情報を追加する',
    AREA_INFORMATION_UPDATE: '地域情報を更新する',
    AREA_NAME: '地域名',
    AREA1: 'エリア',
    ARTICLE_NUMBER: '品番',
    ASSET_CATALOG: '資産リスト',
    ASSET_CATALOG_SETTINGS: '資産マニュアル設定',
    ASSET_CLASS_INFORMATION: '資産分類詳細',
    ASSET_CONTENT_SETTINGS: '資産明細設定',
    ASSET_INFORMATION: '資産詳細',
    ASSET_NAME: '資産名称',
    ASSET_NUMBER: '資産番号',
    ASSIGN_TASKS_IMMEDIATELY_AFTER_SUBMITTING_REPORT: 'レポート提出後に、タスクを割り当てる',
    ASSOCIATED_USER: '関連ユーザー',
    ATTACHMENT: '添付資料',
    ATTACHMENT_ID_DOES_NOT_EXIST: '添付資料IDを入力してください',
    ATTACHMENT_TYPE: '添付ファイル種類',
    AUTHOR: '作者',
    AUTHORITY: 'アクセル許可',
    AUTHORIZATION_MANAGEMENT: '認可された管理',
    AUTOAPPROVED_CATEGORIES_MUST_SELECT_THE_DEFAULT_VENDOR: '自動承認カテゴリのデフォルトベンダーを選択してください',
    AUTOMATIC_APPROVAL: '自動承認',
    AVERAGE_NUMBER_OF_TRANSACTIONS: '平均販売数量',
    AVERAGE_PASSENGER_FLOW: '平均客数',
    AVERAGE_SALES: '平均売上',
    AVERAGE_TRANSACTION_AMOUNT: '平均取引金額',
    BACKUP_PHONE: 'その他の電話番号',
    BAIDU_MAP_API_CUSTOM_MAPS_TO_HELP_USERS_GENERATE_BAIDU_MAPS_UNDER_VISUAL_OPERATION: 'バイドゥマップAPIからマップをカスタマイズし、ユーザーがバイドゥマップの生成を視覚化できるようにします',
    BAIDU_MAP_BAIDU_MAP_API_BAIDU_MAP_CUSTOMIZATION_TOOL_BAIDU_MAP_WYSIWYG_TOOL: 'Baiduマップ、BaiduマップAPI、Baiduマップカスタマイズツール、Baiduマップ利用可能なすべてのツール',
    BASE_FIELD: '基本フィールド',
    BASIC_CONFIGURATION: '基本設定',
    BASIC_DATA_IMPORT: '基本情報インポート',
    BASIC_INFORMATION: '基本情報',
    BASIC_SETTINGS: '基本設定',
    BATCH_DOWNLOAD: 'ダウンロード',
    BATCH_TAG: 'バッチ設定',
    BEGINNING_NUMBER: '期首殘高',
    BEGINNING_TIME: '期首',
    BIND_MAILBOX: '指定Eメールアドレス',
    BIND_PHONE_NUMBER: '携帯番号を関連しましょう',
    BINDING_RELATIONSHIP: '指定の関係',
    BIRTH_DAY: '生年月日',
    BIRTHDAY: '誕生日',
    ExcelTemplate_common_000018: '生年月日',
    BIT: 'Bit',
    BRAND: '所属ブランド',
    BRAND_ADDITION: 'ブランド追加',
    BRAND_CATEGORIES_IN_USE_CANNOT_BE_DELETED: 'ブランドカテゴリーは使用されているので、削除できません',
    BRAND_CATEGORIES_IN_USE_CANNOT_BE_DELETED1: 'ブランドカテゴリーは使用されているので、削除できません',
    BRAND_CATEGORY: 'ブランド類別',
    BRAND_CATEGORY_DOES_NOT_EXIST: 'ブランドカテゴリーの登録がありません',
    BRAND_CATEGORY1: 'ブランド分類',
    BRAND_CUSTOMERS: 'ブランド得意先',
    BRAND_DATA_IMPORT: 'ブランドデータのインポート',
    BRAND_DATA_TEMPLATE: 'ブランドデータテンプレート',
    BRAND_INFORMATION: 'ブランド情報',
    BRAND_INTRODUCTION: 'ブランド紹介',
    BRAND_NAME: 'ブランド名',
    BRAND_REMOVAL_FAILED: 'ブランド名の削除ができませんでした',
    BRAND_SETTINGS: 'ブランド設定',
    BRAND_TYPE: 'ブランドタイプ',
    BRAND_TYPE_DOES_NOT_EXIST: 'ブランドタイプの登録がありません',
    BRAND_TYPE_INFORMATION: 'ブランド対応情報',
    BRAND_TYPE_NAME: 'ブランドタイプ名',
    BRAND_TYPE_NUMBER: 'ブランドタイプ番号',
    BRAND_UPDATE: 'ブランドの更新',
    BROADCAST: 'ラジオ',
    BUILD_FAILED: '作成に失敗しました',
    BUILD_FAILED1: '作成に失敗しました：',
    BUILD_TIME: '作成日時',
    BULK_ENABLE: 'バッチ有効',
    BUSINESS_HOURS: '営業時間',
    BY: '通過',
    BY_SERIAL_NUMBER: 'シリアル番号',
    BY_UPDATE_TIME: '更新日時',
    CALL_DURATION: '通話時間',
    CAMERA_ADDRESS: 'カメラアドレス',
    CAMERA_INFORMATION: 'カメラ情報',
    CAMERA_INFORMATION_ADDED: 'カメラ情報の追加',
    CAMERA_INFORMATION_UPDATE: 'カメラ情報の更新',
    CAMERA_NAME: 'カメラ名',
    CAN_NOT_BE_EMPTY: '空白にしてはならない',
    CAN_NOT_BE_EMPTY1: '入力してください',
    CANCEL: 'キャンセル',
    CANNOT_BE_DELETED: '削除不可',
    CANNOT_EDIT_CURRENCY_NAME: '通貨名の変更は出来ません',
    CATEGORIES: '商品カテゴリ',
    CATEGORY: '所属分類',
    CATEGORY_CODE: '分類番号',
    CATEGORY_DESCRIPTION: '分類記述',
    CATEGORY_DETAILS: '分類詳細',
    CATEGORY_INFORMATION: '分類データ',
    CATEGORY_NAME: '分類名',
    CATEGORY_NUMBER: '分類番号',
    CATEGORY_NUMBER1: '分類番号',
    CATEGORY_UNIQUE_ID_CANNOT_BE_EMPTY: 'カテゴリIDを選択してください',
    CATEGORY1: '分類',
    CC: 'CC',
    CHANGE_PASSWORD_AT_FIRST_LOGIN: '初回ログイン時にパスワードの変更をしてください',
    CHANNEL_DESCRIPTION: '通路説明',
    CHANNEL_DESCRIPTION_CANNOT_EXCEED_1000_WORDS: '通路説明は1000文字以内にしてください',
    CHANNEL_LIST: '通路リスト',
    CHANNEL_NAME: '通路名',
    CHANNEL_NUMBER: '通路ナンバー',
    CHANNEL_NUMBERS_CANNOT_BE_DUPLICATED: 'チャンネル番号が重複しています',
    CHANNEL_TYPE: '通路タイプ',
    CHARACTER_LENGTH_EXCEEDS: '文字数オーバー',
    CHARACTER_LENGTH_EXCEEDS_THE_LIMIT: '制限以内の文字数',
    CHECK_BRAND: 'ブランド検索',
    CHECK_IN_TIME: 'ログイン時間',
    CHECK_THE_PROMPT_FILE: 'ファイルを確認してください',
    CHECKED_FIELDS_ARE_SHOWN_UNCHECKED_ARE_HIDDEN_FIELDS: 'チェックされたフィールドは表示され、チェックされていないフィールドは非表示フィールドです',
    CHILDREN_S_SITUATION: 'お子様の場合',
    CHINESE_SIMPLIFIED: '日本語 （已校正）',
    CHOICE_1: '選択肢1',
    CHOICE_2: '選択肢2',
    CHOICE_3: '選択肢3',
    CHOICE_4: '選択肢4',
    CHOICE_5: '選択肢5',
    CHOOSE_A_STORE: '店舗の選択',
    CHOOSE_FROM_A_QUESTION_BANK: 'データベースから選択してください',
    CLASSIFICATION: '分類',
    CLASSIFICATION_NAME: '分類名',
    CLASSIFICATION_RENAME: '分類の名前変更',
    CLEAR: '晴れ',
    CLIENT: 'カスタマー名',
    CLIENTS_NAME: 'カスタマー名',
    CODE_REFRESH: 'コードの更新',
    CODING: '番号',
    CODING_CANNOT_BE_REPEATED: 'コーディングを繰り返すことはできません',
    COLLAPSE: '閉じる',
    PUT_AWAY: '閉じる',
    COMMENT: 'コメント',
    COMMENT_BY: 'コメント者',
    COMMENT_TIME: 'コメント時間',
    COMMODITY_CATEGORY: '商品カテゴリ',
    COMMODITY_ORGANIZATION_RELATIONSHIP: '商品組織の関係',
    COMMODITY_SMALL_CLASS: '商品小カテゴリ',
    COMPANY_ADD: '会社を追加',
    COMPANY_ADDRESS: '会社の住所',
    COMPANY_CONFIGURATION: '会社の設定',
    COMPANY_DEFAULT_LANGUAGE_CANNOT_BE_EMPTY: '会社のデフォルト言語は空にできません',
    COMPANY_DESCRIPTION: '会社概要',
    COMPANY_DETAILS: '会社の詳細',
    COMPANY_EMAIL: '会社のメール',
    COMPANY_HOMEPAGE_MAP: '会社ホームページ写真',
    COMPANY_INFORMATION: '企業情報',
    COMPANY_NAME: '会社名',
    COMPANY_NUMBER: '会社番号',
    COMPANY_PHONE: '会社の電話番号',
    COMPETING_PICTURE: '競合製品の写真',
    COMPETITION_CATEGORY: '競合製品カテゴリ',
    COMPETITION_CATEGORY_IMPORT: '競合する製品カテゴリのインポート',
    COMPETITION_INFORMATION: '競合製品情報',
    COMPETITION_INFORMATION_IMPORT: '競合する製品情報のインポート',
    COMPETITION_NUMBER: '競合製品番号',
    COMPETITIVE_DATA_IMPORT: '競合する製品データのインポート',
    COMPETITIVE_NAME: '競合製品名',
    COMPETITIVE_PRODUCT_CLASSIFICATION_INFORMATION: '競合する製品分類情報',
    COMPETITIVE_STATUS: '競合製品のステータス',
    COMPLETE_TIME: '完成時間',
    COMPLETED: '完成済み',
    COMPLETION_REPORT_CONFIRMATION_TIME: 'レポート完了のタイミングを確認する',
    COMPLIANCE_SCORE: '達成得点',
    CONFIGURATION_ENTRY: '配置条目',
    CONFIRM: '確認',
    CONFIRM_SYNCHRONIZATION_EASY_TO_KNOW_USER_DATA: '既知のユーザーデータを同期することを確認します',
    CONTACT_ADDRESS: 'オフィス住所',
    CONTACT_DETAILS: '連絡方法',
    ExcelTemplate_common_000021: '連絡方法',
    CONTACT_INFORMATION: '連絡先',
    CONTACT_NAME: '連絡先',
    CONTACT_NUMBER: '電話番号',
    CONTACT_NUMBER1: '連絡先電話番号',
    CONTACT_PERSON: '連絡先',
    CONTACT_SETTINGS: '接点設定',
    CONTACT_US: 'お問い合わせ',
    CONTENT: '内容',
    CONTENT1: 'コンテンツ：',
    CONTROL_EDITING: '制御データ編集',
    CONVERSION_RATE: '転換率',
    COPIED_TO_CLIPBOARD: 'クリップボードにコピー：',
    COPIED_TO_CLIPBOARD1: 'クリップボードにコピーしました',
    COPY: 'コピー',
    COPY_TO_CLIPBOARD_FAILED: 'クリップボードへのコピーに失敗しました',
    CORRECTION_REPORT: '改善報告書',
    COURSE_CREATOR: 'コース作成者',
    COURSE_DETAILS: 'コース詳細',
    COURSE_INFORMATION: 'コース情報',
    COURSE_MANAGEMENT: 'コース管理',
    COURSE_MODIFICATION_TIME: 'コースの変更時間',
    COURSE_NO: 'コース番号',
    COURSE_NOTES: 'コースの備考',
    COURSE_NUMBER: 'コースナンバー',
    COURSE_PICTURES: 'コースの写真',
    COURSE_TITLE: 'コース名',
    COURSE_TYPE: 'コースのタイプ',
    COURSEWARE_ADDED_SUCCESSFULLY: 'コースウェアが正常に追加されました',
    COURSEWARE_ADDITION_FAILED: 'コースウェアを追加できませんでした',
    COURSEWARE_CODING: 'レッスン番号',
    COURSEWARE_CREATOR: 'レッスン作成者',
    COURSEWARE_DETAILS: 'レッスン詳細',
    COURSEWARE_HOME: 'レッスンのホームページ',
    COURSEWARE_INFORMATION: 'レッスン情報',
    COURSEWARE_MODIFICATION_FAILED: 'レッスンの修正ができませんでした',
    COURSEWARE_MODIFIED_SUCCESSFULLY: 'レッスンの修正ができました',
    COURSEWARE_NAME: 'レッスン名',
    COURSEWARE_NOTES: 'レッスンの備考',
    COURSEWARE_NUMBER: 'レッスン番号',
    COURSEWARE_PICTURE: 'レッスン画像',
    COURSEWARE_SERIAL_NUMBER: 'コースウェアのシリアル番号',
    COURSEWARE_UPLOAD: 'レッスンのアップロード',
    CREATE_DATA: 'データ作成',
    CREATION_DATE: '日付を作成する',
    CREATION_TIME: '作成時間',
    CREATOR: '作成者',
    CROP: '切り抜き',
    CURRENCY: '通貨',
    CURRENCY_NAME: '通貨名',
    CURRENCY_SETTING: '通貨設定',
    CURRENCY_TYPE_DOES_NOT_EXIST: '通貨タイプが存在しません',
    CURRENCY_TYPE_IS_NOT_ACTIVATED: '通貨タイプは有効化されていません。',
    CURRENT_EXCHANGE_RATE_SETTINGS: '現在の為替レート設定',
    CUSTOM_FIELD: 'カスタマイズ文字列',
    CUSTOM_FIELD_DOES_NOT_EXIST_IN_EXCEL: 'エクセルにはカスタマイズ文字列が見つかりませんでした',
    CUSTOM_FIELD_INFORMATION: 'カスタマー文字列データ',
    CUSTOMER_DATA_IMPORT: '顧客データの入力',
    CUSTOMER_DATA_TEMPLATE: '顧客情報テンプレート',
    CUSTOMER_INFORMATION: 'カスタマー情報',
    CUSTOMER_LIST: 'カスタマーリスト',
    CUSTOMER_MANAGEMENT: '顧客管理',
    CUSTOMER_NAME: '顧客名',
    CUSTOMER_NICKNAME: 'カスタマー別称',
    CUSTOMER_S_NAME: '顧客名',
    DAILY_PRODUCTS: '1日あたり販売数',
    DAILY_SALES: '1日あたり売上高',
    DAILY_TRAFFIC: '顧客トラフィックの数',
    DATA_CLASSIFICATION: 'データ分類',
    DATA_ENCODING: 'データエンコード',
    DATA_ID: 'データID',
    DATA_IS_INCORRECT_PLEASE_VERIFY: 'データにエラーが生じていますので、校正してください',
    DATA_NAME: 'データ名',
    DATA_PROCESSING_IS_COMPLETE: 'データ処理が完了しました！',
    DATA_REPORTING: 'データ報告',
    m_info_common_000036: 'データレポート',
    DATA_REPORTING_MANAGEMENT: 'データ報告管理',
    DATA_STEWARD: 'データ管理者',
    DATA_TEMPLATE_MANAGEMENT: 'データフォーム管理',
    DATA_TOP_COLLATION: 'データを先頭に並べ替える',
    DATA_TYPE_CONVERSION_FAILED_IT_SHOULD_BE_DATE_TYPE: 'データへの変換に失敗しました。日付形式である必要があります',
    DATA_TYPE_CONVERSION_FAILED_IT_SHOULD_BE_NUMERIC: 'データへの変換に失敗しました。数値形式である必要があります',
    DATE: '日付',
    DATE_RANGE: '入力できる時間帯',
    DAY: '日',
    DEALER__CORPORATE_MANAGEMENT: 'ディーラー/法人管理',
    DEALER_ADDED: 'エージェンシの追加',
    DEALER_CORPORATE: 'ディーラー/法人',
    DEALER_CORPORATE_INFORMATION: 'ディーラー/法人情報',
    DEALER_DATA_IMPORT: 'ディーラーデータの入力',
    DEALER_LEGAL_NAME: 'ディーラー/法人名',
    DEALER_TYPE: 'エージェンシ分類',
    DEALER_TYPE_INFORMATION: 'エージェンシ分類詳細',
    DEALER_UPDATE: 'エージェンシの更新',
    DECIMAL_PLACES: '小数位のまま',
    DECIMALS: '小数のまま',
    DECORATION_MAINTENANCE: '装飾/メンテナンス',
    DECORATION_PERIOD: '装飾可能時間',
    DEFAULT_LANGUAGE: '既定の言語',
    DEFAULT_PASSWORD_FORMAT: 'デフォルトのパスワード形式',
    DEFAULT_PRIORITY: 'デフォルトの優先度',
    DEFAULT_VENDOR: 'デフォルトのベンダー',
    DEFECTIVE_PARTS: '欠陥部分',
    DEFECTIVE_PARTS1: '不良品',
    DEFECTIVE_PRODUCT: '欠陥のある問題',
    DEFECTIVE_REPAIR: '欠陥修理',
    m_info_common_000007: '欠陥修理',
    DELETE: '削除',
    DELETE_A_STAFF_ASSESSMENT_TEMPLATE: '社員評価フォームを削除する',
    DELETE_ASSET: '資産を削除',
    DELETE_ASSET_TYPE: '資産タイプを削除',
    DELETE_CATEGORY: 'カテゴリーを削除',
    DELETE_COMMON_DATA: '通用データの削除',
    DELETE_COURSE: 'コースを削除する',
    DELETE_COURSEWARE: 'レッスンを削除する',
    DELETE_CUSTOM_FIELDS: 'カスタマー文字列を削除する',
    DELETE_CUSTOMER: '取引先を削除する',
    DELETE_CUSTOMER_FAILED: '取引先の削除ができませんでした',
    DELETE_DOCUMENT: 'ファイルの削除',
    DELETE_EXAM_RECORD: '試験記録の削除',
    DELETE_FAILED_THERE_ARE_CHILD_NODES_UNDER_THE_DELETE_NODE: '削除できませんでした。子の下の子ノードを削除してください',
    DELETE_FILE_TYPE: 'ファイルタイプを削除',
    DELETE_GREETING_RETURN_VISIT_TYPE: 'グリーティングの再訪タイプを削除',
    DELETE_JOB: '役職の削除',
    DELETE_JOB_SHOP_TEMPLATE: 'デューティストアテンプレートを削除',
    DELETE_MAINTENANCE_PROBLEM_CLASSIFICATION: 'メンテナンス問題分類を削除する',
    DELETE_ORGANIZATION: '組織を削除する',
    DELETE_ORGANIZATION_TYPE: '組織タイプを削除',
    DELETE_PASSENGER_FLOW: '客数の削除',
    DELETE_PERSON: '職人の削除',
    DELETE_PURCHASE_HISTORY: '購入記録の削除',
    DELETE_QUESTION: '試験問題を削除する',
    DELETE_QUESTION_BANK: 'データベースを削除する',
    DELETE_QUESTION_BANK_QUESTIONS: '質問バンクの質問を削除する',
    DELETE_QUESTION2: '質問バンクの質問を削除する',
    DELETE_QUESTION1: '問題の削除',
    DELETE_RECORD: '記録の削除',
    DELETE_REGION: '地域を削除する',
    DELETE_REPORT_FIELD_ON_DATA: 'データ報告リストの文字列を削除する',
    DELETE_ROLE: '職務の削除',
    DELETE_SALES_DATA: '販売データの削除',
    DELETE_STORE: '店舗の削除',
    DELETE_STORE_ATTACHMENTS: '店舗の添付ファイルの削除',
    DELETE_STORE_CAMERA: '店舗カメラの削除',
    DELETE_STORE_TYPE: '店舗タイプを削除する',
    DELETE_TASK_TYPE: 'タスクタイプを削除',
    DELETE_TEMPLATE: 'テンプレートの削除',
    DELETE_TEST_PAPER: '答案用紙の削除',
    DELETE_THE_REPORT_ON_THE_DATA: 'データ報告リストを削除する',
    DELETE_THIS_CATEGORY: '交替リストの分類を削除する',
    DELETE_THIS_FAILED_POST: '交替リストの投稿削除ができませんでした',
    DELETE_THIS_POST: '交替リストの投稿を削除する',
    DELETE_TRAINING_MATERIALS: 'トレーニングデータを削除する',
    DELETE_TRANSFER_BOOK: '交替リストを削除する',
    DELETE_USER_REFERENCE: 'ユーザー参照を削除する',
    DELETE_VISUAL_DISPLAY_ITEM_DETAILS: 'ビジュアル陳列項目明細の削除',
    DELETE_VISUAL_DISPLAY_ITEMS: 'ビジュアル陳列項目の削除',
    DELETION_FAILED_BECAUSE_A_ROLE_IN_THIS_ROLE_IS_ALREADY_USED: '削除に失敗しました。この役割は役職に就いています',
    DELETION_FAILED_DELETE_TYPE_ALREADY_USED_IN_TYPE: '削除できませんでした。削除タイプが使用されています。',
    DELETION_FAILED_ITEM_WITH_CHILD_MEMBERS_IN_OPTION: 'この選択に存在する子メンバーを削除できませんでした。',
    DELETION_FAILED_ITEMS_USED_IN_ASSET_CONFIGURATION_SETTINGS_EXIST_IN_OPTIONS: '削除に失敗しました。この資産構成設定は使用中です。',
    DELETION_FAILED_ITEMS_USED_IN_ITEM_INFORMATION_MANAGEMENT_EXIST_IN_OPTIONS: '削除に失敗しました。アイテム情報管理で使用されるアイテムはオプションに存在します',
    DELETION_FAILED_SOMEONE_IN_THE_POST: '削除に失敗しました。この位置は使用中です。',
    DELETION_FAILED_SOMEONE_IS_ALREADY_SERVING: '削除に失敗しました。スタッフがこの投稿を保持しています。',
    DELETION_FAILED_THE_ASSET_NAME_USED_IN_THE_STORE_EXISTS_IN_THE_SELECTION: '削除に失敗しました。選択したアセット名はストアで使用されています。',
    DELETION_FAILED_WITH_ITEMS_USED_IN_MAINTENANCE_INFORMATION_MANAGEMENT_IN_OPTIONS: '削除に失敗しました。選択した保守情報管理が使用中です。',
    DELETION_FAILED_YOU_CANNOT_DELETE_THE_ADJUSTMENT_FACTOR_LESS_THAN_OR_EQUAL_TO_TODAY: '削除に失敗しました。今日以下の調整係数は削除できません',
    DELETION_OF_PERSONNEL_ASSESSMENT_TEMPLATE: '社員評価フォーム問題を削除する',
    DESCRIPTION: '説明',
    DESCRIPTION1: '説明',
    DETAILS: '詳細',
    DETAILS_AND_COMMENTS: '詳細とコメント',
    DETERMINE: '確定',
    DEVIATION: '偏差値',
    DEVICE_CODE: '設備ナンバー',
    DEVICE_DESCRIPTION: '設備説明',
    DEVICE_MAC_ADDRESS: 'デバイスのMACアドレス',
    DEVICE_NAME: '設備名',
    DIRECTORY: '所属ディレクトリ',
    DISABLE: '無効にする',
    DISCOUNT_FACTOR: '割引率',
    DISPLAY_BROCHURE: '陳列マニュアル',
    DISPLAY_BROCHURE_CONFIGURATION_TEMPLATE: '陳列配置マニュアルテンプレート',
    DISPLAY_BROCHURE_TEMPLATE: '陳列マニュアルテンプレート',
    DISPLAY_ELEMENT: 'ディスプレイ要素',
    DISPLAY_ITEM_NAME: '項目名',
    DISPLAY_PROPS: '小道具を表示する',
    DISPLAY_THEME: '陳列のテーマ',
    DOCUMENT: '資料',
    DOCUMENT_LIST: 'ドキュメントリスト',
    DOCUMENT_NUMBER: 'ドキュメント番号',
    DOCUMENT_TYPE: 'ドキュメントタイプ',
    DOWNLOAD_COMPETITIVE_INFORMATION_TEMPLATE: '競合製品情報テンプレートをダウンロードする',
    DOWNLOAD_COMPETITIVE_PRODUCT_CLASSIFICATION_TEMPLATE: '競合製品の分類テンプレートをダウンロードする',
    DOWNLOAD_ENTERPRISE_REPAIR_CODE: 'エンタープライズ修復コードをダウンロードする',
    DOWNLOAD_FAILED: 'ダウンロードに失敗しました',
    DOWNLOAD_FEEDBACK_FORM: 'フィードバックファイルのダウンロード',
    DOWNLOAD_IMPORT_TEMPLATE: 'インポートしたテンプレートをダウンロードする',
    DOWNLOAD_INVENTORY_TEMPLATE: '在庫フォームをダウンロードする',
    DOWNLOAD_LINK: 'ダウンロードリンク',
    DOWNLOAD_PRODUCT_CLASSIFICATION_TEMPLATE: '製品分類テンプレートをダウンロードする',
    DOWNLOAD_PRODUCT_INFORMATION_TEMPLATE: '製品情報テンプレートをダウンロードする',
    DOWNLOAD_PROP_CLASSIFICATION_TEMPLATE: '道具分類フォームをダウンロードする',
    DOWNLOAD_PROP_TEMPLATE: '道具フォームをダウンロードする',
    DOWNLOAD_REPAIR_CLASSIFICATION_TEMPLATE: 'メンテナンス分類フォームをダウンロードする',
    DOWNLOAD_REPAIR_FAILURE_TEMPLATE: 'メンテナンス故障フォームをダウンロードする',
    DOWNLOAD_SHOP_REPAIR_CODE: '店舗保守コードをダウンロードする',
    DOWNLOAD_STORE_PROPS_TEMPLATE: '店舗道具フォームをダウンロードする',
    DOWNLOAD_SUCCESSFUL: 'ダウンロード成功',
    DOWNLOAD_TEMPLATE: 'フォームをダウンロードする',
    DROP_DOWN_BOX_FOR_ALL_OPTIONAL_LABELS: '利用可能なすべてのラベルのドロップダウン',
    DUPLICATE_CATEGORY_NAMES_IN_EXCEL_ARE_DUPLICATED: 'Excelで競合製品カテゴリ名が重複しています',
    DUPLICATE_NAMES: '重複した名前',
    DUPLICATE_ORGANIZATION_NAMES_IN_EXCEL: 'Excelで重複する組織名',
    worker_common_000008: '組織名が重複しています',
    DUPLICATE_PRODUCT_NAME: '製品名が重複しています',
    DUPLICATE_PRODUCT_NAMES_IN_EXCEL: 'Excelで製品名が重複しています',
    DUPLICATE_THE_SAME_SHOP_NAME_IN_EXCEL: 'Excelでストア名が重複しています',
    DUPLICATE_THE_SAME_SHOP_NUMBER_IN_EXCEL: 'Excelで店舗番号が重複しています',
    DUPLICATE_USER_PHONE_NUMBER_IN_EXCEL: 'Excelでユーザーの電話番号が重複しています',
    DUPLICATION_OF_GOODS_UNDER_THE_ORGANIZATION: '組織内の重複する製品',
    EASY_KNOW_CODE: 'わかりやすいコード',
    EASY_TO_KNOW_CONFIGURATION: 'わかりやすい構成',
    EASY_TO_KNOW_URL: 'わかりやすいURL',
    EASY_TO_KNOW_WEBSITE_CODE: 'Easy to know website code',
    EDIT_BRAND: 'ブランド名の訂正',
    EDIT_BRAND_TYPE: 'ブランドタイプを修正する',
    EDIT_DETAILS: '編集詳細',
    EDIT_FAILED_THE_SAME_ORGANIZATION_OR_SHOP_NAME_ALREADY_EXISTS: '変更に失敗しました。同じ組織名またはストア名が存在します。',
    EDIT_POSITION: '職位の改定',
    EDIT_POST_FAILED: '職位の修正ができませんでした',
    EDIT_REGION: '地域を修正する',
    EDIT_SHOP: '店舗の訂正',
    EDITING_OPTIONS: 'オプションの編集',
    EDITING_TAGS: 'タグを変更',
    EFFECTIVE: '効果的',
    EFFECTIVE_DATE: '有効期間',
    EMPLOYEE_SUPERIOR: '管理職',
    EMPTY_ORGANIZATION_SHOP: '空の組織ストア',
    ENABLE: '有効にする',
    ENCODING_CANNOT_BE_EMPTY: 'コードを必ず入れてください',
    END_DATE: '終了日',
    END_DATE_CANNOT_BE_LESS_THAN_START_DATE: '終了時間は開始時間以降にしなければならない',
    END_TIME: '期末',
    END_TIME1: '終了時間',
    ENDING_NUMBER: '期末数',
    ENGINEERING_MANAGEMENT: 'プロジェクト管理者',
    m_info_common_000018: 'プロジェクト管理者',
    ENGLISH: '英語',
    ENGLISH_NAME: '英名',
    ENTER_1: '1を入力',
    ENTER_2: '2を入力',
    ENTER_3: '3を入力',
    ENTER_4: '4を入力',
    ENTER_5: '5を入力',
    ENTERPRISE: '企業',
    ENTERPRISE_ANNOUNCEMENT: 'エンタープライズ発表',
    ENTERPRISE_REPAIR_CODE_GENERATION_FAILED: 'エンタープライズメンテナンスコードの生成に失敗しました',
    ENTERPRISE_SHARING: 'エンタープライズ共有',
    m_info_common_000035: 'エンタープライズ共有',
    ENTRIES_FAIL_TO_SUBMIT_QUESTIONS: '失敗したエントリは質問を送信する必要があります',
    ENTRY_CATEGORY_CANNOT_BE_EMPTY: 'エントリカテゴリは空にできません',
    ENTRY_NAME: '条目名称',
    ENTRY_NAME_CANNOT_BE_EMPTY: 'エントリ名は空にできません',
    ENTRY_NUMBER: '項目番号',
    EQUIPMENT_MODEL: '機器モデル',
    EQUIPMENT_QUANTITY: '設備数量',
    EQUIPMENT_TYPE: '設備タイプ',
    ERROR_WRITING_FILE_TO_HARD_DISK: 'ハードディスクへのファイル書き込みエラー',
    EXAM_ID: '試験ID',
    EXAM_ID1: '試験紙ID',
    EXAM_INFORMATION: '試験情報',
    EXAM_LIST: '試験のリスト',
    EXAM_NOTES: '答案用紙の注',
    EXAM_NOTES1: '試験通報',
    EXAMINATION_TIME: '試験時間',
    EXAMINER: '試験スタッフ',
    EXCEED: '超過する',
    EXCEEDS_THE_SIZE_ALLOWED_BY_THE_FORM: 'フォームのサイズ制限を超えました',
    EXCEL_EXPORT: 'Excelをエクスポート',
    EXCEPT_FOR_ARCHIVED_DATA_OTHER_DATA_HAS_BEEN_DELETED_NORMALLY: 'ファイリング済みデータ以外のデータは、全部削除済み',
    EXCHANGE_RATE_MANAGEMENT: '為替レート管理',
    EXCHANGE_RATE_SETTING: '為替レート設定',
    EXPAND: '開く',
    EXPIRATION_DATE: '有効期間',
    ExcelTemplate_common_000019: '有効期間',
    EXPLANATION_OR_NOTE: '説明または備考',
    EXPORT_COMPETING_CATEGORIES: '競合する製品カテゴリをエクスポートする',
    EXPORT_COMPETITION: '競合製品の輸出',
    EXPORT_DATA: '選定済みデータをアウトポートする',
    EXPORT_DATA_UNDER_THE_CURRENT_QUERY_CONDITIONS: '今の検索データをアウトポートする',
    EXPORT_DISPLAY_BROCHURE: '冊子のエクスポート',
    EXPORT_EXCEL: 'Excelのエクスポート',
    EXPORT_FAILED: 'エクスポートに失敗しました！',
    EXPORT_INSPECTION_TOUR: '検査チェックリストのエクスポート',
    EXPORT_MULTIPLE_LANGUAGES: '複数の言語をエクスポートする',
    EXPORT_PEOPLE_EXCEL: '社員名簿エクセルをエクスポートする',
    EXPORT_PREVIEW: 'アウトポートプレビュー',
    EXPORT_PRODUCT: '製品を輸出する',
    EXPORT_PRODUCT_CATEGORIES: '製品分類のエクスポート',
    EXPORT_PROP_CLASSIFICATION: '小道具の分類をエクスポート',
    EXPORT_PROPS: '道具をアウトポートする',
    EXPORT_RETAIL_TOUR: '輸出小売店',
    EXPORT_STAFF_TO_EXCEL: '社員任職情報エクセルをエクスポートする',
    EXTENDED_FIELD_01: '広範文字列01',
    EXTENDED_FIELD_02: '広範文字列02',
    EXTENDED_FIELD_03: '広範文字列03',
    EXTENDED_FIELD_04: '広範文字列04',
    EXTENDED_FIELD_05: '広範文字列05',
    EXTENDED_FIELD_06: '広範文字列06',
    EXTENDED_FIELD_07: '広範文字列07',
    EXTENDED_FIELD_08: '広範文字列08',
    EXTENDED_FIELD_09: '広範文字列09',
    EXTENDED_FIELD_10: '広範文字列10',
    EXTENDED_FIELD_11: '広範文字列11',
    EXTENDED_FIELD_12: '広範文字列12',
    EXTENDED_FIELD_13: '広範文字列13',
    EXTENDED_FIELD_14: '広範文字列14',
    EXTENDED_FIELD_15: '広範文字列15',
    EXTENDED_FIELD_16: '広範文字列16',
    EXTENDED_FIELD_17: '広範文字列17',
    EXTENDED_FIELD_18: '広範文字列18',
    EXTENDED_FIELD_19: '広範文字列19',
    EXTENDED_FIELD_20: '広範文字列20',
    FAIL_TO_EDIT: '修正できませんでした',
    FAIL_TO_EDIT1: '変更に失敗する',
    FAIL_TO_EDIT2: '変更に失敗する',
    FAILED_THE_TEMPLATE_NAME_ALREADY_EXISTS: '失敗：テンプレート名は既に存在します',
    FAILED_TO_ADD_A_QUESTION_BANK_QUESTION: 'データベースに試験問題の追加ができませんでした',
    FAILED_TO_ADD_BRAND_TYPE: 'ブランドタイプを追加できませんでした',
    FAILED_TO_ADD_ITEM_CATEGORY: '道具類別の追加ができませんでした',
    FAILED_TO_ADD_JOB: '職位の追加ができませんでした',
    FAILED_TO_ADD_ORGANIZATION_LEVEL_HAS_REACHED_THE_UPPER_LIMIT: '追加できませんでした、組織レベルが上限に達しました',
    FAILED_TO_ADD_OTHER_ADJUSTMENT_FACTORS_EXIST_IN_THE_STARTTOEND_TIME_PERIOD: '追加に失敗しました。開始時刻と終了時刻の間に他の調整係数が存在します',
    FAILED_TO_ADD_PRODUCT_CATEGORY: '製品カテゴリを追加できませんでした',
    FAILED_TO_ADD_REGION: '地域の追加ができませんでした',
    FAILED_TO_ADD_ROLE: 'ロールの追加ができませんでした',
    FAILED_TO_ADD_ROLE1: '役割を追加できませんでした',
    FAILED_TO_ADD_SALES_DATA: '販売データの追加ができませんでした',
    FAILED_TO_ADD_STORE_TYPE: '店舗タイプの追加ができませんでした',
    FAILED_TO_ADD_TASK_TYPE: 'タスクカテゴリを追加できませんでした',
    FAILED_TO_ADD_THE_PROBLEM_DESCRIPTION_DOES_NOT_EXCEED_1000_WORDS: '追加に失敗しました。問題の説明は1000語を超えてはなりません',
    FAILED_TO_ADD_THE_TRANSFER_LABEL: '交替リストのタグ追加ができませんでした',
    FAILED_TO_DELETE: '削除できませんでした！',
    FAILED_TO_DELETE_BRAND_TYPE: 'ブランドタイプの修正ができませんでした',
    FAILED_TO_DELETE_CANNOT_DELETE_THE_STORE: '削除に失敗しました。ストアを削除できません',
    FAILED_TO_DELETE_COMMON_DATA: '通用データの削除ができませんでした',
    FAILED_TO_DELETE_CUSTOM_FIELD: 'カスタマー文字列の削除ができませんでした',
    FAILED_TO_DELETE_DEALER_TYPE: 'エージェンシ分類の削除ができませんでした',
    FAILED_TO_DELETE_DEFECTIVE_PARTS: '欠陥のあるアクセサリを削除できませんでした',
    FAILED_TO_DELETE_DEFECTIVE_PRODUCT: '欠陥のある問題を削除できませんでした',
    FAILED_TO_DELETE_DEFECTIVE_PRODUCT_CLASSIFICATION: '欠陥のある問題の分類を削除できませんでした',
    FAILED_TO_DELETE_DOCUMENT: 'ファイルの削除ができませんでした',
    FAILED_TO_DELETE_FILE_TYPE: 'ファイルの種類を削除できませんでした',
    FAILED_TO_DELETE_JOB: '職位の削除ができませんでした',
    FAILED_TO_DELETE_MAINTENANCE_ISSUE: 'メンテナンス問題の削除ができませんでした',
    FAILED_TO_DELETE_MAINTENANCE_PROBLEM_CLASSIFICATION: 'メンテナンス問題分類の削除ができませんでした',
    FAILED_TO_DELETE_PERSON: '職員の削除ができませんでした',
    FAILED_TO_DELETE_PURCHASE_RECORD: '購入記録の削除ができませんでした',
    FAILED_TO_DELETE_REGION: '地域の削除ができませんでした',
    FAILED_TO_DELETE_ROLE: 'ロールの削除ができませんでした',
    FAILED_TO_DELETE_STORE: '店舗の削除ができませんでした',
    FAILED_TO_DELETE_STORE_ATTACHMENT: '店舗の添付ファイルの削除ができませんでした',
    FAILED_TO_DELETE_STORE_TYPE: '店舗タイプの削除ができませんでした',
    FAILED_TO_DELETE_STORE_VENDOR: '店舗ベンダーの削除ができませんでした',
    FAILED_TO_DELETE_TASK_TYPE: 'タスクタイプを削除できませんでした',
    FAILED_TO_DELETE_THE_STORE_CAMERA: '店舗カメラの削除ができませんでした',
    FAILED_TO_DELETE_THE_TRANSFER_BOOK: '交替リストの削除ができませんでした',
    FAILED_TO_DELETE_THERE_ARE_ITEMS_USED_IN_THE_ORGANIZATION_NODE_DETAILS_IN_THE_DELETED_ITEMS: '削除に失敗しました、組織ノードの詳細は使用中です',
    FAILED_TO_DELETE_THERE_ARE_ITEMS_USED_IN_THE_ORGANIZATIONAL_STRUCTURE_SETTING_IN_THE_DELETED_ITEMS: '削除できませんでした、組織構造の設定は使用中です',
    FAILED_TO_DELETE_THERE_IS_AN_ITEM_USED_IN_THE_ROLE_SETTING_IN_THE_DELETED_ITEM: '削除に失敗しました。ロール設定が使用されています',
    FAILED_TO_DELETE_THIS_CATEGORY: '交替リストの分類削除ができませんでした',
    FAILED_TO_DELETE_TRACKING: 'アイテムトラッキングを削除できませんでした',
    FAILED_TO_DELETE_USER_REFERENCE: 'ユーザー参照の削除ができませんでした',
    FAILED_TO_DELETE_VENDOR_TYPE: 'ベンダータイプの削除ができませんでした',
    FAILED_TO_DELETE_VISUAL_DISPLAY_ITEM: 'ビジュアル陳列項目の削除ができませんでした',
    FAILED_TO_DELETE_VISUAL_DISPLAY_ITEM_DETAILS: 'ビジュアル陳列項目明細の削除ができませんでした',
    FAILED_TO_DELETE1: '削除できませんでした：',
    FAILED_TO_DELETE2: '削除できませんでした',
    FAILED_TO_GET_THE_FILE_CORRESPONDING_TO_THIS_ID_PLEASE_CONTACT_THE_ADMINISTRATOR: 'このIDに該当するファイルの取得ができませんでした。管理員にご連絡ください',
    FAILED_TO_LOAD: '読み込みに失敗しました',
    FAILED_TO_MODIFY_BRAND: 'ブランド名の訂正ができませんでした',
    FAILED_TO_MODIFY_BRAND_TYPE: 'ブランドタイプを変更できませんでした',
    FAILED_TO_MODIFY_COMPETITION_CATEGORY: '競合ブランドを変更できませんでした',
    FAILED_TO_MODIFY_CUSTOM_FIELDS: 'カスタマー文字列の修正ができませんでした',
    FAILED_TO_MODIFY_DEFECTIVE_PARTS: '欠陥のあるアクセサリを変更できませんでした',
    FAILED_TO_MODIFY_DEFECTIVE_PRODUCT: '不良品の問題を修正できませんでした',
    FAILED_TO_MODIFY_FORM_PERMISSIONS: 'リスト修正権限の修正ができませんでした',
    FAILED_TO_MODIFY_GENERAL_DATA: '通用データの修正ができませんでした',
    MODIFYING_GENERAL_DATA_FAILED: '通用データの修正ができませんでした',
    FAILED_TO_MODIFY_ITEM_CATEGORY: '道具類別の修正ができませんでした',
    FAILED_TO_MODIFY_MAINTENANCE_ISSUES: 'メンテナンス問題の修正ができませんでした',
    FAILED_TO_MODIFY_PRODUCT_CATEGORY: '製品カテゴリを変更できませんでした',
    FAILED_TO_MODIFY_PURCHASE_RECORD: '購入記録の修正ができませんでした',
    FAILED_TO_MODIFY_ROLE: 'ロールの修正ができませんでした',
    FAILED_TO_MODIFY_ROLE_PERMISSIONS: 'ロール権限の修正ができませんでした',
    FAILED_TO_MODIFY_SALES_DATA: '販売データの修正ができませんでした',
    FAILED_TO_MODIFY_STORE: '店舗の訂正ができませんでした',
    FAILED_TO_MODIFY_STORE_CAMERA: '店舗カメラの変更に失敗しました',
    FAILED_TO_MODIFY_STORE_EQUIPMENT: '店舗設備の修正ができませんでした',
    FAILED_TO_MODIFY_STORE_TYPE: '店舗タイプの修正ができませんでした',
    FAILED_TO_MODIFY_TASK_TYPE: 'タスクタイプの変更に失敗しました',
    FAILED_TO_MODIFY_THE_CLASSIFICATION_OF_DEFECTIVE_PRODUCTS: '欠陥製品の問題分類を変更できませんでした',
    FAILED_TO_MODIFY_THE_PHONE_NUMBER_IS_ALREADY_USED: '修正ができませんでした。この携帯番号がすでに使われています',
    FAILED_TO_MODIFY_THE_TRANSFER_OF_THIS_LABEL: '交替リストのタグ修正ができませんでした',
    FAILED_TO_RESET_PASSWORD: 'パスワードのリセットはできませんでした',
    FAILURE: '失敗',
    FAILURE_ONLY_BMP__JPG__JPEG__PNG_FORMAT_PHOTOS_ARE_CURRENTLY_SUPPORTED: '失敗：現在のサポートBMP / JPG / JPEG / PNG形式の写真',
    FAILURE_TO_ADD_MAINTENANCE_PROBLEM_CLASSIFICATION: 'メンテナンス問題分類の追加ができませんでした',
    FAILURE_TO_MODIFY_MAINTENANCE_PROBLEM_CLASSIFICATION: 'メンテナンス問題分類の修正ができませんでした',
    FAILURE1: '失敗：',
    FEATURES_ARE_NOT_OPEN_YET: '機能はまだ利用できません',
    FEMALE: '女',
    infoapi_common_000022: '女',
    FIELD_NAME: '文字列名',
    FIELD_NOTES: '文字列コメント',
    FIELD_NUMBER: '文字列番号',
    FILE: 'ファイル',
    FILE_CATEGORY: 'ファイルタイプ',
    FILE_EXTENSION: 'ファイル拡張子名',
    FILE_EXTENSION_CANNOT_BE_EMPTY: 'ファイル拡張子名は空にできません',
    FILE_FORMAT_ERROR_UPLOAD_FAILED: 'ファイルのフォーマットが間違っている為、アップロードできませんでした',
    FILE_LINK_WILL_BE_DISPLAYED_AFTER_SAVING: '保存した後に、ファイルのリンクが出てきます',
    FILE_NAME: 'ドキュメント名',
    FILE_NAME_CANNOT_BE_EMPTY: 'ファイル名は空にできません',
    FILE_NAME1: 'ファイル名：',
    FILE_NAME2: 'ファイル名',
    FILE_SIZE: 'ファイルサイズ',
    FILE_TITLE: 'ファイルタイトル',
    FILE_TITLE_CANNOT_BE_EMPTY: 'ファイルのタイトルを空にすることはできません',
    FILE_TYPE: 'ファイルタイプ',
    FILE_TYPE_INFORMATION: 'ファイルフォーマット情報',
    FILE_TYPE_NAME: 'ファイルフォーマット名',
    FILE_UPLOAD_FAILED: 'ファイルのアップロードに失敗しました',
    FILTER_ROLES: '役割をフィルター',
    FIND: '見つける',
    FIRST_WEEK_OF_EACH_YEAR: '毎年の最初の週',
    FIX_DEFECTIVE_PRODUCTS: '不良品を修正する',
    FIX_MAINTENANCE_ISSUES: 'メンテナンス問題を修正する',
    FIXED_PASSWORD: '固定パスワード',
    FIXED_PASSWORD_CANNOT_BE_EMPTY: '固定パスワードは空にできません',
    FLOOR_PLAN_FILE_ID_FORMAT_ERROR: 'フロアプランファイルID形式のエラー。',
    FLOOR_PLAN_TITLE_CANNOT_BE_EMPTY: 'フロアプランのタイトルは空にできません。',
    FOLDER__FILE: 'フォルダー/ファイル',
    FOR_GROUP_MESSAGING_YOU_MUST_SELECT_AN_ORGANIZATION: '数人に送信する場合、必ず組織を選択してください',
    FORCED_DISPLAY_OF_TOTAL_SCORE: '合計スコアを強制的に表示する',
    FORMAT: 'フォーマット',
    FORWARD_NEWS: 'フォワードニュース',
    FOUNDER: '作成者',
    FREEZE: '凍結',
    FREEZE_SUCCESSFULLY: '凍結しました',
    FRIDAY: '金曜日',
    FROZEN: '凍結済み',
    FULL_MARK_SETTING: 'フルマーク設定',
    FULL_VALUE: '完全な価値',
    GENDER: '性別',
    ExcelTemplate_common_000017: '性別',
    GENERAL_COMMENT: '一般的なコメント',
    GENERAL_DATA_DICTIONARY: '一般的なデータ辞書',
    GENERAL_DATA_INFORMATION: '一般データ情報',
    GENERAL_USER: '一般ユーザー',
    GENERATE_ENTERPRISE_REPAIR_SPECIALIST: 'エンタープライズ修理スペシャリストを生成する',
    GENERATE_REPAIR_CODE: '修復コードを生成する',
    GENERATED_SUCCESSFULLY: '正常に生成されました',
    GENERATION_OF_MAINTENANCE_CODE_SOME_SELECTED_SHOPS_DO_NOT_HAVE_A_SHOP_NUMBER_AND_CANNOT_GENERATE_REPAIR_CODES: 'メンテナンスコードが生成されています。 選択した店舗には店舗番号がありません。メンテナンスコードを生成できません。',
    GET_VERIFICATION_CODE: '検証コード獲得',
    GOODS_TRACKING: '商品追跡',
    m_info_common_000006: '商品追跡',
    GREETING_RETURN_VISIT_TEMPLATE: '挨拶追跡フォーム',
    GREETINGS_RETURN_VISIT_DATA_IMPORT: '挨拶追跡データをインポートする',
    HAND_HELD_MACHINE: 'モバイル',
    HAND_OVER_THIS: '日誌',
    m_info_common_000029: 'デイリーノート',
    HAVE: '有る',
    HAVE_READ: '読んだ？',
    HIDDEN_DAYS: '日を隠す',
    HIDE_SCORE: 'スコアを非表示',
    HIGH_STRENGTH: '高強度',
    HISTORICAL_EXCHANGE_RATE_SETTINGS: '過去の為替レートの設定',
    HOBBY: '趣味',
    HOUR: '時間',
    IDENTIFY: '識別',
    IF_THE_SIGN_USER_AGREEMENT_OPTION_IS_CHECKED_THE_USER_AGREEMENT_FILE_MUST_BE_UPLOADED: '署名済みユーザー契約オプションが選択されている場合、契約文書をアップロードする必要があります',
    IF_YOU_MODIFY_THE_TEMPLATE_ALL_UNSUBMITTED_TEMPLATES_WILL_NEED_TO_BE_REEDITED_ARE_YOU_SURE_YOU_WANT_TO_MODIFY_IT: 'フォームを修正すると、提出していないすべてのフォームが再作成しなければならないので、修正してよろしいでしょうか',
    IMAGE: '画像',
    IMAGES_WERE_ONLY_PARTIALLY_UPLOADED: '画像が部分的にアップロードされました',
    IMPORT: 'インポート',
    IMPORT_AREA: '地域入力',
    IMPORT_ASSISTANT: 'インポートアシスタント',
    IMPORT_BASIC_DATA: '基本データをインポートする',
    IMPORT_BRAND: 'ブランドを導入する',
    IMPORT_COMPETING_CATEGORIES: '競合するカテゴリをインポートする',
    IMPORT_COMPETITION_INFORMATION: '競合情報をインポートする',
    IMPORT_CUSTOMER: '社員情報の入力',
    IMPORT_DATA: 'データをインポートする',
    IMPORT_DEALER: 'ディーラーの入力',
    IMPORT_DISPLAY_BROCHURE: '陳列マニュアルを導入する',
    IMPORT_DISPLAY_BROCHURE_CONFIGURATION: '陳列配置マニュアルを導入する',
    IMPORT_DISPLAY_BROCHURE_RELATIONSHIP: '陳列マニュアル関係を導入する',
    IMPORT_EXCEL: 'エクセルにインポートする',
    IMPORT_FAILED: 'インポートに失敗しました：',
    IMPORT_FILE_NAME: 'インポートファイル名',
    IMPORT_FILE_SIZE_CANNOT_EXCEED: 'インポートファイルサイズを超えることはできません',
    IMPORT_GOODS: '商品インポート',
    IMPORT_GREETING_RETURN_VISIT: '挨拶追跡をインポートする',
    IMPORT_INSPECTION_TOUR: '輸入検査チェックリスト',
    IMPORT_INVENTORY: '在庫をインポートする',
    IMPORT_ITEM_CLASSIFICATION: '道具分類をインポートする',
    IMPORT_MAINTENANCE_CLASSIFICATION: 'メンテナンス分類をインポートする',
    IMPORT_MAINTENANCE_FAILURE: 'メンテナンスをインポートする',
    IMPORT_ORGANIZATION: '組織の導入',
    IMPORT_PASSENGER_FLOW_CHANNEL: '客数通路のインポート',
    IMPORT_PRODUCT_CATEGORIES: '製品カテゴリをインポートする',
    IMPORT_PRODUCT_INFORMATION: '製品情報をインポートする',
    IMPORT_PROFESSIONAL_STORE_WITH_SHOP_TEMPLATE: 'ストアテンプレートを使用したデューティストアのインポート',
    IMPORT_PROGRESS: 'インポート進行状況',
    IMPORT_PROPS: '道具をインポートする',
    IMPORT_PURCHASE_RECORDS: '購入記録のインポート',
    IMPORT_ROLES: '職務の入力',
    IMPORT_SALES: '売り上げのインポート',
    IMPORT_SHOP: '店舗のインポート',
    IMPORT_SHOP_EQUIPMENT: '店舗設備のインポート',
    IMPORT_SHOP_ITEMS: '店舗道具をインポートする',
    IMPORT_STAFF: '社員任職情報をインポートする',
    IMPORT_STAFF_ASSESSMENT_TEMPLATE: '人事評価テンプレートのインポート',
    IMPORT_STATUS: 'インポート状態',
    IMPORT_SUCCEEDED: 'インポート成功',
    IMPORT_SUPPLIER: '仕入先情報の追加',
    IMPORT_TIME: 'インポート時間',
    IMPORT_TYPE: 'インポート分類',
    IMPORTER: '社員情報の入力',
    INBOUND_TRAFFIC: 'トラフィックのインポート',
    INCORRECT_DATA: 'データエラー',
    INCORRECT_TIME_FORMAT: '誤った時刻形式',
    INCORRECT_TIME_RANGE: '誤った時間範囲',
    INCORRECT_USERNAME_OR_VERIFICATION_CODE: 'アカウントか検証コードが間違っています',
    INDEX: 'インデックス',
    INDUSTRY: '業界',
    INFORMATION: '情報',
    INPUT_VALUE_TYPES_DO_NOT_MATCH: '入力値が一致しません',
    INQUIRE: '検索',
    INSERT_PICTURE: '画像の添付',
    INTERNAL_ERROR_DO_YOU_DOWNLOAD_AND_VIEW_THE_PROMPT_FILE: '内部エラー、ファイルを確認するためにダウンロードしますか？',
    INTERNAL_ERROR_PLEASE_VERIFY: '内部エラーを訂正してください',
    INVALID_ATTACHMENT_ID_FORMAT: '無効な添付IDフォーマット',
    INVALID_DATE_FORMAT: '無効な日付形式',
    INVALID_ID: '無効ID',
    INVALID_MANUAL_ID_FORMAT: '無効なパンフレットIDフォーマット',
    INVALID_NAME: '無効な名前',
    INVALID_NUMBER: '無効な番号',
    INVALID_OPERATION_NO_JOBS_IN_THIS_AREA: '無効な操作です。この領域には位置がありません。',
    INVALID_OPERATION_THIS_ROLE_HAS_NO_REGION_SELECTION: '無効な操作です。この役割にはエリア選択がありません。',
    INVALID_ORGANIZATION: '無効な組織',
    INVALID_PRIMARY_KEY_ID_FORMAT: '無効なプライマリーキーIDフォーマット',
    INVALID_PRODUCT: '無効な製品',
    INVALID_SERVICE_CODE: '無効なサービスナンバー',
    INVALID_STORE_ID_FORMAT: '無効な店舗IDフォーマット',
    INVALID_SUPERIOR: '無効な上司',
    INVENTORY_DATA_IMPORT: '在庫データをインポートする',
    IP_ADDRESS: 'IPアドレス',
    IS_REQUIRED: '必ず入力するかどうか',
    ISSUE_CATEGORY_INFORMATION_EDIT: '問題カテゴリ情報を変更する',
    ISSUE_INFORMATION_EDITING: '問題情報を変更する',
    ISSUE_NUMBER: 'Issue数',
    ISSUE_NUMBER1: '問題番号',
    ITEM_CATEGORY: '小道具カテゴリ',
    ITEM_CATEGORY_INFORMATION: '道具類別データ',
    ITEM_CATEGORY_SETTINGS: '小道具カテゴリ設定',
    ITEM_CLASSIFICATION: '道具分類',
    ITEM_CLASSIFICATION_DOES_NOT_EXIST: '支柱分類は存在しません',
    ITEM_CLASSIFICATION_IMPORT: '道具分類をインポートする',
    ITEM_CODE_CANNOT_BE_EMPTY: 'プロップコードを繰り返すことはできません',
    ITEM_CODES_CANNOT_BE_REPEATED_UNDER_THE_SAME_ITEM_CATEGORY: 'アイテムコードを同じアイテムカテゴリの下に複製することはできません。',
    ITEM_CORRESPONDING_SUPPLIER_DOES_NOT_EXIST: '道具に該当するベンダー別称が見つかりませんでした',
    ITEM_DESCRIPTION: '項目説明',
    ITEM_INFORMATION: '道具データ',
    ITEM_INFORMATION_MANAGEMENT: '支柱情報管理',
    ITEM_NAME: '道具名称',
    ITEM_NAME_CANNOT_BE_EMPTY: 'プロップ名は空にできません',
    ITEM_NAMES_CANNOT_BE_DUPLICATED_UNDER_THE_SAME_ITEM_CATEGORY: 'プロップコードを繰り返すことはできません',
    ITEM_NUMBER: '道具番号',
    ITEM_NUMBER_DOES_NOT_EXIST: '道具ナンバーが見つかりませんでした',
    ITEM_REPAIR: '道具メンテナンス',
    ITEM_UNITS_CANNOT_BE_EMPTY: '支柱ユニットは空にできません',
    JAPANESE: '日本語',
    JOB_DETAILS: '役職詳細',
    JOB_INFORMATION: '役職情報',
    JOB_INFORMATION1: '位置情報',
    JOB_SHOP_PROJECT_MANAGEMENT: '直営店プロジェクト管理',
    m_info_common_000009: '直営店プロジェクト管理',
    JOB_SHOP_TEMPLATE: '直営店テンプレート',
    JOB_TITLE: '役職名',
    JOB_TITLE1: '職名',
    KEYWORD_SEARCH: 'キーワード検索',
    KOREAN: '韓国語',
    KPI_MANAGEMENT: 'KPI管理',
    m_info_common_000015: 'KPI管理',
    LABEL: 'ラベル',
    LABEL_1: 'ラベル1',
    LABEL_2: 'ラベル2',
    LABEL_3: 'ラベル3',
    LABEL_INFORMATION: 'タグ情報',
    LABEL_NAME: 'タグ名',
    LANGUAGE_SELECTION: '言語を選択',
    LAST_LOGIN_TIME: '最終ログイン時間',
    LAST_NAME: '苗字',
    LAST_RENOVATION_TIME: '最終改装時間',
    LAST_UPDATE_TIME: '最終更新時間',
    LAST_UPDATED: '最新更新時間',
    LAST_UPDATED_BY: '最終更新者',
    LEARNER: '学習者',
    LEARNING_RECORD: '学習記録',
    LEAVE_BLANK: '空欄数',
    LIMIT: '制限',
    LIMIT_SET_THE_MAXSIZE_PROPERTY_TO_CHANGE_THE_LIMIT: '限界！ MaxSizeを設定して制限を変更します',
    LINK_ADDRESS: 'アクセルアドレス',
    LINKED: '関連できました',
    LIST_OF_CONTROLS: '制御データリスト',
    LIST_OF_SHOPS: '店舗一覧',
    LOADING: 'アクセス中',
    LOCALE: '地域設定',
    LOCATION_INFORMATION_EDITING: '場所情報を変更する',
    LOCKING: 'ロック',
    LOG_IN: '登録',
    LOGIN_PROTECTION: 'ログイン保護',
    LOGIN_TO_THE_INFORMATION_MANAGEMENT_PLATFORM: 'データ管理定盤に登録済み',
    LONG_TERM_EFFECTIVE: '長期有効',
    LOVE: '趣味',
    LUMP_SUM: '総額',
    M: '顧客タイプ',
    MAIL_BOX: 'メールBOX',
    MAIL_CONFIGURATION: 'メール設定',
    MAILBOX: 'オフィスEメールアドレス',
    ExcelTemplate_common_000020: 'オフィスEメールアドレス',
    MAIN_PICTURE: 'メイン写真？',
    MAINTENANCE_AUTHORITY: 'メンテナンス許可',
    MAINTENANCE_AUTHORIZATION_MANAGEMENT: 'メンテナンス許可の管理',
    MAINTENANCE_CATEGORY_SETTING: 'メンテナンスカテゴリの設定',
    MAINTENANCE_CLASSIFICATION: 'メンテナンス分類',
    MAINTENANCE_CLASSIFICATION_IMPORT: 'メンテナンスの分類をインポートする',
    MAINTENANCE_DATA_DICTIONARY: 'メンテナンスデータ辞典',
    MAINTENANCE_FAULT_CLASSIFICATION: 'メンテナンス故障分類',
    MAINTENANCE_FAULT_CLASSIFICATION_DOES_NOT_EXIST: 'メンテナンス障害分類は存在しません',
    MAINTENANCE_FAULT_CLASSIFICATION_ENGLISH_NAME: 'メンテナンス故障分類英文名',
    MAINTENANCE_FAULT_CLASSIFICATION_INFORMATION: 'メンテナンス故障分類データ',
    MAINTENANCE_FAULT_CLASSIFICATION_NAME: 'メンテナンス故障分類名称',
    MAINTENANCE_FAULT_IMPORT: 'メンテナンス故障をインポートする',
    MAINTENANCE_FAULT_NAME: 'メンテナンス故障名称',
    MAINTENANCE_INFORMATION_MANAGEMENT: 'メンテナンス情報管理',
    MAINTENANCE_SUPPLIER_DATA_IMPORT: 'メンテナンスベンダーデータのインポート',
    MAJOR_CATEGORY_DOES_NOT_EXIST: '主要なカテゴリは存在しません',
    MALE: '男',
    infoapi_common_000023: '男',
    MALFORMED_BIRTH_YEAR: '誤った誕生年の形式',
    MANAGE_EXISTING_TAGS: '既存のタグを管理する',
    MANUAL_UPLOAD_FILE_CANNOT_BE_LARGER_THAN_20M: '手動でアップロードするファイルはマックス20MB以内となる',
    MANUAL_UPLOAD_FILE_CANNOT_BE_LARGER_THAN_40M: '手動アップロードファイルの最大サイズは40Mです',
    MASS_SEND: '一斉送信',
    MATTER_IS_WITHIN_THE_REQUIRED_DATE_RANGE: '必要な日付範囲内の日',
    MATTER_MUST_BE_NUMERIC_ON_THE_FIRST_FEW_DAYS: '事項は数値形式である必要があります',
    MATTERS_MUST_BE_GREATER_THAN_0_ON_THE_FIRST_FEW_DAYS: '事項はその日に0より大きくなければなりません',
    MECHANISM_1_CONTAINS_THE_WEEK_OF_JANUARY_1: 'メカニズム1：1月1日の週を含める',
    MECHANISM_2_WEEK_CONTAINING_1_FIRST_THURSDAY: 'メカニズム2：週に最初の木曜日を含める',
    MESSAGE_ADDED: '情報を追加する',
    MESSAGE_ADDITION_FAILED: '情報の追加ができませんでした',
    MESSAGE_CENTER: 'メッセージセンター',
    MESSAGE_CODE: 'メッセージナンバー',
    MESSAGE_CONTENT: 'メッセージの内容',
    MESSAGE_DELETION: '情報を削除する',
    MESSAGE_NOTIFICATION: 'システム提示',
    MESSAGE_TYPE: 'メッセージタイプ',
    MOBILE_PHONE: '電話番号',
    MODE_OF_OPERATION: '経営方式',
    MODIFICATION_FAILED_BIRTH_TIME_CANNOT_EXCEED_CURRENT_TIME: '変更できませんでした。出生時間は現在の時間を超えることはできません',
    MODIFICATION_FAILED_BUSINESS_START_TIME_CANNOT_BE_LESS_THAN_END_TIME: '変更できませんでした。ビジネスの開始時間は終了時間よりも長くする必要があります',
    MODIFICATION_FAILED_CANNOT_BE_MODIFIED_TO_AN_EXISTING_NONCUSTOM_ORGANIZATION: '変更できませんでした。既存の定義されていない組織を変更できません',
    MODIFICATION_FAILED_OTHER_ADJUSTMENT_FACTORS_EXIST_IN_THE_STARTTOEND_TIME_PERIOD: '変更できませんでした。開始時刻と終了時刻の間に他の調整要素が存在します',
    MODIFICATION_OF_COMPETITION_CATEGORY_SUCCEEDED: '競合カテゴリを変更しました',
    MODIFICATION_OF_RETAIL_TOUR_TEMPLATE: '小売店舗チェックフォーム問題を修正する',
    MODIFY: '修正',
    MODIFY_ASSET_FAILED: 'アセットの変更に失敗しました',
    MODIFY_ASSET_TYPE: 'アセットタイプの変更',
    MODIFY_ASSET_TYPE_FAILED: 'アセットタイプの変更に失敗しました',
    MODIFY_ASSETS: 'アセットの変更',
    MODIFY_CLASSIFICATION: '分類の変更',
    MODIFY_COURSE: 'コースの修正',
    MODIFY_COURSEWARE: 'レッスンの修正',
    MODIFY_DEALER: 'エージェンシの修正',
    MODIFY_DEALER_TYPE: 'エージェンシ分類を修正する',
    MODIFY_DEFECTIVE_PARTS: '不良部品の修正',
    MODIFY_DISPLAY_MANUAL_AND_ROLE_ASSOCIATION: '表示マニュアルとロールの関連付けの変更',
    MODIFY_FAILED_ILLEGAL_OPERATION: '変更できませんでした、不正の操作です',
    MODIFY_FAILED_NO_CORRECT_ANSWER_EXISTS_IN_OPTIONS: '変更できませんでした、選択に正解がありません',
    MODIFY_FAILED_PHONE_NUMBER_ALREADY_EXISTS: '変更できませんでした、携帯番号が存在しません',
    MODIFY_FAILED_START_TIME_CANNOT_BE_GREATER_THAN_END_TIME: '変更できませんでした、開始時間は終了時間より長くすることはできません',
    MODIFY_FAILED_START_TIME_CANNOT_BE_LESS_THAN_TODAY: '変更できませんでした、開始時間は今日より大きくなければなりません',
    MODIFY_FAILED_THE_NUMBER_OF_ORGANIZATIONS_IN_THE_ORGANIZATION_HAS_REACHED_THE_UPPER_LIMIT: '変更できませんでした、組織内の組織数が上限に達しました',
    MODIFY_FILE_TYPE: 'ファイル種類の変更',
    MODIFY_FORM_PERMISSIONS: 'リスト権限を修正する',
    MODIFY_GENERAL_DATA: '通用データの修正',
    MODIFY_GREETING_RETURN_VISIT_TYPE: '挨拶追跡タイプを修正する',
    MODIFY_ITEM_CATEGORY_SUCCESSFULLY: '道具類別の修正ができました',
    MODIFY_ITEM_CLASSIFICATION: 'プロップ分類の変更',
    MODIFY_MAINTENANCE_PROBLEM_CLASSIFICATION: 'メンテナンス問題分類を修正する',
    MODIFY_MAINTENANCE_ROLE_PERMISSIONS: 'ロールメンテナンス権限の修正',
    MODIFY_ORGANIZATION_NODE: '組織節点を修正する',
    MODIFY_ORGANIZATION_TYPE: '組織タイプの変更',
    MODIFY_PASSENGER_FLOW: '客数の修正',
    MODIFY_PASSENGER_FLOW_CONVERSION_RATE: '客数転換率を修正する',
    MODIFY_PERSON: '社員情報の訂正',
    MODIFY_PERSONNEL_ASSESSMENT_TEMPLATE: '社員評価フォームを修正する',
    MODIFY_PURCHASE_RECORDS: '購入記録の修正',
    MODIFY_QUESTION_BANK_QUESTIONS: 'データベースを修正する',
    MODIFY_REPORT_FIELD_ON_DATA: 'データ上のレポートフィールドの変更：',
    MODIFY_RETAIL_TOUR_TEMPLATE: '小売店舗チェックフォームを修正する',
    MODIFY_ROLE: 'ロールの修正',
    MODIFY_ROLE_PERMISSIONS: 'ロール権限の修正',
    MODIFY_SALES_DATA: '販売データの修正',
    MODIFY_SHOP_CAMERA: 'ストアのカメラの変更',
    MODIFY_SHOP_EQUIPMENT: '店舗設備の修正',
    MODIFY_STORE_TYPE: '店舗タイプを修正する',
    MODIFY_TASK_TYPE: 'タスク種類の変更',
    MODIFY_TEST_PAPER: '試験紙を修正する',
    MODIFY_THE_ADJUSTMENT_FACTOR: '調整係数を修正する',
    MODIFY_THE_DEFECTIVE_PRODUCT_CLASSIFICATION: '欠陥のある問題分類の変更',
    MODIFY_THE_REPORT_ON_THE_DATA: 'レポートフィールドのデータの変更：',
    MODIFY_THE_RETAIL_TOUR_TEMPLATE_PROBLEM_CLASSIFICATION: '小売店舗チェックフォーム問題分類を修正する',
    MODIFY_THE_STAFF_ASSESSMENT_TEMPLATE: '社員評価フォーム問題を修正する',
    MODIFY_THE_TEST_QUESTION: '試験問題を修正する',
    MODIFY_THE_TRANSFER_LABEL: '交替リストのタグを修正する',
    MODIFY_USER_REFERENCE: 'ユーザー参照を修正する',
    MODIFY_USER_REFERENCE_FAILED: 'ユーザー参照の修正ができませんでした',
    MODIFYING_CUSTOM_FIELDS: 'カスタマー文字列を修正する',
    MONEY_MANAGEMENT: '通貨管理',
    MONTH: '月',
    MORE_CONDITIONS: '追加オプション',
    MORE_THAN_1000_WORDS: '単語数が1000を超えています',
    MULTILINGUAL_SETTINGS: '多言語設定',
    MULTILINGUAL_UPDATE_OF_MAINTENANCE_CLASSIFICATION: 'メンテナンス分類言語の更新',
    MULTIPLE_CHOICE: 'シングル選択問題',
    SINGLE_CHOICE: '複数選択の質問',
    z_info_common_000002: '複数選択の問題',
    MULTIPLE_CHOICE_QUESTIONS: '多肢選択問題',
    z_info_common_000003: '複数選択の問題',
    MUST_BE_THE_DEFAULT_LANGUAGE_WHEN_ADDING: '新規追加は既定の言語である必要があります',
    NAME: '氏名',
    ExcelTemplate_common_000008: '氏名',
    NAME_CANNOT_BE_EMPTY: 'お名前を必ず入力してください',
    NAME_IS_INVALID: '名前が無効です',
    NAME_IS_REQUIRED: '名称を必ず入れてください',
    NAME_OF_ASSOCIATION: '組織名',
    NAME1: '名前',
    NAME2: '名前',
    NAME3: '名前',
    NEEDS_REVIEW_AND_CONFIRMATION: '監査確認が必要です',
    NEW_REPORT_FIELDS_ON_DATA: 'レポートフィールドの新しいデータ：',
    NEW_TYPE: '新しいタイプ',
    NO: 'いいえ',
    NO_CHANGES: '修正なし',
    NO_COMPANY_SELECTED: '会社が選ばれていません！',
    NO_CORRESPONDING_DEVICE_CODE_FOUND: '該当する設備ナンバーはみつかりませんでした',
    NO_DATA: 'デーナ無し',
    NO_DATA_DETECTED: '未確認のデータです！',
    NO_DATA_IMPORTED: 'インポートしていないデータ',
    NO_EDITABLE_ITEMS_FOUND: '変更可能なアイテムが見つかりません',
    NO_FILE_CORRESPONDING_TO_THE_ID: 'このIDに該当するファイルが無し',
    NO_PASSWORD_SETTINGS_SELECTED: 'パスワード設定が選択されていません',
    NO_REASON_TO_ENTER: '該当する入庫原因がみつかりませんでした',
    NO_SUCH_CUSTOMER_POSITION: 'そのような顧客のポジションはありません',
    NO_SUCH_ORGANIZATION_TYPE: 'そのような組織タイプはありません',
    NO_SUCH_PARENT_ORGANIZATION_NAME: 'そのような親組織名はありません',
    NO_SUCH_SHOP: 'そのようなストアはありません',
    NO_SUCH_SHOP_NAME: 'そのようなストア名はありません',
    NO_SUCH_USER_INFORMATION: 'そのようなユーザー情報はありません',
    NO_SUPERIOR_USER_INFORMATION: '上位のユーザー情報はありません',
    NO_TEMPORARY_DIRECTORY_WAS_FOUND: '一時的なトピックが見つかりません',
    NO1: '無し',
    infoapi_common_000024: '無し',
    NON_RETAIL_SYSTEM: '非小売システム',
    NONRETAIL_SYSTEM: '非小売システム',
    infoapi_common_000028: '非小売システム',
    NONE_OF_THE_SELECTED_STORES_HAVE_A_STORE_NUMBER_AND_CANNOT_GENERATE_A_REPAIR_CODE: '選択された店舗には、店舗番号がありません',
    NOT_CONNECTED_TO_THE_INTERNET: 'インターネットにはアクセスしていません',
    NUMBER_OF_ATTACHMENTS: '添付ファイル数',
    NUMBER_OF_CATEGORIES: '類別数量',
    NUMBER_OF_COMMENTS: 'メッセージ数',
    NUMBER_OF_DAILY_GUESTS: '1日あたり客数',
    NUMBER_OF_ENTRIES: '品目数',
    NUMBER_OF_FAILED_ITEMS: '不合格項目数',
    NUMBER_OF_INSPECTION_ITEMS: '検査項目数',
    NUMBER_OF_LEVELS_OF_SUPERIOR_ORGANIZATION_PERSONNEL_ALLOWED_TO_VIEW: '上位組織のチェック可能範囲',
    NUMBER_OF_MEMBERS: 'メンバー数',
    NUMBER_OF_N_A_ITEMS: 'N / A項目数',
    NUMBER_OF_PHOTOS: '写真枚数',
    NUMBER_OF_PRODUCTS: '製品数',
    NUMBER_OF_QUALIFIED_ITEMS: '合格項目数',
    NUMERIC: '数値型',
    OFFICE_ADDRESS: 'オフィス住所',
    OFFICE_NUMBER: 'オフィス電話番号',
    OFFICE_PHONE: 'オフィス電話番号',
    OFFSET_COEFFICIENT: '偏差比',
    OFFSET_VALUE: '偏差値',
    OK_TO_GENERATE_REPAIR_CODE: '修正コードの生成を確認しますか？',
    OK_TO_REFRESH_ALL_SHOP_REPAIR_SPECIALISTS: 'すべての店舗修理スペシャリストを更新することを確認しますか？',
    ON_MONDAY: '月曜日',
    ON_SATURDAY: '土曜日',
    ON_TUESDAY: '火曜日',
    ON_WEDNESDAY: '水曜日',
    ONLINE_TRAINING: 'オンライン研修',
    ONLY_SELECT_SHOPS: '店舗しか選ばれません',
    ONLY_WORD_DOCUMENTS_ARE_SUPPORTED: 'ワード文書のみサポートされています',
    OPEN_ADDRESS_BOOK: 'アドレス帳を開く',
    OPEN_INQUIRY: '問合せを開く',
    OPEN_SHOP: 'ストアを開く',
    OPENING_DATE: '開店日',
    OPERATION_FAILED: '操作に失敗しました',
    OPERATION_IS_INVALID_BIRTH_TIME_CANNOT_EXCEED_CURRENT_TIME: '操作が無効です、出生時間は現在の時間を越えることはできません',
    OPERATOR: '操作人',
    OPTION: 'オプション',
    OPTION_INFORMATION: 'オプション情報',
    OPTION_MODIFICATION: '選択肢を修正する',
    OPTION_OR_CONTENT_CANNOT_BE_EMPTY: '選択肢或は内容は空白にしてはならない',
    ORDER: '注文',
    ORDINARY_STRENGTH: '通常の強さ',
    ORGANIZATION: '組織',
    ORGANIZATION_CODE: '組織番号',
    ORGANIZATION_DATA_IMPORT: '組織データの入力',
    ORGANIZATION_DATA_TEMPLATE: 'ブランドデータテンプレート',
    ORGANIZATION_DIRECTORY: '組織のディレクトリ',
    ORGANIZATION_HANDOVER: '組織交替書',
    ORGANIZATION_INFORMATION: '組織情報',
    ORGANIZATION_LIST: '組織リスト',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY: '組織名を必ず入れてください',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY1: '組織名を空にすることはできません',
    worker_common_000005: '組織名を入力してください',
    ORGANIZATION_NAME_CANNOT_BE_EMPTY2: '組織名を空にすることはできません！',
    ORGANIZATION_STRUCTURE_SETTING: '組織構造設定',
    TREE_MENU_DOMAIN_MANAGEMENT: '組織構造設定',
    ORGANIZATION_TYPE: '組織タイプ',
    ORGANIZATION_TYPE_CANNOT_BE_EMPTY: '組織タイプを必ず入れてください',
    ORGANIZATION_TYPE_CANNOT_BE_EMPTY1: '組織タイプを空にすることはできません',
    ORGANIZATION_TYPE_CANNOT_BE_SHOP: '組織タイプを格納できません',
    ORGANIZATION_TYPE1: '組織タイプ',
    ORGANIZATION1: '組織',
    ORGANIZATION2: '所属組織',
    ORGANIZATIONDEPARTMENT_NAME: '組織/部門名',
    ExcelTemplate_common_000011: '組織名',
    OTHER_INFORMATION: 'その他の情報',
    OUT_OF_STOCK: '当期出荷',
    OUTBOUND: '送信',
    OUTBOUNDINBOUND: '出荷/入荷',
    OUTGOING_NUMBER: 'ダイヤルアウト番号',
    OWNED_MALL: 'デパートに所属する',
    PARENT_CATEGORY_IS_NOT_LOADED: '親カテゴリが読み込まれていません',
    PARENT_FOLDER: '親フォルダ',
    PARENT_ORGANIZATION: '親会社',
    PART_OF_THE_DATA_IS_IMPORTED_SUCCESSFULLY_DO_YOU_DOWNLOAD_THE_PROMPT_FILE_TO_VIEW_THE_WRONG_DATA: '部分的なデータのインポートが成功しました、間違ったデータをチェックをする為のヒントをダウンロードしますか？',
    PASSENGER_CHANNEL: '客数通路',
    PASSENGER_CHANNEL_IMPORT_TEMPLATE: '客数通路インポートフォーム',
    PASSENGER_CHANNEL_INFORMATION: '客数通路情報',
    PASSENGER_DATA_IMPORT: 'トラフィックデータのインポート',
    PASSENGER_DATA_IS_ARCHIVED: '客数データがファイリング済み',
    PASSENGER_DATA_TEMPLATE: 'トラフィックデータテンプレート',
    PASSENGER_EQUIPMENT_INFORMATION: '客数設備情報',
    PASSENGER_FLOW_ADJUSTMENT: 'トラフィック調整',
    PASSENGER_FLOW_ADJUSTMENT_LIST: 'トラフィック調整リスト',
    PASSENGER_FLOW_EQUIPMENT: '客数設備',
    PASSENGER_FLOW_INFORMATION: 'トラフィック情報',
    PASSENGER_FLOW_INFORMATION_ADDED: '客数情報の追加',
    PASSENGER_FLOW_INFORMATION_UPDATE: '客数情報の更新',
    PASSENGER_FLOW_MANAGEMENT: 'トラフィック管理',
    PASSENGER_FLOW_STATISTICS: 'トラフィック統計',
    PASSING_SCORE: '合格点',
    PASSWORD: 'パスワード',
    PASSWORD_IS_TOO_LONG: 'パスワードが長すぎます',
    PASSWORD_IS_TOO_SHORT: 'パスワードが短すぎます',
    PASSWORD_RESET_SUCCEEDED: 'パスワードのリセットができました',
    PENDING_REVIEW: '監査をする',
    PEOPLE_DATA_TEMPLATE: '社員データのテンプレート',
    PEOPLE_LIST: '社員名簿',
    PERCENTAGE: 'パーセンテージ',
    PERFORMANCE_APPRAISAL: 'パフォーマンス評価',
    m_info_common_000023: 'パフォーマンス評価',
    PERFORMANCE_APPRAISAL_REPORT: '業績評価報告書',
    PERFORMANCE_APPRAISAL_REPORT1: '業績評価報告書',
    PERFORMANCE_APPRAISAL_TEMPLATE: '業績評価フォーム',
    PERMISSION_INFORMATION: 'アクセス許可情報',
    PERSONAL_INFORMATION: '個人情報',
    PERSONNEL_ASSESSMENT_TEMPLATE_IMPORT: '社員評価フォームをインポートする',
    PERSONNEL_INFORMATION: '社員情報を入れる',
    PERSONNEL_MANAGEMENT: '人員管理',
    PHASE_ENDS_ON_DAY_OF_DAY_MUST_BE_NUMERIC: 'フェーズが終了する日付は数値型である必要があります',
    PHASE_ENDS_ON_DAYS_MUST_BE_GREATER_THAN_0: 'フェーズが終了する日は0より大きくする必要があります',
    PHASE_STARTS_ON_DAY_OF_DAY_MUST_BE_NUMERIC: 'フェーズは数値型でなければならない日に始まります',
    PHASE_STARTS_ON_THE_FIRST_FEW_DAYS_AND_MUST_BE_GREATER_THAN_0: 'フェーズは、0より大きくなければならない日に始まります',
    PHONE: '電話番号',
    PHONE_NUMBER: '電話番号',
    PHONE_NUMBER_CANNOT_BE_EMPTY: 'プロップ番号は空にできません',
    PICTURE_FORMAT_IS_NOT_SUPPORTED: '画像フォーマットが認められていません',
    PICTURE_UPLOADED_SUCCESSFULLY: '画像のアップロードができました',
    PLANNING_TIME: '計画時間',
    PLEASE_ADD_PASSENGER_FLOW_DATA: '客数データを追加してください',
    PLEASE_CHECK_THE_DATA: 'データを確認して下さい',
    PLEASE_CHECK_THE_REQUIRED_FIELDS: '必須のフィールドを確認して下さい',
    PLEASE_CHOOSE: '選択してください',
    PLEASE_CHOOSE_TO_UPLOAD_A_FILE: 'アップロードしたいファイルを選択してください',
    PLEASE_CONFIRM_WHETHER_TO_RESET_THE_SELECTED_USER_PASSWORD: '選択したユーザーパスワードをリセットするかどうかを確認してください。',
    PLEASE_COPY: 'コピーして下さい',
    PLEASE_ENTER_PASSENGER_FLOW_DATA: '乗客フローデータを入力して下さい',
    PLEASE_ENTER_SALES_DATA: '売上データを入力して下さい',
    PLEASE_ENTER_THE_SERVICE_CODE: 'サービスナンバーを入力してください',
    PLEASE_FILL_IN_THE_ATTACHMENT_CATEGORY_AND_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: '添付ファイルの標題及び分類を選択した上、アップロードしてください',
    PLEASE_FILL_IN_THE_INFORMATION_CATEGORY_AND_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: '情報のカテゴリとタイトルを入力し、ファイルのアップロードを選択してください！',
    PLEASE_FILL_IN_THE_TITLE_AND_CHOOSE_TO_UPLOAD_THE_FILE: 'タイトルを入力して、ファイルのアップロードを選択してください！',
    PLEASE_SELECT: '選択して下さい',
    PLEASE_SELECT_A_CATEGORY: 'カテゴリを選択して下さい',
    PLEASE_SELECT_A_CUSTOMER: 'カスタマーを選択してください',
    PLEASE_SELECT_A_DOCUMENT_TO_DOWNLOAD: 'ダウンロードするファイルを選んでください',
    PLEASE_SELECT_A_DOWNLOAD_TEMPLATE: 'フォームを選択してください',
    PLEASE_SELECT_A_FILE: 'ファイルを選択して下さい',
    PLEASE_SELECT_A_FILE_TO_UPLOAD: '情報のカテゴリとタイトルを入力し、ファイルのアップロードを選択してください！',
    PLEASE_SELECT_A_FROZEN_REPAIR_CODE: '凍結修理コードを選択してください',
    PLEASE_SELECT_A_MODIFICATION: '変更を選択して下さい',
    PLEASE_SELECT_A_NODE: '節点を選択してください',
    PLEASE_SELECT_A_PARENT_ORGANIZATION: '上位組織を選択してください',
    PLEASE_SELECT_A_PICTURE: '写真を選択して下さい',
    PLEASE_SELECT_A_PRODUCT_CATEGORY: '商品カテゴリを選択して下さい',
    PLEASE_SELECT_A_PRODUCT_CATEGORY1: '商品カテゴリを選択して下さい',
    PLEASE_SELECT_A_PROP_CATEGORY: '道具類別を選択してください',
    PLEASE_SELECT_A_REPAIR_CATEGORY: 'メンテナンス類別を選択してください',
    PLEASE_SELECT_A_SHOP: '店舗を選択してください',
    PLEASE_SELECT_A_STICKY_ITEM: 'スティッキーアイテムを選択して下さい',
    PLEASE_SELECT_A_SUITABLE_PASSWORD_LENGTH: '適切なパスワードの長さを選択してください',
    PLEASE_SELECT_A_USER: 'ユーザー名を選択してください',
    PLEASE_SELECT_AN_ITEM: '削除項目を選択してください',
    PLEASE_SELECT_AN_ITEM_TO_DEACTIVATE: '無効にするアイテムを選択してください',
    PLEASE_SELECT_AN_ITEM_TO_UNPIN: 'アイテムを選択して固定を解除してください',
    PLEASE_SELECT_AN_ORGANIZATION_NODE: '組織ノードを選択して下さい',
    PLEASE_SELECT_ASSET_CLASS: '資産分類を選択してください',
    PLEASE_SELECT_EXPORT_DATA: 'アウトポートするデータを選択してください',
    PLEASE_SELECT_ITEM_CATEGORY: '道具類別を選択してください',
    PLEASE_SELECT_THE_COMPANY_YOU_WANT_TO_LOGIN: 'ログインしたい会社を選択してください',
    PLEASE_SELECT_THE_COMPETITION_CATEGORY: '競争カテゴリを選択して下さい',
    PLEASE_SELECT_THE_FROZEN_REPAIR_CODE: 'フリーズを解除する修復コードを選択してください',
    PLEASE_SELECT_THE_ITEM_CATEGORY: '項目のカテゴリを選択して下さい',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_DELETE: '削除したい項目を選択してください',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_ENABLE: '有効にするアイテムを選択します',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_PIN: 'トップに固定するアイテムを選択してください',
    PLEASE_SELECT_THE_ITEM_YOU_WANT_TO_UNFREEZE: '凍結解除の項目を選択してください',
    PLEASE_SELECT_THE_ITEMS_THAT_NEED_TO_BE_FROZEN: '凍結する項目を選択してください',
    PLEASE_SELECT_THE_STORE_TO_BE_EDITED: '編集するストアを選択してください',
    PLEASE_SELECT_THE_TOPICS_YOU_WANT_TO_ADD: '追加する問題を選択してください',
    PLEASE_SELECT_UNPIN: 'ピン留め解除を選択して下さい',
    PLEASE_SELECT_UPLOAD_FILE: 'アップロードしたいファイルを選択してください',
    PLEASE_SELECT_WHO_YOU_WANT_TO_SEND: '送信する人を選択してください！',
    PLEASE_UPLOAD_A_600_600_PIXEL_IMAGE: '600 x 600ピクセルの画像をアップロードしてください',
    PLEASE_UPLOAD_A_COURSEWARE_PICTURE: 'コースウェアの画像をアップロードして下さい',
    POINT_BOOK_LIST: '在庫リスト',
    POSITION: '役職',
    POSITION_MANAGEMENT: '役職管理',
    POSITION_SELECTION: '位置選択',
    POSITION1: '位置',
    POST_FORM: '投稿フォーム',
    POST_INFORMATION: '返信情報',
    POSTCODE: '郵便番号',
    PRICE: '定価',
    PROBLEM_CATEGORY_NAME: '問題カテゴリ名',
    PROBLEM_DESCRIPTION: '問題の説明',
    PROBLEM_INFORMATION: '問題',
    PROBLEM_MODIFICATION: '試験問題を修正する',
    PROBLEM_NAME: '問題名',
    PROBLEM_WEIGHT: '問題重み付け',
    PROCESSING: '進行中',
    PRODUCT_CATEGORY_ADDED_SUCCESSFULLY: '製品カテゴリが正常に追加されました',
    PRODUCT_CATEGORY_IMPORT: '製品カテゴリのインポート',
    PRODUCT_CATEGORY_MODIFIED_SUCCESSFULLY: '製品カテゴリが正常に変更されました',
    PRODUCT_CLASSIFICATION_INFORMATION: '製品分類情報',
    PRODUCT_DATA_IMPORT: '製品データのインポート',
    PRODUCT_ID: '製品ID',
    PRODUCT_INFORMATION: '製品情報',
    PRODUCT_INFORMATION_IMPORT: '製品情報のインポート',
    PRODUCT_LEVEL_1_CLASSIFICATION: '製品レベル1の分類',
    PRODUCT_LEVEL_1_CLASSIFICATION_NAME: '製品クラス1分類名',
    PRODUCT_NAME: '商品名',
    PRODUCT_NAME1: '品名',
    PRODUCT_NUMBER: '品番',
    PROJECT_MANAGER: 'プロジェクト管理者',
    PROMPT: 'プロンプト',
    PROMPT_MESSAGE: 'プロンプトメッセージ',
    PROP_DATA_IMPORT: '道具データをインポートする',
    PROP_DOES_NOT_EXIST: 'プロップが存在しません',
    PROP_IMAGE: 'プロップ画像',
    PROPS_CATEGORY_PICTURES: '道具分類写真',
    PROVINCE_NAME: '所属地域（省名）',
    PUBLIC_DOCUMENT: '公共ファイル',
    PURCHASE_DATE: '購入日',
    PURCHASE_HISTORY: '購入履歴',
    PURCHASE_INFORMATION: '購入情報',
    PURCHASE_RECORD_IMPORT: '購入記録のインポート',
    PURCHASE_RECORD_TEMPLATE: '購入記録フォーム',
    PURCHASE_TIME: '購入時間',
    PURPOSE_OF_RETURN_VISIT: '訪問目的',
    PUSH: '押す',
    PUSH_TARGET: 'ターゲットを押す',
    QUANTITY: '数',
    QUERY_CONDITIONS: '問い合わせ条件',
    QUERY_ORGANIZATION_TAG: '組織タグを検索する',
    QUESTION_ANSWER: 'タイトルの答え',
    QUESTION_BANK_ADD: 'データーベースの追加',
    QUESTION_BANK_MANAGEMENT: 'テスト管理',
    QUESTION_CATEGORY: '質問カテゴリ',
    QUESTION_CODE: '問題番号',
    QUESTION_NUMBER: '問題番号',
    QUESTION_NUMBER1: '問題番号',
    QUESTION_TITLE: '問題タイトル',
    QUESTION_TYPE: '答案用紙のタイプ',
    QUESTION_TYPE1: '問題のタイプ',
    QUESTIONS_IN_USE_CANNOT_BE_DELETED: '使用中の質問は削除できません！',
    R_ACADEMY: 'Rアカデミー',
    RANDOM_PASSWORD: 'ランダムパスワード',
    RANGE_LIMITATION: '範囲限界',
    REACHING_THIS_VALUE_THE_SCORES_FOR_THIS_BROAD_CATEGORY_ARE: 'この値に達すると、このカテゴリのスコアは次のとおりです。',
    RECEIVE_CC: '受信/CC',
    RECIPIENT: '受信者',
    RECIPIENT_ORGANIZATION: '受信組織',
    RECOGNITION_SUCCESS: '識別できました',
    RECORDING_METHOD: '記録方式',
    REFERENCE_DESCRIPTION: '参照説明',
    REFERENCE_FORM: '参照リスト',
    REFRESH: 'リフレッシュ',
    REFRESH_FAILED: 'リフレッシュできませんでした',
    REFRESH_SUCCESSFUL: 'リフレッシュできました',
    REFUSE: '拒否',
    REGION_DATA_TEMPLATE: '地域データテンプレート',
    REGION_SELECTION: '地域選択',
    REGIONAL_DATA_IMPORT: '地域データの入力',
    REJECTED: '拒否しました',
    RELATED_SHOPS: '関連店舗',
    RELEASE_DATE: 'リリース日',
    RELEASE_TIME: 'リリース時間',
    REMARK: '発言',
    REMARK1: '発言',
    REMARK2: '注',
    REMINDER: 'システムプロンプト',
    REMOVE_BRAND: 'ブランド削除',
    REMOVE_BRAND_TYPE: 'ブラントタイプの削除',
    REMOVE_DEALER: 'エージェンシの削除',
    REMOVE_DEALER_TYPE: 'エージェンシ分類を削除する',
    REMOVE_DEFECTIVE_PARTS: '不良部品を取り除く',
    REMOVE_DEFECTIVE_PRODUCT: '不良品を取り除く',
    REMOVE_DEFECTIVE_PRODUCT_CLASSIFICATION: '不良品の分類を削除する',
    REMOVE_GPS: 'GPSの削除',
    REMOVE_ITEM_CATEGORY: 'アイテムカテゴリを削除する',
    REMOVE_LAND_PASSENGER_CONVERSION_RATE: '客数転換率を削除する',
    REMOVE_MAINTENANCE_ISSUES: 'メンテナンス問題を削除する',
    REMOVE_RETAIL_TOUR_TEMPLATE: '小売店舗チェックフォームを削除する',
    REMOVE_RETAIL_TOUR_TEMPLATE_ISSUE: '小売店舗チェックフォーム問題を削除する',
    REMOVE_STORE_VENDOR: '店舗ベンダーの削除',
    REMOVE_TRACKING: '商品追跡データの削除',
    REMOVE_VENDOR_TYPE: 'ベンダータイプを削除する',
    REMOVE_VISUAL_DISPLAY: 'ビジュアル陳列を削除する',
    REPAIR_APPLICATION: 'メンテナンス申込書',
    REPAIR_CATEGORY: '修理カテゴリ',
    REPAIR_CATEGORY_INFORMATION: 'メンテナンス類別データ',
    REPAIR_CLASSIFICATION: '修理分類',
    REPAIR_CODE: '修理コード',
    REPAIR_CODE_IS_FROZEN: '修理コードは凍結されています',
    REPAIR_CODE_IS_NOT_FROZEN: 'プロップコードは凍結されていません',
    REPAIR_CODE_STATUS: '修理コードの状態',
    REPAIR_FAILURE: 'メンテナンス故障',
    REPAIR_FAILURE_INFORMATION: 'メンテナンス故障データ',
    REPAIR_INFORMATION: '修理情報',
    REPAIR_MODULE_CONFIGURATION: 'モジュール構成の修復',
    REPAIR_NAME: '修理名',
    REPLIES: '回復回数',
    REPORT_CATEGORY: '報告書類別',
    REPORT_CENTER: 'レポートセンター',
    m_info_common_000002: '報告センター',
    REPORT_DATE: '報告年月日',
    REPORT_DESCRIPTION: '報告書記述　',
    REPORT_MANAGEMENT: 'レポート管理',
    REPORT_NAME: '報告書タイトル',
    REPORT_NUMBER: '報告書番号',
    REPORT_PERMISSION_SETTINGS: '報告書権限設定',
    REQUEST_CANCELLATION_REPORT_EXPIRY_TIME: 'プロップキャンセルレポートの有効期限',
    REQUIRED: '必須',
    REQUIRED1: '必須',
    RESELLER_DATA_TEMPLATE: 'ディーラーデータテンプレート',
    RESET: 'リセット',
    RESET_PASSWORD: 'パスワードのリセット',
    RESET_PASSWORD_MAIL: 'メールのパスワードをリセット',
    RESET_PASSWORD_SMS: 'SMSのパスワードをリセット',
    RESTORE: '復元',
    RESTRICT_ORGANIZATION_INFORMATION: '組織情報の制限',
    RESTRICTED_CATEGORY: 'カテゴリの制限',
    RESTRICTED_ORGANIZATION: '組織の制限',
    RESTRICTED_REPAIR_CATEGORIES: '修正カテゴリの制限',
    RETAIL_MANAGEMENT: '小売管理',
    RETAIL_TOUR: 'リテイルツアー',
    RETAIL_TOUR_REPORT: '小売店舗チェック報告書',
    RETAIL_TOUR_STORE_TEMPLATE: '店舗巡回テンプレート',
    RETURN_NAME: 'リターン名',
    RETURN_NUMBER: '訪問番号',
    RETURN_NUMBER1: 'リターン数',
    RETURN_VISIT_DETAILS: '追跡詳細',
    RETURN_VISIT_GUIDANCE: '追跡指導',
    RETURN_VISIT_INFORMATION: '追跡データ',
    RETURN_VISIT_PLAN: '訪問計画',
    RETURN_VISIT_RECORDS: '訪問記録',
    RETURN_VISIT_RESULTS: '訪問結果',
    RETURN_VISIT_TIME: '訪問時間',
    REVERSE_ORDER: '逆順',
    REVERSE_ORDER1: '逆順',
    REVISITED: '訪問',
    RIGHTS_PROFILE: '権利プロファイル',
    ROLE_DATA_IMPORT: '職務情報の追加',
    ROLE_DATA_TEMPLATE: '職務のテンプレート',
    ROLE_DETAILS: '役割詳細',
    ROLE_INFORMATION: '役職情報',
    ROLE_LOOK_UP: 'ロール（タイトル）',
    ROLE_NAME: '職務名',
    ROLE_NAME_CANNOT_BE_EMPTY: 'ロール名を必ず入れてください',
    ROLE_NAME_CANNOT_BE_EMPTY1: 'プロップ名は空にできません',
    ROLE_PERMISSIONS: '役割の許可',
    ROLE_SELECTION: '役割の選択',
    ROLE_TEMPLATE_SETTINGS: '職務テンプレート設定',
    ROLES: '役職',
    ExcelTemplate_common_000010: '職務名',
    ROLES1: '役割',
    RPLUS: 'Rﾌﾟﾗｽ',
    SAFETY_STOCK: '安全在庫',
    SALES_DATA_IMPORT: '販売データのインポート',
    SALES_DATA_IS_ARCHIVED: '販売データがファイリング済み',
    SALES_DATA_TEMPLATE: '売り上げデータテンプレート',
    SALES_INFORMATION: '販売情報',
    SALES_INFORMATION_UPDATE: '販売データの更新',
    SALES_MANAGEMENT: '販売管理',
    SALES_REPORT: '売上レポート',
    m_info_common_000038: 'セールスレポート',
    SALES_STATISTICS: '売り上げ統計',
    SAVE: '保存',
    SAVE_FAILED: '保存できませんでした',
    SAVE_THE_CONFIGURATION: '構成を保存',
    SAVED_SUCCESSFULLY: '保存できました',
    SCORE: '得点',
    SCORE_DISPLAY: '得点表示',
    SCORE_VALUE: '得点値',
    SCORING_METHOD: '採点方式',
    SCORING_MODE: '採点方式',
    SEARCH_FOR: '検索',
    SELECT: 'せんタック',
    SELECT_ALL: '全選択',
    SELECT_ALL_STORES: '全ストア選択',
    SELECT_EMAIL_LANGUAGE: '電子メール言語の選択',
    SELECT_GOODS: '商品選択',
    SELECT_IMAGE: '写真の選択',
    SELECT_SHOP: 'セレクトショップ',
    SELECT_SUPERIOR: '上級選択',
    SELECTED_ANSWER: '答えの選択',
    SELECTED_NODE_ID: 'ノードIDを選択',
    SELECTIVE: '選択',
    SEND: '送信',
    SEND_DATE: '日付の送信',
    SEND_HEADER_CANNOT_BE_EMPTY: 'プロップヘッダーは空にできません',
    SEND_MESSAGES: 'メッセージの送信',
    SEND_SIGNATURE_CANNOT_BE_EMPTY: 'プロップの署名は空にできません',
    SENDER: '送信者',
    SENDER1: '送信者',
    SENDING_CONTENT_CANNOT_BE_EMPTY: 'プロップの内容は空にできません',
    SEQUENCE_NUMBER: 'シーケンス番号',
    SERIAL_NUMBER: 'シリアルナンバー',
    SERIAL_NUMBER1: 'シリアルナンバー',
    SERVE: '就任',
    SERVICE_CODE: 'サービスナンバー',
    SERVICE_TYPE: 'サービスタイプ',
    SERVICE_TYPE1: 'サービス種別',
    SET_AS: 'として設定',
    SET_CURRENCY: '通貨の設定',
    SET_FAULT_CLASSIFICATION: '障害分類の設定',
    SET_ROLE: '役割の設定',
    SET_UP: '設定',
    SET_UP_SUCCESSFULLY: '正常に設定されました',
    SETUP_FAILED: '設定に失敗しました',
    SEX_FAREWELL: '性別',
    SHOP: '店舗',
    SHOP_ACCESSORIES: '店舗の添付ファイル',
    SHOP_ADRESS: '店舗所在地',
    SHOP_AREA: '店舗面積',
    SHOP_ENGLISH_NAME: '店舗英名',
    SHOP_EQUIPMENT: '店舗機器',
    SHOP_FAX: '店舗Fax番号',
    SHOP_ID: '店舗ID',
    SHOP_INSPECTION: '店舗検査',
    m_info_common_000008: 'チェックリスト',
    SHOP_INSPECTION_DATA_IMPORT: '店舗検査データのインポート',
    SHOP_INSPECTION_MODULE_CONFIGURATION: '店舗検査モジュールの構成',
    SHOP_INSPECTION_PROBLEM_CATEGORIES: '店舗の問題分類',
    SHOP_INSPECTION_REPORT: '店舗検査レポート',
    SHOP_INSPECTION_TEMPLATE: '店舗検査テンプレート',
    SHOP_INSPECTOR: '店舗検査',
    SHOP_LABEL: '店舗ラベル',
    SHOP_MAILBOX: '店舗Eメールアドレス',
    SHOP_MAINTENANCE: '店舗メンテナンス',
    SHOP_NUMBER: '店舗番号',
    SHOP_PROPS_IMPORT: '店舗道具をインポートする',
    SHOP_REPAIR: '店舗修理',
    m_info_common_000026: '店舗修理',
    SHOP_REPAIR_EMAIL: '店舗修理メール',
    SHOP_REPAIR1: '店舗メンテナンス',
    SHOP_STAFF: '店舗スタッフ',
    infoapi_common_000027: '店舗スタッフ',
    SHOP_TOUR_PLAN: '店舗ツアープラン',
    m_info_common_000030: 'チェックリスト計画',
    SHOP_TOUR_PREVIEW: '店舗ツアープレビュー',
    SHOP_TOUR_REPORT: '店舗チェック報告書',
    SHOP_TOUR_TEMPLATE: '店舗巡回のテンプレート',
    m_info_common_000003: 'チェックリストテンプレート',
    SHOP_TYPE: '店舗タイプ',
    SHOP_VISIT_ENTRY: '店舗項目',
    SHOPPING_MALL_APPLICATION_REQUIREMENTS: 'デパートの必要証明書',
    SHORT_NAME: '略称',
    SHOW_DEPRECATED: '非推奨を表示',
    SHOW_REPAIR_COSTS: '修理費用を表示',
    SHOW_SCORE_IN_PDF: 'PDFでスコアを表示',
    SHOW_SUBORDINATES: '部下を表示する',
    SHUT_DOWN: '閉鎖',
    SIGNATURE: '署名',
    SIGNING_TIME: '署名時間',
    SIMPLIFIED_CHINESE: '簡体字中国語',
    SINGLE_FILE_SIZE_EXCEEDS: '単一ファイルサイズを超える',
    SIZE: 'サイズ',
    SMALL_CLASS_DOES_NOT_EXIST: 'プロップクラスが存在しません',
    SMS_NOTIFICATION: 'SMS認証',
    SMS_VERIFICATION: 'SMSの検証',
    SORRY_SOMETHING_WENT_WRONG: '申し訳ありませんが何かが間違っていました',
    SORRY_THE_DEALER_HAS_BEEN_USED_IN_BUSINESS_DATA_AND_CANNOT_BE_DELETED: '申し訳ありませんが、このディーラーはビジネスデータで使用されています。削除できません',
    SORRY_THE_PROGRAM_DOES_NOT_ALLOW_FILE_DOMAINS_WITH_THE_SAME_NAME_ATTRIBUTE: '申し訳ありませんが、プログラムはファイルフィールドの同じプロパティを使用できません！',
    SORRY_YOU_ARE_NOT_A_SYSTEM_ADMINISTRATOR_PLEASE_CONTACT_YOUR_SYSTEM_ADMINISTRATOR: '申し訳ございせんが、システム管理員ではないので、あなたのシステム管理員にご連絡ください。',
    SORRY_YOUR_PASSWORD_IS_WRONG_PLEASE_REENTER: '申し訳ございませんが、パスワードが間違っていますので、もう一度ご入力ください',
    SORRY_YOUR_SOFTWARE_LICENSE_HAS_EXPIRED_PLEASE_CONTACT_R__SYSTEM_ADMINISTRATOR: '申し訳ありませんが、ソフトウェアライセンスの有効期限が切れています',
    SORRY_YOUR_USER_ACCOUNT_IS_LOCKED: '申し訳ございませんが、あなたのアカウントはロックされました。',
    SORT: 'ソート',
    SORT_FIELDS: 'フィールドの並び替え',
    SPECIAL_CHARACTERS_ARE_NOT_ALLOWED: 'プロップ文字は使用できません',
    SPECIAL_TASK_TEMPLATE: '特別任務フォーム',
    SPECIFICATION: '規格',
    STAFF_APPOINTMENT_DATA_TEMPLATE: '社員名簿フォーム',
    STAFF_ASSESSMENT_TEMPLATE: '人事評価テンプレート',
    STAFF_MANAGEMENT: 'スタッフ管理',
    STANDARD_CURRENCY: '標準通貨',
    STANDARD_CURRENCY_CANNOT_BE_EMPTY: 'プロップ通貨は空にできません',
    STANDARD_MODE: '標準モード',
    STAR_BRAND: '所属ブランド',
    STAR_DEFAULT_CURRENCY: 'スターの既定通貨',
    STAR_SHOP_LANGUAGE: 'スターの店舗言語',
    STARSTORE_NAME: '店舗名',
    START_DATE: '開始日',
    STARTING_TIME: '開始時間',
    STARTUP_PAGE_DIAGRAM: '最初のページ図',
    STATISTIC_TYPE: '統計タイプ',
    STATISTICAL_DATE: '統計日',
    STATUS: '状態',
    ExcelTemplate_common_000012: '状態',
    STATUS_QUERY: '状況サーチ',
    STICKY: 'スティッキー',
    STICKY_COURSE: 'スティッキーコース',
    STOCK_TRACKING_DATA_TEMPLATE: '商品追跡データフォーム',
    STORE_AGENT: '店舗代理店',
    STORE_AREA_INPUT_VALUE_IS_INCORRECT: 'ストア領域の入力値が間違っています',
    STORE_ASSETS: '店舗資産',
    STORE_CATEGORIES_IN_USE_CANNOT_BE_DELETED: '使用中のストアカテゴリは削除できません！',
    STORE_CATEGORY: '店舗類別',
    STORE_CATEGORY1: '店舗分類',
    STORE_CODE_CANNOT_BE_EMPTY: 'プロップコードは空にできません',
    STORE_CONTACT: '店舗連絡先',
    STORE_DATA_IMPORT: '店舗データのインポート',
    STORE_DATA_TEMPLATE: '店舗データテンプレート',
    STORE_DOCUMENT: '店舗書類',
    STORE_EQUIPMENT_DATA_TEMPLATE: '店舗設備データフォーム',
    STORE_FIELD_CONFIGURATION: '店舗のフィールド構造',
    STORE_ID: '店舗ID',
    STORE_INFORMATION: '店舗情報',
    STORE_INSPECTION_REPORT_EDIT: '店舗検査レポートの変更',
    STORE_LONGITUDE_INPUT_IS_WRONG: 'プロップ経度入力が間違っています',
    STORE_MANAGEMENT: '店舗管理',
    STORE_MONITORING: '店舗モニタリング',
    STORE_MONITORING_LIST: '店舗監察リスト',
    STORE_NAME: '店舗名',
    STORE_NAME_ALREADY_EXISTS: '店舗名が既に存在しています',
    STORE_NAME_CANNOT_BE_EMPTY: '店舗名を必ず入れてください',
    STORE_PHONE: '店舗電話',
    STORE_POSTCODE_ENTERED_INCORRECT_VALUE: 'プロップ郵便番号が間違った値を入力しました',
    STORE_REPAIR_CODE_MANAGEMENT: '店舗修理コード管理',
    STORE_REPAIR_SPECIALIST_WILL_BE_GENERATED_LATER: 'ショップ修理スペシャリストは後で生成されます',
    STORE_STOREID_DOES_NOT_BELONG_TO_THE_BUSINESS: '店舗IDはこの企業に属していません',
    STORE_TYPE_DETAILS: '店舗タイプの詳細',
    STORE_TYPE_INFORMATION: '店舗タイプ情報',
    STORE_TYPE_NAME: '店舗タイプ名',
    STORE_TYPE_NUMBER: '店舗タイプ番号',
    STORES_CANNOT_ADD_SUBORDINATE_ORGANIZATIONS: '店舗には下級組織の追加ができません',
    STRING: '文字列',
    STUDYTIME: '学習時間',
    SUB_ACCOUNT: '子アカウント',
    SUBHEADINGS: '小見出し',
    SUBMIT_CONTENT: 'コンテンツを送信する',
    SUBORDINATE_POSITIONS: '部下の役職',
    SUBSTANDARD_SCORE: '未達得点',
    SUCCESS: '成功',
    SUCCESSFUL_OPERATION: '操作に成功しました',
    SUCCESSFUL_OPERATION1: '操作に成功しました',
    SUCCESSFUL_RECOVERY: '回復に成功しました',
    SUCCESSFUL_SYNCHRONIZATION: '同期に成功しました',
    SUCCESSFULLY_DELETED: '削除に成功しました',
    SUCCESSFULLY_DELETED_JOB: '職位の削除ができました',
    SUCCESSFULLY_DELETED1: '削除に成功しました',
    SUCCESSFULLY_DELETED2: '削除できました',
    SUCCESSFULLY_MODIFIED: '修正できました',
    SUCCESSFULLY_MODIFIED1: '正常に変更されました',
    SUIJIE_TECHNOLOGY: '水傑技術',
    SUNDAY: '日曜日',
    SUPERIOR: '上級',
    SUPERIOR_AREA: '上位地域',
    SUPERIOR_SELECTION: '管理職の選択',
    SUPPLIER_ALIAS: 'ベンダー別称',
    z_info_common_000005: 'ベンダー名',
    SUPPLIER_CLASSIFICATION: '仕入先分類',
    SUPPLIER_CONTACT_INFORMATION: 'サプライヤーの連絡先情報',
    SUPPLIER_DATA_IMPORT: 'ベンダーデータをインポートする',
    SUPPLIER_DATA_TEMPLATE: '仕入先データテンプレート',
    SUPPLIER_INFORMATION: '仕入先情報',
    SUPPLIER_MANAGEMENT: '仕入先管理',
    SUPPLIER_NAME: '仕入先名称',
    SUPPLIER_NAME1: 'サプライヤー名',
    SUPPORTS_DOWNLOADING_UP_TO_50_DOCUMENTS_AT_THE_SAME_TIME: '同時にダウンロードできるファイル数はマックス50個以内となる',
    SURNAME: '苗字',
    SWITCH_LANGUAGE: '言語切り替え',
    SYNC_FAILED: '同期に失敗しました',
    SYNCHRONIZED_EASY_TO_UNDERSTAND_DATA: 'データを理解しやすいプロップ',
    SYSTEM_HINT: 'システムヒント',
    SYSTEM_NAME: '情報管理プラットフォーム',
    HOME_PAGE: 'ホームページ',
    SELECT_EXPORT_FIELD: 'エクスポートフィールドの選択',
    SELECT_VIEW: '読み取り用にエクスポート',
    EXPORT_FOLLOW_UP: 'エクスポート',
    CURRENT_SELECT_FIELD: '選択フィールド',
    PARENT_ORGANIZATION_NAME: '親組織名',
    WHETHER_ALLOW_MULTIPLE_PEOPLE: '複数ユーザー',
    HAVE_A_JOB: '投稿しますか？',
    EXPORT_SUCCESSFULLY: 'エクスポートされました',
    SYSTEM_NOTIFICATION: 'システム通知',
    SYSTEM_REMINDER: 'システムリマインダー',
    TAG_ID: 'タグID',
    TASK_TYPE: 'タスクの種類',
    TASK_TYPE_EDIT: 'タスクの種類の変更',
    TEMPLATE_ALREADY_EXISTS: 'テンプレートは既に存在します',
    TEMPLATE_DATA_IMPORT: 'テンプレートデータのインポート',
    TEMPLATE_DOES_NOT_EXIST: 'テンプレートは存在しません',
    TEMPLATE_EDITING: 'フォーム編集',
    TEMPLATE_NAME: 'テンプレート名',
    TEMPLATE_NAME_CANNOT_BE_EMPTY: 'プロップ名は空にできません',
    TEMPLATE_NUMBER: 'フォームナンバー',
    TEMPLATE_SETTINGS: 'テンプレート設定',
    TEMPLATE_TYPE: 'テンプレートタイプ',
    TEST_PAPER_DESCRIPTION: '答案用紙の説明',
    TEST_PAPER_INFORMATION: '答案用紙情報',
    TEST_PAPER_LIST: '答案用紙のリスト',
    TEST_PAPER_NAME: 'コース名',
    TEST_PAPER_NUMBER: 'コース番号',
    TEST_PAPER_NUMBER1: '試験紙ナンバー',
    TEST_PAPER_REMINDER: '答案用紙のリマインダ',
    TEST_PAPER_TYPE: '答案用紙のタイプ',
    TEST_SCORE: '試験得点',
    TEXT: 'テキスト',
    TEXT_CONTENT_CANNOT_BE_EMPTY: 'プロップの内容は空にできません',
    THE_ACCOUNT_DOES_NOT_EXIST: 'このアカウントが見つかりませんでした',
    THE_AREA_NAME_DOES_NOT_EXIST: 'エリアの名前は存在しません',
    THE_BASIC_DATA_IS_INCOMPLETE_PLEASE_MAINTAIN_THE_STORE_CATEGORY: '基本データが不完全です。ストアカテゴリを維持してください',
    THE_BASIC_DATA_IS_INCOMPLETE_PLEASE_MAINTAIN_THE_STORE_TYPE: '基本データが不足しています。店舗分類を正しく入れてください。',
    THE_BRAND_NAME_DOES_NOT_EXIST: 'ブランド名は存在しません',
    THE_CLASSIFICATION_OF_THE_TRANSFER_IN_USE_CANNOT_BE_DELETED: 'このハンドオーバ分類は使用中です。削除できません！',
    THE_COMPANY_CAN_ADD_PEOPLE_FULL: 'この会社の追加可能人数はゼロです',
    THE_COMPANY_HAS_INSUFFICIENT_REMAINING_ADDABLE_STORES: '本会社の下には店舗の追加可能数量が足りません',
    THE_COMPANY_HAS_INSUFFICIENT_REMAINING_PERSONNEL_TO_ADD: 'この会社の追加可能人数は足りません',
    THE_CORRESPONDING_DEVICE_CODE_ALREADY_EXISTS_UNDER_THE_DEVICE_TYPE: '対応するデバイスコードはデバイスタイプの下にすでに存在します',
    THE_COURSEWARE_YOU_UPLOADED_IS_NOT_A_STANDARD_FORMAT: 'アップロードしたいファイルが標準フォーマットではありません',
    THE_CUSTOMER_DOES_NOT_EXIST: 'プロップ顧客は存在しません',
    THE_DATA_IS_INCORRECT_PLEASE_VERIFY: 'データが正しくありません。確認してください。',
    THE_DATA_IS_NOT_IMPORTED_PLEASE_WAIT: 'データはまだインポートされていません。しばらくお待ちください！',
    THE_DATA_IS_WRONG: 'データが間違っています',
    THE_DATA_IS_WRONG_DO_YOU_WANT_TO_DOWNLOAD_AND_VIEW_THE_PROMPT_FILE: 'データエラー、ヒントファイルをダウンロードしますか？',
    THE_DEALER_CATEGORY_BEING_USED_CANNOT_BE_DELETED: '使用中のディストリビューター分類は削除できません！',
    THE_DEALER_NAME_DOES_NOT_EXIST: 'ディーラー名が存在しません',
    THE_DEVICE_NAME_DOES_NOT_HAVE_A_CORRESPONDING_DEVICE_CODE: 'デバイス名に対応するデバイスコードがありません',
    THE_DEVICE_TYPE_AND_THE_CORRESPONDING_DEVICE_CODE_ALREADY_EXIST: 'この設備に該当する設備ナンバーはすでに存在しています',
    THE_DIRECTORY_NAME_IS_INCORRECT: 'プロップのディレクトリ名が正しくありません',
    THE_DOCUMENT_CLASSIFICATION_IN_USE_CANNOT_BE_DELETED: '使用中の文書分類は削除できません！',
    THE_ENGLISH_NAME_OF_THE_ITEM_UNDER_THE_SAME_ITEM_CATEGORY_CANNOT_BE_REPEATED: '同じアイテムカテゴリにあるアイテムの英語名を繰り返すことはできません。',
    THE_ENTRY_NAME_ALREADY_EXISTS_UNDER_THE_SAME_TEMPLATE_CATEGORY: 'エントリ名は同じテンプレート分類に既に存在します',
    THE_ENTRY_NUMBER_ALREADY_EXISTS_UNDER_THE_SAME_TEMPLATE_CATEGORY: '同じテンプレート分類のエントリ番号は既に存在します',
    THE_FILE_ID_YOU_WANT_TO_MODIFY_IS_WRONG_PLEASE_TRY_AGAIN_LATER: '変更するファイルIDが間違っています。しばらくしてからもう一度お試しください',
    THE_FILE_TYPE_YOU_ARE_TRYING_TO_MODIFY_IS_INCORRECT_PLEASE_TRY_AGAIN_LATER: '変更するファイルのタイプが間違っています。しばらくしてからもう一度お試しください',
    THE_INPUT_VALUE_IS_NOT_IN_THE_VALID_RANGE: '入力値が有効な範囲内にありません',
    THE_LEVEL_DOES_NOT_MATCH_THE_SUPERIOR_LEVEL: '階層が上位階層と一致しません',
    THE_MAINTENANCE_CODE_IS_BEING_GENERATED_PLEASE_REFRESH_THE_PAGE_LATER_TO_VIEW: 'メンテナンスコードが生成されています。ページを更新して後で表示してください',
    THE_MANUAL_NAME_ALREADY_EXISTS: 'プロップのマニュアル名は既に存在します',
    THE_MAXIMUM_LENGTH_MUST_BE_GREATER_THAN_0: '最大長さが必ず０以上にしてください',
    THE_NAME_CANNOT_BE_REPEATED_UNDER_THE_SAME_LEVEL: '同じ上位名を繰り返すことはできません',
    THE_NAME_OF_THE_PARENT_ORGANIZATION_CANNOT_BE_EMPTY: '親組織の名前は空にできません',
    THE_NAME_OF_THE_SAME_CLASS_CANNOT_BE_THE_SAME: '同じカテゴリの名前を同じにすることはできません。',
    THE_NAME_OF_THE_SUPERIOR_AREA_DOES_NOT_EXIST: '上位エリアの名前は存在しません。',
    THE_NAMES_OF_MAINTENANCE_FAULTS_UNDER_THE_SAME_MAINTENANCE_FAULT_CLASSIFICATION_ARE_NOT_ALLOWED_TO_BE_DUPLICATED: '同じメンテナンス障害分類に基づくメンテナンス障害の名前を繰り返すことはできません。',
    THE_NAMES_OF_PASSENGER_FLOW_CHANNELS_UNDER_THE_SAME_STORE_ORGANIZATION_CANNOT_BE_DUPLICATED: '同じ店舗組織の乗客フローチャネルの名前は重複できません。',
    THE_NUMBER_OF_STORE_FLOOR_PLANS_HAS_REACHED_THE_UPPER_LIMIT_AND_A_MAXIMUM_OF_TEN_STORE_FLOOR_PLANS_CAN_BE_UPLOADED: '店舗平面図の数量がマックス10枚しかアップロードできません',
    THE_ORGANIZATION_DOES_NOT_EXIST: 'プロップ組織は存在しません',
    THE_ORGANIZATION_NAME_DOES_NOT_EXIST: '組織名が存在しません',
    THE_OTHER_PARTY_HAS_BEEN_DELETED: '相手がすでに削除済み',
    THE_OTHER_PARTY_IS_FROZEN: '相手が凍結済み',
    THE_PARENT_ORGANIZATION_CANNOT_BE_THE_CURRENT_ORGANIZATION: '上級組織が今の組織であってはならない',
    THE_PASSWORD_YOU_SET_IS_A_SECURITY_RISK_PLEASE_RESET_IT: '設定したパスワードはセキュリティ上のリスクがあるため、リセットしてください',
    THE_PHONE_NUMBER_IS_INCORRECT: '携帯番号を正しく入力してください',
    THE_PHONE_NUMBER_USER_ALREADY_EXISTS: '電話番号ユーザーは既に存在します',
    THE_PRODUCT_NAME_DOES_NOT_EXIST: '製品名が存在しません',
    THE_ROLE_DOES_NOT_ALLOW_MULTIPLE_PEOPLE_TO_TAKE_OFFICE: 'この役割を複数の人に割り当てることはできません',
    THE_ROLE_DOES_NOT_EXIST: 'プロップの役割が存在しません',
    THE_ROLE_DOES_NOT_EXIST_UNDER_THE_ORGANIZATION: '役割は組織の下に存在しません',
    THE_ROLE_NAME_ALREADY_EXISTS: 'このロール名はすでに使われています',
    THE_ROLE_NAME_ALREADY_EXISTS1: 'プロップの役割名が既に存在します',
    THE_ROLE_OF_SETTING: 'キャラクター設定',
    THE_SAME_ENTRY_NAME_OR_SERIAL_NUMBER_EXISTS_IN_THE_SAME_TEMPLATE_CATEGORY: '同一フォームの分類には同じ条目名称若しくはシリアル番号があります',
    THE_SERIAL_NUMBER_CAN_ONLY_BE_NUMERIC_OR_EMPTY: 'シリアル番号は数値またはnullのみです',
    THE_SHOP_DOES_NOT_EXIST: 'プロップの店舗が存在しません',
    THE_SHOP_DOES_NOT_EXIST1: 'プロップの店舗が存在しません',
    THE_SHOP_NUMBER_ALREADY_EXISTS: 'プロップの店舗番号は既に存在します',
    THE_SHOP_TYPE_DOES_NOT_EXIST: 'ショップタイプが存在しません',
    THE_SINGULAR_THE_NUMBER_OF_PRODUCTS_AND_THE_TOTAL_SALES_CANNOT_BE_EMPTY_AT_THE_SAME_TIME: '単数、製品数、および総売上を同時に空にすることはできません。',
    THE_SIZE_OF_YOUR_UPLOADED_IMAGE_IS: 'アップロードする画像サイズがXXXです？',
    THE_START_TIME_CANNOT_BE_LESS_THAN_THE_FILING_DATE: '開始時間は出願日よりも短くすることはできません。',
    THE_STATISTICAL_DATE_CANNOT_BE_GREATER_THAN_THE_CURRENT_DATE: '統計の日付は現在の日付よりも大きくてはならない',
    THE_STATISTICAL_DATE_CANNOT_BE_LESS_THAN_THE_FILING_DATE: '統計日は出願日よりも前であってはならない',
    THE_STOCK_QUANTITY_CANNOT_BE_EMPTY: '入庫数は必ず入れてください',
    THE_STORE_DIMENSION_INPUT_VALUE_IS_INCORRECT: '店舗分析コードの入力値が間違っています',
    THE_STORE_DOES_NOT_EXIST: 'プロップの店舗が存在しません',
    THE_STORE_LANGUAGE_TYPE_DOES_NOT_EXIST: '店舗言語の種類が存在しません',
    THE_STORE_MAILBOX_INPUT_VALUE_IS_INCORRECT: '間違った郵便番号',
    THE_SUPERIOR_CLASSIFICATION_DOES_NOT_EXIST: '上位カテゴリはありません',
    THE_SUPPLIER_CATEGORY_BEING_USED_CANNOT_BE_DELETED: '使用済みの仕入先カテゴリで削除しないでください',
    THE_SUPPLIER_DOES_NOT_EXIST: 'サプライヤーコードが存在しません',
    THE_TOTAL_NUMBER_OF_DAYS_FOR_THE_TEMPLATE_STORE_MUST_BE_GREATER_THAN_0: '日数は0より大きくなければなりません',
    THE_TOTAL_NUMBER_OF_DAYS_IN_THE_TEMPLATE_STORE_MUST_BE_A_NUMERIC_TYPE: '日数は数字でなければなりません',
    THE_TRACKING_NUMBER_OF_THE_ITEM_ALREADY_EXISTS: '追跡番号が重複しています',
    THE_UPLOAD_DIRECTORY_DOES_NOT_EXIST: 'アップロードされたカタログは存在しません',
    THE_UPLOAD_DIRECTORY_DOES_NOT_HAVE_WRITE_PERMISSION: 'アップロードされたカタログに承認が設定されていません',
    THE_UPLOAD_FILE_SIZE_EXCEEDS_THE_LIMIT: 'ファイルサイズが制限を超えています',
    THE_UPPER_CLASSIFICATION_HAS_DUPLICATE_DATA: '上位カテゴリの重複データ',
    THE_USER_ALREADY_HAS_THE_POSITION: 'そのポジションはユーザーによって取得されました',
    THE_USER_ENTERED_THE_MAILBOX_INCORRECTLY: '間違った登録メール',
    THE_USERS_WORK_MAILBOX_INPUT_VALUE_IS_INCORRECT: '間違った仕事用メール',
    THE_VALUE_ENTERED_ON_THE_SHOP_OPENING_DATE_IS_INCORRECT: '間違った店舗開店日',
    THE_VALUE_OF_THE_LAST_RENOVATION_DATE_IS_INCORRECT: '間違った改修日',
    THE_WORD_COUNT_EXCEEDS_200_WORDS: '200を超える単語数',
    THE_WRONG_ITEM_CLASSIFICATION_LEVEL_IS_SELECTED: '間違った分類レベルが選択されました',
    THE_YEAR_OF_BIRTH_CANNOT_EXCEED_THE_CURRENT_YEAR: '出生年を未来にはなりえません',
    THERE_ARE_NO_COMMODITIES_UNDER_THE_CATEGORY: 'カテゴリの下に製品がありません',
    THERE_IS_DUPLICATE_DATA_IN_EXCEL: 'Excelファイル内のデータの重複',
    THERE_IS_NO_SUCH_CHANNEL_NUMBER_UNDER_THE_STORE: 'このチャンネル番号は店舗に属していません',
    THERE_IS_NO_SUCH_SUBCATEGORY_UNDER_THE_BIG_CATEGORY: 'このサブカテゴリは存在しません',
    THIS_ALREADY_EXISTS_IN_EXCEL: 'エクセルにすでに存在しています',
    THIS_BRAND_HAS_BEEN_ASSIGNED_A_STORE_AND_CANNOT_BE_DELETED: 'ブランドは店舗に割り当てられており、削除できません',
    THIS_FUNCTION_DOES_NOT_SUPPORT_FOLDERS: 'フォルダーはサポートされていません',
    THIS_FUNCTION_IS_ONLY_SUPPORTED_FOR_THE_SUPPLIER_WHOSE_SERVICE_TYPE_IS_SHOP_REPAIR: 'この機能は、サービスタイプが店舗修理であるサプライヤーに対してのみサポートされています',
    THIS_ITEM_CANNOT_ADD_ORGANIZATION: '該当項目には組織を追加することができません',
    THIS_POSITION_DOES_NOT_EXIST: 'このポジションは存在しません',
    THIS_PRODUCT_IS_USED_AND_CANNOT_BE_DELETED: 'この製品は使用されており、削除できません',
    THIS_USER_DOES_NOT_EXIST: 'このユーザーは存在しません',
    THRESHOLD: '閾値',
    THRESHOLD_MODE: '閾値モード',
    THRESHOLD1: '閾値',
    THURSDAY: '火曜日',
    TICKETS: '客の数',
    TIME: '時間',
    TITLE: '標題',
    TITLE_CONTENT: '問題の内容',
    TITLE_DESCRIPTION: 'タイトル説明',
    TITLE_DETAILS: '題目の詳細',
    TITLE_PICTURE: '画像タイトル',
    TITLE1: 'タイトル名',
    TO: 'まで',
    TO1: 'まで',
    TOTAL_NUMBER_OF_DAYS_WITH_TEMPLATE_SHOP: 'テンプレート店舗での合計日数',
    TOTAL_NUMBER_OF_MATTERS: '総件数',
    TOTAL_NUMBER_OF_STAGES: '総ステージ数',
    TOTAL_PASSENGER_FLOW: 'トータル客数',
    TOTAL_SALES: '売り上げ総額',
    TOTAL_SALES_AMOUNT: '売上総額',
    TOTAL_SCORE_IS_SHOWN_AS: '合計スコアは',
    TOTAL_TRANSACTION: '取引総額',
    TOTAL_TRANSACTIONS: '取引総数',
    TRADITIONAL_CHINESE: '繁体字中国語',
    TRADITIONAL_CHINESE1: '繁体字中国語',
    TRANSFER_RECORD_CATEGORY: '交替履歴類別',
    TRANSFER_THIS_CATEGORY: '日誌分類',
    TREE_MENU_BASIC_DATA: 'ツリーメニューの基本データ',
    TURN_ON: '開く',
    TURN_ON_THE_WATERMARK_ON_THE_SCREEN_OF_THE_MOBILE_PHONE: '携帯電話の画面の透かしをオンにする',
    TURN_ON_TOP_SORT: 'トップソートをオンにする',
    TURNOVER: '実際売価',
    TYPE_CONVERSION_FAILED_TYPE_CANNOT_BE_CONVERTED: '種別の変換に失敗しました、種別を変換できません',
    TYPE_ENCODING: 'タイプコード',
    TYPE_ENGLISH_NAME: '分類の英文名称',
    TYPE_ID: '分類番号',
    TYPE_INFORMATION: 'タイプ情報',
    TYPE_NAME: 'タイプ名',
    TYPE_NUMBER: '分類番号',
    TYPE_OPERATION: '分類操作',
    TYPES_OF: 'タイプ',
    UNFREEZE: '凍結解除',
    UNIT: '単位',
    UNIT_PRICE: '単価',
    UNKNOWN_MISTAKE: '未知エラー',
    UNKNOWN_MISTAKE1: '未知の間違い',
    UNLIMITED: '無制限',
    UNLIMITED_CATEGORIES: '無制限のカテゴリー',
    UNLIMITED_ORGANIZATION: '無制限の組織',
    UNLOCKED: 'アンロック',
    UNPIN: '解除',
    UNQUALIFIED_SCORE: '不合格点',
    UNSPECIFIED: '未指定',
    UNSUCCESSFUL: '失敗',
    UNSUCCESSFUL_DATA: '失敗したデータ',
    UPDATE_COMPLETED: 'アップロードが完了しました',
    UPDATE_COMPLETED1: '更新ができました',
    UPDATE_DATA: 'データ更新',
    UPDATE_FAILED: 'アップロードに失敗しました',
    UPDATE_FAILED1: '更新ができませんでした',
    UPDATE_FAILED2: 'アップロードに失敗しました',
    UPDATE_MULTILINGUAL: '多言語更新',
    UPLOAD: 'アップロード',
    UPLOAD_ATTACHMENT: 'レッスンの添付',
    UPLOAD_DATE: 'アップロード日',
    UPLOAD_FAILED: 'アップロードできませんでした',
    UPLOAD_FAILED1: 'アップロードに失敗しました',
    UPLOAD_FAILED2: 'アップロードに失敗しました',
    UPLOAD_FILE_NOT_FOUND: 'アップロードファイルが見つかりません',
    UPLOAD_FILES: 'アップロードファイル',
    UPLOAD_IMAGE: '画像をアップロード',
    UPLOAD_INFORMATION: 'アップロードデータ',
    UPLOAD_LIMIT: 'アップロード制限',
    UPLOAD_OF_STORE_ATTACHMENT_FAILED: '店舗の添付ファイルのアップロードに失敗しました',
    UPLOAD_SHOP_ATTACHMENT: '店舗の添付ファイルのアップロード',
    UPLOAD_TIME: 'アップロードタイム',
    UPLOAD_TRAINING_MATERIALS: 'トレーニングデータをアップロードする',
    UPLOADED_BY: 'アップロード者',
    UPLOADED_DATA_EXCEEDS: 'アップロードされたデータが超えています',
    UPLOADED_SUCCESSFULLY: 'アップロードできました',
    UPLOADING_TRAINING_MATERIALS_FAILED: 'トレーニングデータのアップロードができませんでした',
    USE_DETAILS: '使用詳細',
    USER: 'ユーザー',
    USER_AGREEMENT: 'ユーザー同意書',
    USER_AGREEMENT_UPLOAD: 'ユーザー同意書のアップロード',
    USER_CANCELED_OPERATION: 'ユーザーが操作の取り消しを行う',
    USER_DATA_IMPORT: 'ユーザーデータのインポート',
    USER_ID: 'ユーザーID',
    USER_JOB_INFORMATION_IMPORT: 'ユーザー任職情報のインポート',
    USER_REFERENCE: 'ユーザー参照',
    USER_REFERENCE_IN_USE_CANNOT_BE_DELETED: '使用中のユーザー参照は削除できません！',
    USER_TYPE: 'ユーザータイプ',
    ExcelTemplate_common_000013: 'ユーザータイプ',
    USERNAME: 'ユーザー名',
    USERS_IN_EXCEL_CANNOT_REPEAT_THE_SAME_POSITION: 'ユーザーはExcelで同じ位置を繰り返し保持することはできません',
    VALID_UNTIL: 'まで有効',
    VALUE: '数値',
    VALUE_ELEMENT: '値要素',
    VENDOR_TYPE_NAME: '仕入先タイプ',
    VENDOR_TYPE_NUMBER: '仕入先タイプ番号',
    VERIFICATION_CODE: '検証コード',
    VIEW: 'チェック',
    VIEW_REPAIR_CODE: '修理コードの表示',
    VIEW_SERVICE_CODE: 'サービスナンバー',
    VISUAL_DISPLAY: 'ビジュアル陳列',
    m_info_common_000020: 'ディスプレイ表示',
    VISUAL_DISPLAY_RECORD: 'ビジュアルディスプレイの記録',
    VOIP_CALL_HISTORY: 'VOIP通話履歴',
    WAREHOUSE: '倉庫',
    WAREHOUSE_IN_THIS_ISSUE: '当期入荷',
    WEATHER_CODE: '天気コード',
    WEEK: '週',
    WEIGHTS: '重さ',
    WEIGHTS1: '重量',
    WELCOME_STRING: 'こんにちは',
    WELCOME_STRING1: 'こんにちは',
    WHETHER_ADMINISTRATOR: '管理者か否か',
    WHETHER_COMPLETED: '完成するか否か',
    WHETHER_GIVEAWAY: 'プレゼントかどうか',
    WHETHER_LOCKED: 'ロックまたはロック解除',
    WHETHER_LOGIN_PROTECTION: 'ログイン保護か否か',
    WHETHER_PROJECT_MANAGER: 'プロジェクト管理者か否か',
    WHETHER_SUCCEED: 'できましたか',
    WHETHER_THE_PROBLEM_DESCRIPTION_IS_REQUIRED: '問題の説明は必要ですか？',
    WHETHER_THE_SUPPLIER_INSTALLS: 'ベンダーインストールですか',
    WHETHER_TO_CONFIRM_THE_REPAIR_CODE: '修復コードを復元することを確認します',
    WHETHER_TO_CONNECT: 'アクセスできましたか',
    WHETHER_TO_ENABLE: '有効にするかどうか',
    WHETHER_TO_MODIFY_THE_SCORE_MUST_NOT_BE_EMPTY: 'スコアは修正/空にすることができます、確認しますか？',
    WHETHER_TO_SELL: '販売するかどうか',
    WHETHER_TO_STICK: '貼り付けるかどうか',
    WITHOUT_THE_MANUAL_ID: '手動IDなし',
    WITHOUT_THE_PRIMARY_KEY_ID: 'プライマリーキーIDなし',
    WORK_EMAIL: 'オフィスEメールアドレス',
    WORK_INFO: '仕事情報',
    WORK_SHOP_WITH_SHOP_TEMPLATE: '店舗テンプレートつきワークショップ',
    WORKING_ADDRESS: 'オフィス住所',
    WORKING_AGE: '勤務年数',
    WRONG_BIRTHDAY_FORMAT: '間違った誕生日の形式',
    YEAR: '年',
    YEAR_OF_BIRTH: '生まれ年',
    YES: 'はい',
    YOU_ARE_NOT_USING_IE8_OR_ABOVE_IT_MAY_CAUSE_COMPATIBILITY_PROBLEMS_AND_PREVENT_YOU_FROM_USING_IT_NORMALLY: 'お使いになっているシステムがIE8以下の場合、互換性問題で、正常に動作しない場合もあります。',
    YOU_HAVE_NOT_SELECTED_A_NODE: 'まだ削除する点を選択していません。',
    YOU_HAVE_NOT_SELECTED_THE_PARENT_FOLDER: '親フォルダを選択していません。',
    APPLY_FOR_REPAIRS: '修理申請のために写真を提出する',
    MUSTPROPACCEPTANCESCORE: 'アイテム受け入れスコアは必要ですか？',
    MUSTPROPCONTENT: 'アイテムの説明が必要ですか？',
    PROPACCEPTANCEIMGCOUNT: '備品受取りの写真の構成',
    PROPS_MODULE_CONFIGURATION: 'アイテムモジュールの構成',
    HISTORICAL_RATE: '過去のレート',
    ADD_FAILED_THE_FORM_NAME_ALREADY_EXISTS: '追加に失敗しました。 フォーム名は既に存在します',
    ADD_FORM: 'フォームの追加',
    BOOLEAN: 'ブール',
    CALCULATION_FORMULA: '計算式',
    CATEGORY_DEFAULT_VENDOR_INVALID: '変更したカテゴリの制限により、以下のカテゴリのデフォルトの仕入先が無効になっています。手動で設定してください。',
    CHECKBOX: 'チェックボックス',
    COMPANY: '会社',
    CONTROL_DESCRIPTION: 'コントロールの説明',
    CONTROL_DESCRIPTION1: 'コントロールの説明',
    CONTROL_NAME: 'コントロール名',
    CONTROL_TYPE: 'コントロールタイプ',
    COUNTRY_NUMBER: '国コード',
    CURRENT_EXCHANGE_RATE: '現在の為替レート',
    CUSTOM_REFERENCE: 'カスタム参照',
    DATA_IMPORT: 'インポートデータ',
    DATE_CONTROL: '日付管理',
    DATE_TYPE: '日付タイプ',
    DECIMAL_PLACES1: '小数点',
    DEFAULTS: 'デフォルト値',
    DELETE_FORM: 'フォームの削除',
    DROP_DOWN_BOX: 'ドロップダウンボックス',
    ENUMERATION: '列挙型',
    FILE_UPLOAD_CONTROL: 'ファイルアップロードコントロール',
    FORM_DESCRIPTION: 'フォームの説明',
    FORM_DETAILS: 'フォームの詳細',
    FORM_NAME: 'フォーム名',
    FORM_NAME_CONTAINS_ILLEGAL_CHARACTERS_ONLY_ALPHANUMERIC_AND_UNDERSCORES_ARE_ALLOWED: '無効なフォーム名です。 フォーム名には下線と英数字のみを含める必要があります',
    FORM_TITLE: 'フォームタイトル',
    IF_YOU_DELETE_THE_TEMPLATE_ALL_THE_QUESTIONS_IN_THE_TEMPLATE_WILL_BE_DELETED_TOGETHER_ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT: 'テンプレートを削除すると、テンプレート内のすべての質問が一緒に削除されます。 本当に削除しますか？',
    IMPORT_FORM: 'インポートフォーム',
    INPUT_CHARACTERS_DO_NOT_MEET_REQUIREMENTS: '入力した文字が要件を満たしていません。',
    IS_EMPTY: '空欄を許可しますか？',
    MAX: '最大値',
    MINIMUM_VALUE: '最小値',
    NO_PICTURE: '画像なし',
    NOTE_CURRENTLY_ONLY_SUPPORTS_XLS_FORMAT: '注: サポートできるのは .xls 形式のみです',
    OPTIONAL_ROLE: 'オプションのロール',
    PICTURE_UPLOAD_CONTROL: '画像アップロードコントロール',
    PRIORITY_HIGHLIGHTING: '優先度のハイライト',
    PUBLISHED_SUCCESSFULLY: '正常にリリースされました',
    REFERENCE_TYPE: '参照タイプ',
    RELEASE: 'リリース',
    SELECTED_ROLES: 'ロールの選択',
    SEQUENCE: 'オーダー',
    STANDARD_MODE1: '標準モード (すべてのエントリーの合計)',
    STORE_INFO: '店舗情報',
    SYSTEM_REFERENCE: 'システム参照',
    TASK_CENTER: 'タスクセンター',
    TEXT_BOX: 'テキストボックス',
    THE_MAXIMUM_AND_MINIMUM_RANGE_IS_2147483648_TO_2147483647: '最大値と最小値の範囲は-2147483648〜2147483647です',
    THE_MAXIMUM_LENGTH: '最大長',
    THRESHOID_MODE1: '閾値モード（サブ項目のスコアに応じて、主要なカテゴリーが標準を満たすかどうかを判断します）',
    TIME_CONTROL: '時間範囲',
    TIME_TYPE: '時間タイプ',
    TOUR_CATEGORY: 'チェックリストカテゴリー',
    TYPE_OF_DATA: 'データタイプ',
    UPDATE_TIME: '更新時間',
    WHETHER_TO_ALLOW_NULL: '空欄を許可しますか？',
    WHETHER_TO_DISPLAY_THE_LIST: 'ディスプレイリストですか？',
    WHETHER_TO_SHOW: 'ディスプレイですか？',
    WORK_SHOP_WITH_SHOP: '店舗プロジェクト',
    r_info_common_000022: 'ストアをオープンする',
    d_info_common_000022: '開店',
    YZAPPID: 'YZAPPID',
    z_info_common_000001: 'シリアル番号が重複しています。',
    z_info_common_000004: '決済を完了してください',
    z_info_common_000009: '技術者の再派遣',
    z_info_common_000010: 'リマインダーの受信',
    z_info_common_000011: 'ユーザーのコメント',
    z_info_common_000012: '注文のキャンセル',
    z_info_common_000013: 'メンテナンス申請が完了しました',
    z_info_common_000014: '再派遣（技術者の選択）',
    z_info_common_000015: '保留中のメンテナンス申請',
    z_info_common_000016: '新規メンテナンス申請',
    z_info_common_000017: '簡易リマインダー',
    z_info_common_000018: '注文の作成',
    z_info_common_000019: 'メンテナンス案の差戻し',
    z_info_common_000020: '差戻し',
    z_info_common_000021: '承認期日のリマインダー',
    z_info_common_000022: '再派遣（情報の入力）',
    z_info_common_000023: 'メンテナンス案の提出',
    z_info_common_000024: 'メンテナンス案の差戻し',
    z_info_common_000025: '発送期日のリマインダー',
    z_info_common_000026: '修理差戻しメール',
    z_info_common_000027: 'メンテナンス申請のキャンセル',
    z_info_common_000028: '差戻し',
    z_info_common_000029: '承認',
    z_info_common_000030: '注文完了',
    z_info_common_000031: 'メンテナンス申請レビュー',
    z_info_common_000032: 'メンテナンス案の確認',
    z_info_common_000033: '価格の問い合わせ',
    z_info_common_000034: '決済完了の提出',
    z_info_common_000035: '決済完了の確認',
    z_info_common_000036: '決済完了の差戻し',
    z_info_common_000037: 'スタートアップメンテナンスプロジェクト',
    z_info_common_000038: 'ユーザー情報が見つかりません',
    z_info_common_000039: 'アカウントが削除されました。 以前のレコードを復元しますか？',
    z_info_common_000040: 'アカウントを復元',
    z_info_common_000041: '新しいアカウントを追加',
    z_info_common_000042: '復元したいアカウントを選択してください',
    z_info_common_000043: '復元したいアカウントの場所を選択してください',
    z_info_common_000044: '削除された情報',
    z_info_common_000006: 'スターの店舗言語',
    z_info_common_000007: 'スターの既定通貨',
    z_info_common_000008: 'GPS',
    USER_ADDED_SUCCESS_MESSAGE: 'アカウント番号と初期パスワードがSMS経由でユーザーに送信されました',
    z_info_common_000045: '備品管理設定',
    z_info_common_000046: '自動完了を許可しますか？',
    z_info_common_000047: '承認後',
    z_info_common_000048: '再発行しますか？',
    z_info_common_000049: '日',
    z_info_common_000050: 'カメラ情報',
    z_info_common_000051: 'プラットフォームタイプ',
    z_info_common_000052: 'アクセスタイプ',
    z_info_common_000053: 'カメラコード',
    z_info_common_000054: '端末シリアル番号',
    z_info_common_000055: '地域',
    z_info_common_000056: 'カメラ名',
    z_info_common_000057: 'カメラリンク',
    z_info_common_000058: 'チャンネル番号',
    z_info_common_000059: '端末確認コード',
    z_info_common_000060: 'カメラ管理',
    z_info_common_000061: '同じカメラの使用はできません',
    z_info_common_000062: 'カメラ番号は重複できません',
    z_info_common_000063: 'リンクモードで再生可能なカメラのライブブロードキャストのリンクアドレス',
    z_info_common_000064: '申請は、更新サイトをご参照ください',
    z_info_common_000065: '申請は、更新サイトをご参照ください',
    z_info_common_000066: '端末のシリアル番号',
    z_info_common_000067: '端末確認コードは、本体に記載されている大文字6英数字です',
    z_info_common_000068: '採用日',
    z_info_common_000069: '閉店店舗',
    z_info_common_000070: 'メールアドレスが重複しています。再度確認してください。',
    z_info_common_000072: '関連しているメンテナンスカテゴリーを削除してください',
    z_info_common_000071: '関連しているメンテナンス問題を削除してください',
    z_info_common_000073: '同じ問題カテゴリにできません',
    z_info_common_000074: 'ディスプレイ位置',
    z_info_common_000075: '店舗配送',
    z_info_common_000076: '国/地域',
    z_info_common_000077: '閉店時刻',
    z_info_common_000078: '採用日の形式が間違っています',
    z_info_common_000079: '閉店時刻は現在時刻より遅くすることはできません',
    z_info_common_000080: '組織カテゴリーが存在しません',
    z_info_common_000081: '払い戻しを申請します',
    z_info_common_000082: '在庫の無い商品の申請を許可します',
    z_info_common_000083: '現在、パブリックフォルダ、オンライントレーニング、ロール構成のみをサポート',
    z_info_common_000084: '同じ組織タイプのロールのみを表示',
    z_info_common_000085: 'パブリックフォルダの構成',
    z_info_common_000086: '閉店時刻の形式が間違っています',
    z_info_common_000087: '正常',
    z_info_common_000088: 'ソート構成',
    'z_info_common_000089\t': '送信しました。お待ちください。',
    z_info_common_000090: 'バッチの非アクティブ化',
    z_info_common_000091: '無効を表示',
    z_info_common_000092: '止めてもよいですか？',
    PLEASE_ENTER_ACCOUNT: 'アカウント番号を入力してください',
    ACCOUNT_PASSWORD_CANNOT_EMPTY: 'アカウントパスワードが空欄です！再入力してください',
    InfoAccountCannotEmpty: 'アカウント番号が空欄です！再入力してください',
    InfoPleaseSelectCompany: '会社を選択',
    InfoYourPasswordIsEmpty: 'パスワードを再入力してください',
    InfoLogOut: 'ログアウト',
    ImportOrExport: 'インポート/エクスポート',
    SearchedOut: '検索',
    Results: '結果',
    Operation: 'オペレーション',
    Edit: '編集',
    TurnIntoShop: 'ストアに変換',
    Filter: 'フィルター',
    PleaseEnter: '入力してください',
    DeleteSelectOrganization: '選択した組織を削除しますか？',
    DeletionCancelled: '削除をキャンセル',
    Return: '戻る',
    SelectOrganization: '組織を選択',
    NewOrganization: '新しい組織',
    EditOrganization: '組織を編集',
    NoSelectMsg1: '自分と自分の下の組織を親組織として選択することはできません',
    EditSuccess: '正常に編集されました！',
    InfoStoreStatus: '店舗状況',
    InfoIsDeleteStore: '選択したストアを削除しますか？',
    InfoSelectTimeRange: '時間範囲を選択',
    InfoMustContain: '@マークを含める必要があります',
    InfoServerBusy: 'サーバーがビジー状態',
    InfoDataNoExist: 'データは存在しません',
    InfoNoLoginRights: 'ログイン権限がありません。管理者に連絡してください',
    InfoSubmitFailed: '送信に失敗しました',
    InfoCreationFailed: '作成に失敗しました',
    InfoUpdateFailed: 'アップデートに失敗しました',
    InfoAgainLogin: 'ログインの有効期限が切れています。もう一度ログインしてください',
    InfoInvalidEnterpriseWechatAuthcode: 'Wecom 認証コードが無効です',
    InfoAccountNoExist: '入力したアカウントは存在しません。管理者に連絡してください',
    InfoCompanyDeleted: '会社は削除されました。R+管理者に連絡してください',
    InfoCompanyFrozen: '会社は凍結されています。R+管理者に連絡してください',
    InfoUserDeleted: 'ユーザーが削除されました',
    InfoUserFrozen: 'ユーザーは凍結されています',
    InfoNotSystemAdministrator: 'あなたはシステム管理者ではありません。管理者に連絡してください',
    InfoPasswordError: 'パスワードが間違っています。再入力してください',
    InfoCompanyExpired: '会社の有効期限が切れています',
    InfoNameAlreadyExists: '名前はすでに存在します',
    InfoOrganizationTypeNoExist: '組織タイプが存在しません',
    InfoSuperiorOrganizationNoExist: '親組織は存在しません',
    InfoStoreNoExist: '店舗は存在しません',
    InfoStoreOrganizationNoExist: '店舗組織が存在しません',
    InfoStoreCodeAlreadyExists: '店舗コードはすでに存在します',
    InfoStoreExistingPosition: 'ポジションは店舗に存在します',
    InfoOrganizationExistingPosition: 'ポジションは組織に存在します',
    InfoSubsetsOrganizations: '組織を区分けする',
    InfoOrganizationTypeIsShop: '組織タイプは店舗です',
    InfoOrganizationTypeNotModified: '組織タイプは変更できません',
    InfoWechatSynchronization: 'WeChatによって同期された組織は削除できません',
    InfoUnauthorized: '正しくありません。もう一度ログインしてください',
    InfoAccessDenied: 'アクセスが拒否されました',
    InfoRequestError: 'リクエストエラー、リソースが見つかりませんでした',
    InfoRequestMethodNoAllowed: 'リクエストメソッドは許可されていません',
    InfoRequestTimeout: 'リクエストのタイムアウト',
    InfoServerSideError: 'サーバー側のエラー',
    InfoNetworkNoImplemented: 'ネットワークが実装されていません',
    InfoNetworkError: 'ネットワークエラー',
    InfoServiceNoAvailable: 'サービスは利用できません',
    InfoNetworkTimeout: 'ネットワーク接続を確立できませんでした',
    InfoNoSupportedRequest: 'httpバージョンはリクエストをサポートしていません',
    InfoServerResponseTimeout: 'サーバーの応答がタイムアウトしました。現在のページを更新してください',
    InfoConnectServerFailed: '接続障害',
    z_info_common_000093: '経度を保存',
    z_info_common_000094: '緯度を保存',
    z_info_common_000095: '最終改修日',
    z_info_common_000096: 'メンテナンス可能時間',
    z_info_common_000097: '営業時間',
    z_info_common_000098: '閉店時間',
    z_info_common_000099: 'フロアプランタイトル',
    z_info_common_000100: 'フロアプランファイルの場所',
    z_info_common_000101: '店舗コードの最大文字数は12です;',
    z_info_common_000102: 'ステータス（通常：0、クローズ：1）',
    z_info_common_000103: 'ステータスとして入力0または1のみを許可',
    infoapi_common_000001: '中国',
    infoapi_common_000002: 'アメリカ/カナダ',
    infoapi_common_000003: 'ロシア',
    infoapi_common_000004: 'ペルー',
    infoapi_common_000005: 'ブラジル',
    infoapi_common_000006: 'オーストラリア',
    infoapi_common_000007: 'インドネシア',
    infoapi_common_000008: 'フィリピン',
    infoapi_common_000009: 'ニュージーランド',
    infoapi_common_000010: 'シンガポール',
    infoapi_common_000011: 'タイ',
    infoapi_common_000012: '日本',
    infoapi_common_000013: '韓国',
    infoapi_common_000014: 'ミャンマー',
    infoapi_common_000015: '香港',
    infoapi_common_000016: 'マカオ',
    infoapi_common_000017: '台湾',
    RESETCancelled: 'キャンセルをリセットする',
    BATCH_SET: '一括操作',
    SET_LABEL: 'ラベルを設定する',
    Note_WXSYNCHROHIZATION_LABEL: '注：＊は、Wecomによって同期されたラベルを表します',
    Note_COMMON_LABEL: '注：現在xxxストアが選択されています。このページには、これらのストアの共通タグのみが表示および維持されます',
    NEW_LABEL: 'ラベルを追加',
    IS_RETURN_STORE: '現在の組織をストアに変換してもよろしいですか？',
    TurnIntoOrg: '組織に変換',
    IS_RETURN_ORG: 'ストアを組織に復元してもよろしいですか？',
    SUCCESSFULLY_REDUCTION: '正常に復元されました',
    SUCCESSFULLY_TRANSFORMATION: '正常に変換',
    Is_Enterprise_Micro_Synchronization: 'Wechatから同期',
    Latest_Login_Time: '最終ログイン時間',
    Position_Information: '職種情報',
    No_ADMINISTRATOR: '管理者以外',
    Open: '開いてます',
    Not_Open: '開いてません',
    Lock_In_People: 'スタッフをロックする',
    Unbundling: '解放する',
    Binding: '結合',
    Retail_Manager: 'リテールマネージャー',
    Store_Manager: 'ストアマネージャー',
    Store_Staff: 'ストアスタッフ',
    Non_Retail_System: '非小売システム',
    Vacation: '休暇',
    InfoIsDeletePerson: '選択した人物を削除しますか？',
    CurrentDefaultPosition: '現在のデフォルトの位置',
    SetDefaultPosition: 'デフォルトの位置を設定',
    DefaultPosition: 'デフォルトの位置',
    DefaultPositionChangeTo: 'デフォルトの位置を変更',
    MAIL_NOTIFICATION: 'メール通知',
    UnorganizedConvertedStores: '組織化されていないコンバージョンストア',
    OrganizationSubordinateOrganizations: '下位組織',
    EnterpriseSynchronizationOnly: 'Wecomと同期している組織のみが変換できます',
    AccountAlreadyExists: 'アカウントはすでに存在しています',
    WorkMailboxAlreadyExists: '仕事用メールボックスは既に存在します',
    PersonnelDoesNotExist: '人は存在しません',
    SEND_SMS_NOTIFICATION: 'SMS通知を送信する',
    SEND_MAIL_NOTIFICATION: 'メール通知を送信する',
    RELEVANT_PERSONNEL: '関連要員',
    BIND_ROLE: '役割を割り当てる',
    DELETE_LABEL: 'ラベルを削除する',
    SELECTED_LABEL_HAVE_ROLE_OR_PERSON_ISDELETE: '選択したラベルには役割/人物が割り当てられています。本当に削除しますか？',
    SELECTED_LABEL_HAVE_STORE_ISDELETE: 'このラベルに割り当てられたストアがあります。 削除するかどうか確認してください。',
    PERSON_LABEL: '個人タグ',
    LABEL_NAME_ALREADY_EXISTS: 'タグ名は既に存在します',
    LABEL_DOES_NOT_EXIST: 'タグが存在しません',
    LABEL_MANAGEMENT: 'タグ管理',
    SHOP_COVER: 'カバーを保存',
    UPLOAD_COVER: 'カバーを更新',
    DELETE_COVER: 'カバーを削除',
    PICTURE_CAPTURE: 'スクリーンショット',
    PLEASE_SELECT_CORRECT_PICTURE_FORMAT: '正しい画像形式を選択してください！',
    NOTE_CURRENTLY_SELECTED: '注：現在選択されています',
    SHOP_PAGE_ONLY_SHOW_AND_MAINTAIN_COMMON_TAGS: 'このページには、これらのストアの共通タグのみが表示および維持されます',
    QW_BIND_STATUS: 'Wecomの結束している状況',
    STORE_FLOOR_PLANS: 'フロアプランを保管',
    UPLOAD_FLOOR_PLAN: 'フロアプランを更新',
    FLOOR_PLAN_NAME: 'フロアプラン名',
    LOOK_FLOOR_PLAN: 'フロアプランを確認',
    CLICK_UPLOAD: 'クリックしてアップロード',
    ONLY_UPLOAD_JPG_OR_PNG_FILE: 'jpg / pngファイルのみアップロードできます',
    PLEASE_UPLOAD_A_2000_2000_PIXEL_IMAGE: '2000 * 2000ピクセル以内で画像をアップロードしてください！',
    CHOICE_DATE: '日付を選択してください',
    PLEASE_BEFORE_SELECT_ORGANIZATION: '組織を選択してください',
    NOTE_OLD_ORGANIZATION_NAME: '注：元の組織名',
    RETURN_FOR_ORG: '組織に戻す',
    THE_ORG_NO_ALLOW_TURN_SHOP: '組織はストアへの変換を許可していません',
    ExcelTemplate_common_000001: '組織ID',
    ExcelTemplate_common_000002: '組織名',
    ExcelTemplate_common_000003: '親組織ID',
    ExcelTemplate_common_000004: '親組織名',
    ExcelTemplate_common_000005: '組織タイプ',
    ExcelTemplate_common_000006: 'Wechatから同期',
    ExcelTemplate_common_000007: '注',
    CHECKED: '選択',
    CHECKED_PERSON: '選択したユーザー：',
    CHECKED_STORE: '選択した店舗：',
    DEVICE_MANAGEMENT: 'デバイス管理',
    MECHANICAL_ARM: 'メカニカルアーム',
    Equipment_Number: '端末コード',
    Device_Type: '端末タイプ',
    Device_SN: '端末シリアル',
    Intranet_IP: 'LAN IPアドレス',
    ARM_BRAND: 'ブランド',
    MODEL: 'モデル',
    Installation_POSITION: 'インストール箇所',
    CUSTOMER: '顧客',
    INTERNET_IP: 'WAN IPアドレス',
    STATE: 'ステータス',
    LAST_USE_TIME: '最終使用日',
    OFFLINE: 'オフライン',
    ONLINE: 'オンライン',
    DEVICE_INFO: '端末情報',
    z_info_common_000104: 'ステータス（無効：0,有効：1）',
    TEST_QUESTION: '試験問題',
    DISPLAY_BROCHURE_RELATIONSHIP: 'VMマニュアル',
    ITEM_INVENTORY: '備品',
    KPI_SALES_TARGET: 'KPI販売ターゲット',
    FILE_FORMAT_ERROR_PLEASE_UPLOAD_EXCAL: 'インポートしたフォーマットが間違っています。正しいファイルをアップロードしてください。',
    FILE_ALREADY_UPLOAD_YOU_CAN_VIEW_IMPORT_ASSISTANT: 'ファイルがアップロードされました。インポートアシスタントでデータのインポート結果を表示できます',
    BUSINESS_HOURS_OPENING: '営業時間（開始時間）',
    BUSINESS_HOURS_CLOSE: '営業時間（閉店時間）',
    LABLE_ABOUT_PERSON: '"xxx" 関連店舗',
    LABLE_ABOUT_STORE: '"xxx"関連店舗',
    TYPE_NAME_ALREADY_EXISTS: 'タイプ名は',
    TYPE_IS_BEING_NOT_ALLOWED_DELETE: '削除できません',
    NO_DATA_DELETE: '削除できません',
    SET_DEFAULT: 'デフォルトとして設定',
    worker_common_000015: '企業',
    worker_common_000016: '卸売',
    infoapi_common_000019: '卸売',
    SUPERIOR_NAME: 'サプライヤー名',
    SUPERIOR_ACCOUNT: 'サプライヤーアカウント',
    ORG_TYPE_CANNOT_SET_ENTERPRISE_DEPARTMENT_STORE: '組織タイプを企業、部門、またはストアとして設定することはできません',
    DEPARTMENT: '部署',
    worker_common_000001: '組織タイプを選択してください',
    worker_common_000002: '組織を追加する場合、組織タイプを企業またはストアにすることはできません',
    worker_common_000003: 'サプライヤー組織ID',
    worker_common_000004: 'サプライヤー組織IDエラー',
    worker_common_000006: '組織タイプが存在しません',
    worker_common_000007: 'サプライヤー組織は存在しません',
    worker_common_000010: '組織IDエラー',
    worker_common_000011: '組織は存在しません',
    worker_common_000074: '組織は存在しません。',
    worker_common_000012: '上位組織を下位組織の下に置くことはできません;',
    worker_common_000013: '組織タイプを変更する場合、ストアとして設定された元の組織タイプは更新できません;',
    worker_common_000014: '組織タイプを変更する場合、企業として設定された元の組織タイプは更新できません。',
    worker_common_000017: '正常',
    infoapi_common_000021: '正常',
    worker_common_000018: '閉店',
    infoapi_common_000020: '閉店店舗',
    worker_common_000019: '組織を追加するときは、Wecom同期フィールドをNに設定する必要がありますか？',
    worker_common_000020: '店舗コードを入力してください',
    worker_common_000021: '店舗名を入力してください',
    worker_common_000022: '店舗言語を選択してください',
    worker_common_000023: 'ブランドを選択してください',
    worker_common_000024: '通貨を選択してください',
    worker_common_000025: 'ステータスを選択してください',
    worker_common_000026: '店舗IDフォーマットが正しくありません',
    worker_common_000027: '店舗IDが存在しません',
    worker_common_000028: '店舗カテゴリが存在しません',
    worker_common_000035: '店舗タイプが存在しません',
    worker_common_000029: '上位組織IDが存在しません',
    worker_common_000030: 'ブランド名が存在しません',
    worker_common_000031: '通貨フォーマットが正しくありません',
    worker_common_000032: 'ステータスフォーマットが正しくありません',
    worker_common_000033: '閉店時間フォーマットは正しくありません',
    worker_common_000034: '閉店時間は正しくありません',
    worker_common_000036: '場所が存在しません',
    worker_common_000037: 'ビジネスタイプが存在しません',
    worker_common_000038: '営業時間（開店時間）のフォーマットが正しくありません',
    worker_common_000039: '営業時間（閉店時間）のフォーマットが正しくありません',
    worker_common_000040: '開店時間は閉店時間より早い時間を選択してください',
    worker_common_000041: 'フロアプランのタイトルは空にできません。',
    worker_common_000042: 'フロアプランファイルID形式のエラー。',
    worker_common_000052: 'フロアプランファイルID形式のエラー。',
    worker_common_000043: '店舗コードは既にあります',
    worker_common_000044: '店舗名は既に存在します',
    worker_common_000045: '店舗名が重複しています',
    worker_common_000046: '店舗コードが重複しています',
    worker_common_000047: '店舗コードは12文字以内で入力してください',
    worker_common_000048: '店舗名は200文字以内で入力してください',
    worker_common_000049: '英語の店舗名は200文字以内で入力してください',
    worker_common_000050: '店舗ステータスが間違えています',
    worker_common_000051: 'フロアマップのタイトルは2000文字以内で入力してください',
    worker_common_000053: '店舗住所は300文字以内で入力してください',
    worker_common_000054: '店舗メールアドレスの無効',
    worker_common_000055: '店舗電話番号は200文字以内で入力してください',
    worker_common_000056: '店舗連絡先は200文字以内で入力してください',
    worker_common_000057: '連絡先番号は200文字以内で入力してください',
    worker_common_000058: '名前を入力してください',
    worker_common_000059: 'アカウントを入力してください',
    worker_common_000060: '名前は50文字以内で入力してください',
    worker_common_000061: 'アカウントは50文字以内で入力してください',
    worker_common_000062: '役職を選択してください',
    worker_common_000063: '組織を選択してください',
    worker_common_000064: 'ユーザーステータスを選択してください',
    worker_common_000065: 'ユーザーステータスが存在しません',
    worker_common_000066: 'ユーザータイプが存在しません',
    worker_common_000067: '国が存在しません',
    worker_common_000068: '性別は存在しません;',
    worker_common_000069: '開始日の形式が間違っています;',
    worker_common_000070: '誕生日の形式が間違っています;',
    worker_common_000071: '誕生日の形式が間違っています;',
    worker_common_000072: 'Excelでアカウントが重複しています;',
    worker_common_000073: 'ロールは存在しません;',
    worker_common_000075: 'ユーザーIDフォーマットエラー',
    worker_common_000076: 'アカウントが重複しています',
    worker_common_000077: '有効期限のフォーマットが正しくありません',
    worker_common_000078: '本日以降の有効期限を設定してください',
    worker_common_000079: 'ユーザーデータがありません',
    worker_common_000080: 'メールアドレスが重複しています',
    worker_common_000081: 'この役職は複数ユーザーで設定できません',
    worker_common_000082: '上位ユーザーは存在しません',
    ExcelTemplate_common_000014: '採用日',
    ExcelTemplate_common_000015: '上位ユーザー名',
    ExcelTemplate_common_000016: '上位ユーザーアカウント',
    ExcelTemplate_common_000022: '国/地域',
    infoapi_common_000018: '企業',
    infoapi_common_000025: '小売管理',
    infoapi_common_000026: '店舗管理',
    worker_common_000083: {
      other: '店舗IDが重複しています'
    },
    EXPORT_PEOPLE: 'ユーザーのエクスポート',
    EXPORT_STAFF: 'ユーザー権限のエクスポート',
    worker_common_000085: '同じ店舗名が組織内に存在します',
    worker_common_000086: 'フロアプランファイルのIDデータが正しくありません',
    ExcelTemplate_common_000023: 'WeChat ID',
    worker_common_000088: '組織IDを入力してください',
    worker_common_000089: '役職名を入力してください',
    worker_common_000091: '組織IDの形式が正しくありません',
    worker_common_000094: 'Excelで位置が重複しています',
    ABOUT_PERSON: '関係者',
    ABOUT_STORE: '関連店舗',
    DOWNLOAD_POSITION_TEMPLATE: '承認テンプレートのダウンロード',
    IMPORT_PERSONNEL_POSITION: 'ユーザー認証のインポート',
    ALLOW: '許可',
    NOT_ALLOW: '却下',
    NOT_EDIT_TYPE: 'タイプは変更できません',
    NOT_DELETE_TYPE: 'タイプは削除できません',
    CURRENT_USER_TYPE_NOT_EDIT: 'ユーザータイプは変更できません',
    ROLE_DATA_NOT_DELETE: '操作に失敗しました。選択したロールがデータが含まれていて、削除できません',
    LEAEVE_NOT_OVER: '上位組織のレベルは、レベル７以上でないと表示できません',
    ROLE_POSITION_IS_USE_NOT_DELETE: '操作に失敗しました。選択したロールは使用済みデータが含まれていました',
    worker_common_000098: '無効なロールID',
    worker_common_000101: 'ロール名は50文字を超えることはできません',
    worker_common_000102: 'Excelで同じロールの名前が重複しています',
    worker_common_000103: 'ユーザータイプを空白にすることはできません',
    worker_common_000104: '複数のユーザーに無効なデータを許可するかどうか',
    worker_common_000105: '備考に入力した長さがが300文字を超えています',
    worker_common_000084: '通貨は有効化されていません；',
    currency_common_000001: '{User name}の長さは{50}文字を超えることはできません。',
    currency_common_000002: '{user name}の長さは{5}文字以上にする必要があります;',
    currency_common_000003: '無効な {ユーザーID};',
    currency_common_000004: '{ユーザー名} を選択してください',
    currency_common_000005: '{User ID}フォーマットエラー;',
    currency_common_000006: '{User ID}は既に存在します;',
    currency_common_000007: '{User name}を繰り返し、使用することはできません。',
    currency_common_000008: '{User} は存在しません;',
    UPDATE_ROLE_AUTHORITY_TITLE: 'ロール"{xx}"の認証設定',
    ALL_AUTHORITY: '全ての認証',
    worker_common_000106: 'インポートおよび更新する場合、ロールと組織を変更することはできません。 ユーザーのロールを変更するには、ユーザーのロールをインポートする機能を使用してください。',
    infoapi_common_000032: 'プランA',
    infoapi_common_000033: 'プランB',
    infoapi_common_000034: 'プランC',
    infoapi_common_000035: 'タスクを作成',
    infoapi_common_000036: '申請書を提出',
    OPEN_STORE_DESC: '開店後、ストアリストは誰でも使用できます',
    OPEN_ADDRESS_BOOK_DESC: 'アドレス帳を開くと、ユーザーのリストがすべての人に公開されます',
    ALLOW_EXPORT_OF_CONTACTS_DESC: '開いた後、アドレス帳の情報を携帯電話のアドレス帳にエクスポートできます',
    CHANGE_PASSWORD_AT_FIRST_LOGIN_DESC: '選択後、初めてログインするユーザーはパスワードを変更する必要があります',
    TURN_ON_THE_WATERMARK_ON_THE_SCREEN_OF_THE_MOBILE_PHONE_DESC: '選択すると、アドレス帳が透かしてみえます。',
    DEFAULT_PASSWORD_CONFIGURATION: 'デフォルトのパスワード設定',
    RANDOM_PASSWORD1: 'ランダムパスワード',
    MODULE_COLOR: 'モジュールカラー',
    ONLY_RPLUS_QYWX: 'R+ Work Wechatバージョンのみをサポート',
    SYSTEM_DISTRIBUTION: 'システムカラー',
    CUSTOM_COLOR_MATCHING: 'カスタムカラー',
    RESTORE_DEFAULT_COLOR: 'デフォルトカラーに戻す',
    CLOPY_COLOR: 'カラーをコピー',
    ADHESIVE_COLOR: 'カラーを張り付け',
    SUCCESS_COLOR: '正常にコピーされました',
    z_info_common_000109: 'チェックリストの時間を削除することを許可',
    z_info_common_000110: '日数',
    z_info_common_000111: 'レポートの削除を許可',
    z_info_common_000112: 'レポートの削除が許可される期間は1〜999日です',
    INFO_TIPS_PERSON: 'アカウントはすでに存在します',
    ACCOUNT_HAVE_DELETE_INFO: 'このアカウントは削除されました。必要に応じて復元してください',
    BRAND_NO_DELETE_INFO: 'このブランドは既に店舗で使用されており、削除することはできません',
    SHOP_TEMPLETE_CONFIG: 'チェックリストテンプレート設定',
    SHOP_TEMPLETE_CONFIG_DESC: '選択後に、ユーザーはチェックリストレポートをプレビューできます',
    BASIC_FIELD_CONFIG: 'BASIC_FIELD_CONFIG',
    CUSTOM_FIELD_CONFIG: 'CUSTOM_FIELD_CONFIG',
    THE_ORG_NO_ALLOW_TURN_SHOP1: '組織には下位組織があり、店舗への変換は許可されていません',
    NO_EDIT_TIPS: 'Wecom同期の役割を変更することはできません',
    WEEK_SET: '週の設定（週の最初の日）',
    MECHANISM_CONTAINS_THE_WEEK_OF_JANUARY_1: '1月1日を含む週',
    MECHANISM_WEEK_CONTAINING_1_FIRST_THURSDAY: '第1木曜日を含む週',
    UPLOAD_LIMIT_WORD: 'Word形式のみがサポートされており、ファイルサイズは10Mを超えることはできません',
    ENLARGE: 'ズームイン(拡大)',
    NARROW: 'ズームアウト(縮小)',
    TURN_LEFT: '左に回転',
    TURN_RIGHT: '右に回転',
    AGREEMENT_HAVE: 'プロトコルはすでに存在します',
    WEEK_SET_1: '週の設定',
    COST_RECORD: 'コスト記録',
    PROJECT_MAINTENANCE: 'メンテナンスプロジェクト',
    PROBLEM_DESCRIPTION_REQUIRED: '問題の説明は必須',
    ACCEPTANCE_SCORING_REQUIRED: '合格の等級は必須',
    VISIBLE_ROLE: 'visible roles',
    VISIBLE_REGIO: 'visible organizations',
    NO_LIMIT: 'no restrictions',
    SELECT_ORG: '組織の選択',
    ENABLE_CLASSIFICATION_PERMISSIONS: 'Enable category permissions',
    AUTO_SUCCESS: '自動完了',
    PROP_APPLY_MIN_IMG_CONFIG: '備品発注アプリの最小画像構成',
    ACCEPTANCE_MIN_IMG_CONFIG: '最小画像受入れ構成',
    ALLOW_REISSUE: '補充を許可',
    REPAIR_MAIL_CONFIG: 'メンテナンスメールの構成',
    USER_STATUS_QUIT: '退職',
    ORGANIZATION_PATH: '組織のパス',
    USER_HAS_RESIGNED: 'ユーザーが退職しました',
    UPDATE_ORGANIZATION_PARENT_WARNING: '親組織を変更すると、Wecomと同期しなくなります',
    SMART_SCREEN: 'スマートスクリーン',
    SMART_SCREEN_ID: 'スマートスクリーンID',
    SMART_SCREEN_LOCATION: '店舗',
    SMART_SCREEN_STATUS: 'デバイスのステータス',
    SMART_SCREEN_REGISTERATION_DATE: '登録時間',
    r_info_common_000001: '備品のバッチ受入れ',
    d_info_common_000001: '備品の一括適用',
    r_info_common_000002: 'メンテナンスプロジェクトを提出',
    r_info_common_000003: '備品分析レポートへのアクセス',
    d_info_common_000003: '備品分析レポートにアクセス',
    r_info_common_000004: 'メンテナンス分析レポートへのアクセス',
    d_info_common_000004: 'メンテナンス分析レポートにアクセス',
    r_info_common_000005: '欠陥修理アプリケーションを確認',
    d_info_common_000005: '欠陥修理アプリケーションを確認',
    r_info_common_000006: '欠陥修理申請書を提出',
    d_info_common_000006: '欠陥修理申請書を提出',
    r_info_common_000007: '欠陥修理アプリケーションを検索',
    d_info_common_000007: '欠陥修理アプリケーションを検索',
    r_info_common_000008: '欠陥修理を使用',
    d_info_common_000008: '欠陥修理を使用',
    r_info_common_000009: 'チェックリスト計画を管理',
    r_info_common_000010: '売上レポートを見る',
    d_info_common_000010: '売上レポートを表示',
    r_info_common_000011: '売上レポートを使用',
    d_info_common_000011: '売上レポートを使用',
    r_info_common_000012: '軌跡を開く',
    d_info_common_000012: 'ユーザー履歴を開く',
    r_info_common_000013: '他のフォローアップメンテナンスを見る',
    d_info_common_000013: '他の継続中のメンテナンスを表示',
    r_info_common_000014: 'カスタマーサービス本部_NanTong',
    d_info_common_000014: 'カスタマーサービス本部_NanTong',
    r_info_common_000015: 'カスタマーサービス本部_Ru Dong',
    d_info_common_000015: 'カスタマーサービス本部_Ru Dong',
    r_info_common_000016: 'メンテナンスエンジニアを管理',
    d_info_common_000016: 'メンテナンスエンジニアを管理',
    r_info_common_000017: '製品メンテナンス申請書を提出',
    d_info_common_000017: '製品メンテナンス申請を提出',
    r_info_common_000018: '製品のメンテナンスを管理',
    d_info_common_000018: '製品のメンテナンスを管理',
    r_info_common_000019: 'ユーザーの軌跡を確認',
    d_info_common_000019: 'ユーザー履歴を確認',
    r_info_common_000020: '他のオープンストアプロジェクトを見る',
    d_info_common_000020: '他のオープンストアプロジェクトを表示',
    r_info_common_000021: 'オープンストアプロジェクトを追加',
    d_info_common_000021: 'オープンストアプロジェクトを追加',
    r_info_common_000023: 'データレポートを表示',
    d_info_common_000023: 'データレポートを表示',
    r_info_common_000024: 'レポートセンターへアクセス',
    d_info_common_000024: 'レポートセンターへアクセス',
    r_info_common_000025: '販売目標の管理',
    d_info_common_000025: '販売目標を管理',
    r_info_common_000026: 'ストアプロファイルを編集',
    r_info_common_000027: 'ストアプロファイルを編集',
    d_info_common_000027: 'ストアプロファイルを編集',
    r_info_common_000028: 'VMプロジェクトを管理',
    r_info_common_000029: 'タスクプランを承認',
    r_info_common_000030: 'タスクプランを表示',
    d_info_common_000030: 'タスクプランを表示',
    r_info_common_000031: '備品申請書を無制限に提出',
    r_info_common_000032: '備品の注文を管理',
    r_info_common_000033: '備品の注文を表示',
    d_info_common_000033: '備品の注文を表示',
    r_info_common_000034: '備品の在庫を更新',
    d_info_common_000034: '備品の在庫を更新',
    r_info_common_000035: '備品の在庫を表示',
    d_info_common_000035: '備品の在庫を表示',
    r_info_common_000036: '備品のプロファイルを管理',
    r_info_common_000037: '備品申請をクローズ',
    d_info_common_000037: '備品申請をクローズ',
    r_info_common_000038: '備品の注文を割り当てる',
    r_info_common_000039: '全ての備品を表示',
    r_info_common_000040: '備品の受領',
    d_info_common_000040: '備品の受領',
    r_info_common_000041: '備品申請を提出',
    d_info_common_000041: '備品申請書を提出',
    r_info_common_000042: '備品申請にアクセス',
    d_info_common_000042: '備品アプリケーションにアクセス',
    r_info_common_000043: 'メンテナンス申請を無制限に提出',
    r_info_common_000044: 'メンテナンスの注文を管理',
    r_info_common_000045: 'メンテナンスの注文を表示',
    d_info_common_000045: 'メンテナンスオーダーを表示',
    r_info_common_000046: 'メンテナンス申請をクローズ',
    d_info_common_000046: 'メンテナンスアプリケーションをクローズ',
    r_info_common_000047: 'メンテナンスの注文を割り当てる',
    r_info_common_000048: 'メンテナンスの受け入れ',
    d_info_common_000048: 'メンテナンスの受け入れ',
    r_info_common_000049: 'メンテナンス申請を提出',
    d_info_common_000049: 'メンテナンス申請書を提出',
    r_info_common_000050: 'ストアメンテナンスにアクセス',
    r_info_common_000051: 'メールボックスはチェックリストレポートを自動的に受信します',
    r_info_common_000052: 'パフォーマンス評価を使用',
    r_info_common_000053: 'ユーザーを削除',
    r_info_common_000054: 'ユーザープロファイルを編集',
    r_info_common_000055: '参加する',
    m_info_common_000016: 'サインイン',
    d_info_common_000055: '参加する',
    r_info_common_000056: 'VMマニュアルを管理',
    r_info_common_000057: 'VMの写真を表示',
    d_info_common_000057: 'VMの写真を表示',
    r_info_common_000058: 'VMの写真を提出',
    d_info_common_000058: 'VMの写真を提出',
    r_info_common_000059: 'VMの写真に返信',
    d_info_common_000059: 'VMの写真に返信',
    r_info_common_000060: 'KPIグラフにアクセス',
    r_info_common_000061: 'KPIグラフにアクセス',
    d_info_common_000061: 'KPIグラフにアクセス',
    r_info_common_000062: 'デイリーログを使用',
    r_info_common_000063: 'ライブビデオ',
    m_info_common_000017: 'ライブビデオ',
    r_info_common_000064: 'トラフィックデータを入力',
    d_info_common_000064: 'トラフィックデータを入力',
    r_info_common_000065: 'タスクプロジェクトを管理',
    r_info_common_000066: 'チェックリストレポートを提出',
    r_info_common_000067: 'Eラーニングを使用',
    d_info_common_000067: 'Eラーニングを使用',
    r_info_common_000068: '権限範囲内の全てのドキュメントを表示',
    r_info_common_000069: '販売データを入力',
    d_info_common_000069: '販売データを入力',
    r_info_common_000070: 'レビューをしていない他のチェックリストレポートを表示',
    r_info_common_000071: '共有フォルダを管理',
    r_info_common_000072: 'チェックリストのダッシュボードにアクセス',
    d_info_common_000072: 'チェックリストのダッシュボードにアクセス',
    r_info_common_000073: 'モバイルラーニングを使用',
    d_info_common_000073: 'モバイルラーニングを使用',
    r_info_common_000074: '他のタスクグループを表示',
    r_info_common_000075: '新しい顧客を追加',
    d_info_common_000075: '新しい顧客を追加',
    r_info_common_000076: 'モバイルラーニングを管理',
    d_info_common_000076: 'モバイルラーニングを管理する',
    r_info_common_000077: 'アプリのホームページで掲示板を管理',
    d_info_common_000077: 'アプリのホームページで掲示板を管理',
    r_info_common_000078: 'ストア情報の非表示フィールドを表示',
    d_info_common_000078: 'ストア情報の非表示フィールドを表示',
    r_info_common_000079: 'タスクグループ計画を管理',
    r_info_common_000080: '新しいユーザーを追加',
    r_info_common_000081: 'Advantech LoT',
    d_info_common_000081: 'Advantech IoT',
    r_info_common_000082: 'タスクグループを管理',
    r_info_common_000083: '会社の進捗状況を設定',
    r_info_common_000084: 'チェックリストテンプレートを管理',
    r_info_common_000085: 'カスタムフォームを管理',
    d_info_common_000085: 'カスタムフォームを管理',
    r_info_common_000086: '他の顧客プロファイルを表示',
    r_info_common_000087: 'タスクグループを表示',
    r_info_common_000088: 'チェックリストプランを表示',
    d_info_common_000088: 'チェックリストプランを表示',
    r_info_common_000089: 'ストアのカレンダーを表示',
    d_info_common_000089: 'ストアのカレンダーを表示',
    r_info_common_000090: 'カスタマイズされたデイリーログを追加',
    d_info_common_000090: 'カスタマイズされたデイリーログを追加',
    m_info_common_000001: 'カスタムフォーマット',
    m_info_common_000004: 'アイテム管理',
    m_info_common_000005: 'タスク計画',
    m_info_common_000010: 'プロジェクトを引き継ぐ',
    m_info_common_000011: 'VMアドバンストモジュール',
    m_info_common_000012: 'データテンプレート',
    m_info_common_000013: 'E-Leaning',
    m_info_common_000014: 'e-ワーキング',
    m_info_common_000019: '店舗検査',
    m_info_common_000021: '日次在庫',
    m_info_common_000022: 'VOIPダイヤル',
    m_info_common_000024: 'パークモール',
    m_info_common_000025: 'フォローアップ',
    m_info_common_000027: 'タスクグループ',
    m_info_common_000028: '製品修理',
    m_info_common_000031: '電話会議',
    m_info_common_000032: 'モバイルラーニング',
    m_info_common_000033: 'リテールコンサルティング',
    m_info_common_000034: 'KPIチャート',
    m_info_common_000037: 'eショップ',
    m_info_common_000039: 'Advantech LoT',
    m_info_common_000040: 'Basic',
    d_info_common_000002: 'Webの「一括適用」でメンテナンスプロジェクトを実行し、複数の店舗に申請書を提出',
    d_info_common_000009: 'チェックリストプランを開始、編集、終了',
    d_info_common_000026: '他の（組織内の）VMプロジェクトを表示',
    d_info_common_000028: 'VMプロジェクトを追加し、写真の要件をリリースして、アップロードされた写真を承認',
    d_info_common_000029: 'タスクプラン内のタスクを承認',
    d_info_common_000031: '1日に1件のリクエスト注文を送信するという制限はなし。配送後7日以内に受領する必要がある。',
    d_info_common_000032: 'メンテナンスオーダーの管理、納品の確認、オーダーのクローズ',
    d_info_common_000036: '備品を追加、編集、削除',
    d_info_common_000038: '備品の申請を確認し、承認後の再配達のリクエストを含め、ベンダーに注文を割り当てる',
    d_info_common_000039: '会社全体の備品の全ての情報をWebで表示',
    d_info_common_000043: '1日で1件のリクエストを送信するという制限はありません。割り当て後7日以内に受け入れる必要があります。',
    d_info_common_000044: 'メンテナンス注文を管理し、ソリューション、価格、レポートを確認し、注文をクローズする',
    d_info_common_000047: 'メンテナンスアプリケーションを確認し、承認後の再割り当てを含め、ベンダーに注文を割り当てる',
    d_info_common_000050: 'ストアメンテナンスにアクセス',
    d_info_common_000051: 'メールボックスは、ユーザーがレポート受信者のリストに含まれると同時にチェックリストレポートを受信する',
    d_info_common_000052: '業績評価の全ての機能を使用',
    d_info_common_000053: '同じレベル以下のユーザーを削除',
    d_info_common_000054: '同じレベルまたはそれ以下のレベルのユーザープロファイルを編集',
    d_info_common_000056: 'VMマニュアルをアップロード、削除、アクセス許可を設定',
    d_info_common_000060: '自由に送信したストアのVMのステータスを変更',
    d_info_common_000062: 'デイリーログを表示して返信し、新しいメッセージを残す',
    d_info_common_000063: 'カメラをリモートで表示',
    d_info_common_000065: 'タスクプランをリリース、編集、クローズ',
    d_info_common_000066: 'チェックリストを使用してチェックリストレポートを送信',
    d_info_common_000068: '"Me"の中の全てのドキュメントを表示→”My Report"（チェックリストレポート、チェックリスト問題レポート、パフォーマンス評価レポートを含む）',
    d_info_common_000070: 'まだレビューしていないチェックリストレポート（組織内）を表示しますか？他の人がレビューするのを待ちますか？',
    d_info_common_000071: 'パブリックファイルをアップロード、編集、削除、アクセス許可を設定',
    d_info_common_000074: '他の（組織内の）タスクグループを表示',
    d_info_common_000079: 'タスクグループプランの追加、編集、削除',
    d_info_common_000080: '同じレベルまたはそれ以下のレベルで新しいユーザーを追加',
    d_info_common_000082: 'タスクグループを追加し、表示されたタスクグループを編集してクローズができる',
    d_info_common_000083: 'メンテナンスの進捗状況、備品の適用の進捗状況など、会社の進捗状況を設定する',
    d_info_common_000084: 'Web上でチェックリストテンプレートを作成および設定する',
    d_info_common_000086: '他の（組織内の）顧客プロファイルを表示する',
    d_info_common_000087: 'タスクグループモジュールを表示するかどうか',
    z_info_common_000113: '新しいテンプレートに変換してもよいですか？',
    SELECTED_ORGANIZATION_TO_STORE: '選択した組織を店舗に変変更したいですか？',
    SELECTED_ORGANIZATION_TO_STORE_FAIL: '変更失敗',
    SELECTED_ORGANIZATION_TO_STORE_SUCCESS: '変更成功',
    ORGANIZATION_TO_STORE: '店舗に変更',
    SELECTED_ORGANIZATION_TO_STORE_INFO: '{0} {2} 成功、 {1} 不可',
    mntapi_common_000212: 'リクエスト情報',
    mntapi_common_000213: '問題点情報',
    CURRENT_POSITION: '表示箇所',
    ExcelTemplate_common_000024: '表示箇所',
    COSTUMER_CODE: '顧客コード',
    COSTUMER_NAME: '顧客名',
    UPDATED_BY: 'アップデート',
    COSTUMER_RELATION: '顧客管理',
    COSTUMER_RELATION_INFO: '顧客情報',
    Rebinding: '再同期',
    Rebinding_MSG1: '親組織情報がR+とWechatに同期されます。よろしいですか？',
    SELECTED_OPERATION_FAIL: '失敗{0} ',
    SELECTED_OPERATION_SUCCESS: '完了{0} ',
    Rebinding_MSG2: ' {0} の為、Wechatに再同期されますが、完全に再同期されません。',
    SHOW_QY_USERNAME: 'Wechatでの表示名',
    QY_USERNAME: 'Wechatの表示名',
    SHOW_QY_DEPARTMENTNAME: 'Wechatの部署名',
    QY_DEPARTMENTNAME: 'Wechat上の部署',
    QY_CANNOT_GET: '利用不可',
    RETURN_ORG_MSG: '店舗情報が削除されます。よろしいですか？',
    AREA_SETTING: '場所の設定',
    CLOSE_STORE_AND_RECOVER: '店舗のクローズ/再オープン',
    AREA_INFO: '場所の情報',
    SELECT_AREA: '場所の選択',
    AREA_NAME_EXISTS: '地域名は既に存在します',
    COSTUMER_NAME_EXISTS: '顧客は既に存在します',
    COSTUMER_CODE_EXISTS: '顧客コードは既に存在します',
    AREA_CODE_EXISTS: '場所コードは既に存在します',
    FIELD_MANAGEMENT: 'フィールド管理',
    STORE_FIELD_MANAGEMENT: '店舗フィールド管理',
    SAVE_FIELD: '保存できませんでした',
    ADD_FIELD: '追加できませんでした',
    ADD_CATEGORYS: 'カテゴリの追加',
    SYSTEM_FIELD: 'システム失敗',
    LAST_MODI_TIME: '最終編集日',
    FIELD_TYPE: 'フィールドタイプ',
    REQUIRED2: '必須項目',
    PUBLIC: '公共',
    AS_FILTER_KEY: '使用フィルター',
    STACK_SHELVES: 'リリース',
    WITHDRAW_SHELVES: '撤回',
    MNT_CATEGORY: 'メンテナンスカテゴリ',
    IS_STACK: 'リリースの撤回',
    SHOW_HAS_BEEN_WITHDRAWED_CATEGORY: '取り下げられたカテゴリを表示',
    MNT_CATEGORY_INFO: 'メンテナンスカテゴリ情報',
    IS_DELETE_CATEGORY: '選択したカテゴリを削除しますか？',
    PLZ_USE_WITHDRAW: 'カテゴリは使用されているため、削除できません。',
    SELECT_CATEGORY: 'カテゴリの選択',
    VERSION_EXCEPTION: '例外のバージョン',
    UN_INPUT_OPTION_EXIST: '必須項目が埋まっていません',
    FIELD_NOT_ALLOWED_REPEAT: 'フィールドを繰り返しできません',
    DEFAULT_LANG_CATEGORY_NAME_REQUIRED: '会社のデフォルト言語は必須です',
    UNDER_SAME_PARENT_CATEGORY_NAME_NOT_ALLOWED_REPEAT: 'メンテナンスカテゴリ以下で、同じメンテナンス名を登録できません。',
    UNDER_SAME_PARENT_CATEGORY_NO_NOT_ALLOWED_REPEAT: 'メンテナンスカテゴリ以下で、同じシリアル番号を登録できません。',
    ID_CAN_NOT_EMPTY_WHEN_UPDATE: 'アプロード時は、データIDを入力してください。',
    PARENT_IS_WITHDRAWED: 'メンテナンスは撤回として分類されます。',
    UNDER_SAME_PARENT_PROP_ENG_NAME_NOT_ALLOWED_REPEAT: 'アイテムカテゴリ以下で同じ英語のカテゴリ名は登録できません。',
    UNDER_SAME_PARENT_PROP_NAME_NOT_ALLOWED_REPEAT: '同じカテゴリ名を登録することはできません。',
    IS_WITHDRAW_CATEGORY: '選択したカテゴリを削除しますか？',
    WITHDRAW_SUCCESSFUL: '撤回成功',
    STACK_SUCCESSFUL: 'リリース成功',
    PROP_CATEGORY_INFO: '備品カテゴリ情報',
    DELETE_IMG: '写真の削除',
    ExcelTemplate_common_000025: 'デフォルト役職',
    ExcelTemplate_common_000026: 'デフォルト組織ID',
    MNT_QUESTION_CATEGORY: 'メンテナンス問題カテゴリ',
    MNT_QUESTION: 'メンテナンス問題',
    ExcelTemplate_common_000027: '複数タグを分けるために、 "|"を使用してください。',
    ExcelTemplate_common_000028: '*は必須項目です。インポート時は、入力してください。',
    ExcelTemplate_common_000029: '新規ユーザーのIDは入力する必要ありません。',
    ExcelTemplate_common_000030: 'インポート時、デフォルト組織ID、組織パス、役職フィールドは反映されません。次のページで詳細を確認してください。記入されていないフィールドは登録済みのユーザー情報に影響されません。',
    ExcelTemplate_common_000031: '他フィールドは必須項目ではありません。記入されていない項目は、クリアされます。',
    ExcelTemplate_common_000032: 'デフォルト組織パス',
    MNT_QUESTION_CATEGORY_NAME: 'メンテナンス問題カテゴリ名',
    MNT_QUESTION_CATEGORY_INFO: 'メンテナンス問題カテゴリ情報',
    MNT_QUESTION_INFO: 'メンテナンス問題情報',
    MNT_QUESTION_NAME: 'メンテナンス問題名',
    ExcelTemplate_common_000041: 'メンテナンス問題名',
    r_info_common_000091: '価格表示の許可',
    ExcelTemplate_common_000033: 'メンテナンス問題ID',
    d_info_common_000091: '価格表示の許可',
    ExcelTemplate_common_000034: '必須',
    ExcelTemplate_common_000035: '1.　エクセルシートのフィールドを、追加や削除、修正をしないでください。',
    ExcelTemplate_common_000036: '2.　*マークが付いている項目は、必須項目です。必ず埋めてください。',
    ExcelTemplate_common_000037: '3.　新規問題点をインポートする際、メンテナンス問題IDは必要ではありません。アップロードする際には、エクスポートした問題IDと同じものを記載してください。',
    ExcelTemplate_common_000038: '4.　メンテナンス問題名は多言語が含まれます。{{}}iは必須項目です。他言語は必要に応じて入力してください。',
    ExcelTemplate_common_000039: '5.　他のフィールドは必須項目ではありません。記入されていない項目は、クリアされます。',
    ExcelTemplate_common_000040: '6.　問題カテゴリ、デフォルト優先度は、{{}} の名前に基づいてインポートされます。',
    ExcelTemplate_common_000042: '3.　新規問題点をインポートする際、メンテナンス問題IDは必要ではありません。アップロードする際には、エクスポートした問題IDと同じものを記載してください。',
    ExcelTemplate_common_000043: '4.　メンテナンス問題カテゴリは多言語が含まれます。{{}}iは必須項目です。他言語は必要に応じて入力してください。',
    ExcelTemplate_common_000044: '5.　フィールドが記入されていない項目は、クリアされます。',
    EXPORT_MNT_QUESTION: '問題点をエクスポート',
    EXPORT_MNT_QUESTION_CATEGORY: '問題カテゴリをエクスポート',
    IS_DELETE_QUESTION: '選択した問題点を削除しますか？',
    DATA_HAS_BEEN_USED: 'データは使用されているため、削除できません',
    CAN_NOT_REPEAT: '繰り返し不可',
    SAME_MNT_QUESTION_CATEGORY_QUESTION_NAME_CAN_NOT_REPEAT: 'メンテナンス問題カテゴリ以下で、同じ問題名を登録することはできません。',
    DOWNLOAD_MNT_QUESTION_TEMPLATE: 'メンテナンス問題テンプレートのダウンロード',
    MNT_QUESTION_TEMPLATE: 'メンテナンス問題テンプレート',
    DOWNLOAD_MNT_QUESTION_CATEGORY_TEMPLATE: '問題カテゴリテンプレートのダウンロード',
    MNT_QUESTION_CATEGORY_TEMPLATE: 'Multilingual templates of category',
    worker_common_000114: '問題カテゴリは必須です',
    worker_common_000115: '無効な優先度',
    worker_common_000116: 'デフォルト言語は設定してください',
    worker_common_000117: '無効なID',
    worker_common_000118: '同じカテゴリ以下で、同じ問題名を入力できません',
    worker_common_000119: 'Category name repeated',
    POFIELD_SAVE_FIELDCLASS_MSG: 'A category named {0} already exists',
    POFIELD_SAVE_FIELD_MSG: 'An issue named {0} already exists in the same category',
    EXPORT_STORE: 'Export stores',
    DOWNLOAD_EXCEL_QYTEMPLATE: '企微预绑定模板下载',
    QY_PRE_BINDING: '企微预绑定',
    QYUSER: '企微人员',
    STORE_LONG_FORM: '店铺长表单',
    QYWX_CONFIG: '仅对企微所在部门为店铺的用户添加"成员"相关职位',
    STORE_INFO_AREASQUARE: '面积',
    STORE_INFO_OPENDATE: '开店时间',
    STORE_INFO_CLOSEDATE: '闭店时间',
    STORE_INFO_DECORATIONDATE: '最近装修时间',
    BINDING_QY_DEPARTMENT: '绑定企微部门',
    BINDING_QY_DEPARTMENT_DOWNLOAD: '下载绑定企微部门模板'
  },
  ...jaLocale
}
